webpackJsonp([1],{

/***/ "+2xm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-map-overlay',{attrs:{"overlayId":"wgu-hover-tooltip","visible":false,"autoPan":"","autoPanDuration":250,"positioning":"top-center","offset":[0, 20]},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var feature = ref.feature;
var hoverAttribute = ref.hoverAttribute;
return (feature)?_c('v-sheet',{staticClass:"pa-2 text-center",attrs:{"max-width":"200"}},[_vm._v("\n    "+_vm._s(feature.get(hoverAttribute))+"\n  ")]):_vm._e()}}],null,true)})}
var staticRenderFns = []


/***/ }),

/***/ "+yZ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wgu-overviewmap-wrapper"}},[_c('v-menu',{attrs:{"offset-x":"","nudge-right":"15","transition":"scale-transition","close-on-content-click":false,"close-on-click":false,"z-index":"2","attach":"#wgu-overviewmap-wrapper"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-sheet',{staticClass:"wgu-map-button wgu-overviewmap"},[_c('v-btn',_vm._g({attrs:{"color":"secondary","fab":"","title":_vm.$t('wgu-overviewmap.title')}},on),[_c('v-icon',{attrs:{"color":"onsecondary","medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1)]}}]),model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._v(" "),(_vm.open)?_c('wgu-overviewmap-panel',{attrs:{"rotateWithView":_vm.rotateWithView,"width":_vm.width,"height":_vm.height}}):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "/AG+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IdsCorpusCategory_vue__ = __webpack_require__("k3Re");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ids-corpora-filter',
  components: {
    'ids-corpus-category': __WEBPACK_IMPORTED_MODULE_1__IdsCorpusCategory_vue__["a" /* default */]
  },
  props: {
    corpusListApi: {
      type: Array,
      required: true
    },
    corpusSelection: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      dataCorpusSelection: this.corpusSelection
    };
  },
  computed: {
    /** Get the corpora aggregated by their categories */
    corpusByCategory: function corpusByCategory() {
      var aggregate = {};
      this.corpusListApi.forEach(function (korp) {
        if (!aggregate[korp.v_corpus_cat]) {
          aggregate[korp.v_corpus_cat] = [];
        }

        aggregate[korp.v_corpus_cat].push(korp);
      });
      return aggregate;
    }
  },
  methods: {
    /**
     * Handles change of corpus checkboxes.
     * Updates the state (corpusSelection) mapping category to selection array.
     */
    onCorpusSelectionChange: function onCorpusSelectionChange(corpusCategory, newCorpusSelection) {
      this.dataCorpusSelection[corpusCategory] = newCorpusSelection;
      this.$emit('ids-corpus-selection-change', this.dataCorpusSelection);
    }
  }
});

/***/ }),

/***/ "/UKJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',{attrs:{"icon":"","color":"onprimary","title":_vm.$t('wgu-geolocator.title')},on:{"click":_vm.geolocateUserAndShowMarkerOnMap}},[(this.isSearchingForGeolocation)?_c('v-icon',[_vm._v("update")]):(this.isGeolocationAPIAvailable && (!this.isGeolocationFound))?_c('v-icon',[_vm._v("location_searching")]):(this.isGeolocationAPIAvailable && this.isGeolocationFound)?_c('v-icon',[_vm._v("gps_fixed")]):_c('v-icon',[_vm._v("location_disabled")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "00qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"ids-detail-filter",attrs:{"moduleName":"ids-detail-filter-module","icon":_vm.icon}},'wgu-module-card',_vm.$attrs,false),[_c('v-container',{attrs:{"fluid":""}},[_c('v-card-subtitle',{staticClass:"pl-0 pt-0 pb-1"},[_vm._v(_vm._s(_vm.$t('ids-detail-filter-module.description')))]),_vm._v(" "),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"5"}},[_c('v-text-field',{staticClass:"mt-0 pt-0 ids-year-input",attrs:{"value":_vm.filterInterval[0],"hide-details":"","single-line":"","type":"number","full-width":"","rules":[
            function (ly) { return !!ly && ly >= _vm.minYear && ly <= _vm.maxYear; }
          ]},on:{"input":_vm.onLowerInputText}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"5"}},[_c('v-text-field',{staticClass:"mt-0 pt-0 ml-1 ids-year-input",attrs:{"value":_vm.filterInterval[1],"hide-details":"","single-line":"","type":"number","full-width":"","rules":[
            function (uy) { return !!uy && uy >= _vm.minYear && uy <= _vm.maxYear; }
          ]},on:{"input":_vm.onUpperInputText}})],1),_vm._v(" "),_c('v-col',{staticClass:"d-flex justify-center align-center",attrs:{"cols":"2"}},[_c('v-btn',{attrs:{"small":"","elevation":"0","title":"Zeitraum zurücksetzen"},on:{"click":_vm.resetFilterInterval}},[_c('v-icon',[_vm._v("mdi-reload")])],1)],1)],1)],1),_vm._v(" "),_c('v-range-slider',{staticClass:"mr-2 ml-2 align-center",attrs:{"max":_vm.maxYear,"min":_vm.minYear,"hide-details":""},model:{value:(_vm.filterInterval),callback:function ($$v) {_vm.filterInterval=$$v},expression:"filterInterval"}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "01On":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "04/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_components_ol_Map__ = __webpack_require__("i8bC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_components_ol_HoverTooltip__ = __webpack_require__("X0Tm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AppHeader__ = __webpack_require__("mUig");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AppFooter__ = __webpack_require__("ZfcG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AppSidebar__ = __webpack_require__("ETGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_components_AppLogo__ = __webpack_require__("qq5n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_components_AppLoadingMask__ = __webpack_require__("yJe9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_components_bglayerswitcher_BgLayerSwitcher_vue__ = __webpack_require__("jc9b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_components_overviewmap_OverviewMap_vue__ = __webpack_require__("9OJY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_components_measuretool_MeasureWin__ = __webpack_require__("lgWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_components_layerlist_LayerListWin__ = __webpack_require__("29fi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_components_helpwin_HelpWin__ = __webpack_require__("UkhJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_components_infoclick_InfoClickWin__ = __webpack_require__("qUL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_components_progress_MapLoadingStatus__ = __webpack_require__("novK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_components_attributeTable_AttributeTableWin_vue__ = __webpack_require__("MV43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_components_maprecorder_MapRecorderWin__ = __webpack_require__("ILVl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ids_components_featureinfo_IdsFeatureInfoModuleWin_vue__ = __webpack_require__("PKmJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ids_components_filter_IdsFilterModuleWin_vue__ = __webpack_require__("JETI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ids_components_detailfilter_IdsDetailFilterModuleWin_vue__ = __webpack_require__("1yXK");







function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-tpl',
  components: {
    'wgu-map': __WEBPACK_IMPORTED_MODULE_9__src_components_ol_Map__["a" /* default */],
    'wgu-hover-tooltip': __WEBPACK_IMPORTED_MODULE_10__src_components_ol_HoverTooltip__["a" /* default */],
    'wgu-app-header': __WEBPACK_IMPORTED_MODULE_11__components_AppHeader__["a" /* default */],
    'wgu-app-footer': __WEBPACK_IMPORTED_MODULE_12__components_AppFooter__["a" /* default */],
    'wgu-app-sidebar': __WEBPACK_IMPORTED_MODULE_13__components_AppSidebar__["a" /* default */],
    'wgu-app-logo': __WEBPACK_IMPORTED_MODULE_14__src_components_AppLogo__["a" /* default */],
    'wgu-app-loading-mask': __WEBPACK_IMPORTED_MODULE_15__src_components_AppLoadingMask__["a" /* default */],
    'wgu-bglayerswitcher': __WEBPACK_IMPORTED_MODULE_16__src_components_bglayerswitcher_BgLayerSwitcher_vue__["a" /* default */],
    'wgu-overviewmap': __WEBPACK_IMPORTED_MODULE_17__src_components_overviewmap_OverviewMap_vue__["a" /* default */],
    'wgu-measuretool-win': __WEBPACK_IMPORTED_MODULE_18__src_components_measuretool_MeasureWin__["a" /* default */],
    'wgu-layerlist-win': __WEBPACK_IMPORTED_MODULE_19__src_components_layerlist_LayerListWin__["a" /* default */],
    'wgu-helpwin-win': __WEBPACK_IMPORTED_MODULE_20__src_components_helpwin_HelpWin__["a" /* default */],
    'wgu-infoclick-win': __WEBPACK_IMPORTED_MODULE_21__src_components_infoclick_InfoClickWin__["a" /* default */],
    'wgu-maploading-status': __WEBPACK_IMPORTED_MODULE_22__src_components_progress_MapLoadingStatus__["a" /* default */],
    'wgu-attributetable-win': __WEBPACK_IMPORTED_MODULE_23__src_components_attributeTable_AttributeTableWin_vue__["a" /* default */],
    'wgu-maprecorder-win': __WEBPACK_IMPORTED_MODULE_24__src_components_maprecorder_MapRecorderWin__["a" /* default */],
    'ids-feature-info-module-win': __WEBPACK_IMPORTED_MODULE_25__ids_components_featureinfo_IdsFeatureInfoModuleWin_vue__["a" /* default */],
    'ids-filter-module-win': __WEBPACK_IMPORTED_MODULE_26__ids_components_filter_IdsFilterModuleWin_vue__["a" /* default */],
    'ids-detail-filter-module-win': __WEBPACK_IMPORTED_MODULE_27__ids_components_detailfilter_IdsDetailFilterModuleWin_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isEmbedded: false,
      sidebarConfig: this.getSidebarConfig(),
      overviewMapConfig: this.getOverviewMapConfig(),
      floatingWins: this.getModuleWinData('floating'),
      sidebarWins: this.getModuleWinData('sidebar'),
      showCopyrightYear: __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig.showCopyrightYear
    };
  },
  created: function created() {
    this.setDocumentTitle();
  },
  mounted: function mounted() {
    // apply the isEmbedded state to the member var
    this.isEmbedded = this.$isEmbedded; // make the refs (floating module window, which are not connected to their
    // related components, e.g. buttons to toggle them)

    var refs = this.$refs;
    var cmpLookup = {};

    for (var _i = 0, _Object$keys = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(refs); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      cmpLookup[key] = refs[key][0];
    }

    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.cmpLookup = cmpLookup; // inform registered cmps that the app is mounted and the dynamic
    // components are available

    __WEBPACK_IMPORTED_MODULE_8__src_WguEventBus__["a" /* WguEventBus */].$emit('app-mounted');
  },
  methods: {
    /**
     * Returns the configuration object for the sidebar from app-config.
     * @return {Object} Sidebar configuration object.
     */
    getSidebarConfig: function getSidebarConfig() {
      var appConfig = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig || {};
      return appConfig['sidebar'];
    },

    /**
     * Returns the configuration object for the overview map from app-config.
     * @return {Object} Overview map configuration object.
     */
    getOverviewMapConfig: function getOverviewMapConfig() {
      var appConfig = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig || {};
      return appConfig['overviewMap'];
    },

    /**
     * Determines the module window configuration objects from app-config:
     *     moduleWins: [
     *       {type: 'wgu-layerlist-win'},
     *       {type: 'wgu-measuretool-win'}
     *     ]
     * @param  {String} target Either 'floating' or 'sidebar'
     * @return {Array} module window configuration objects
     */
    getModuleWinData: function getModuleWinData(target) {
      var appConfig = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig || {};
      var modulesConfs = appConfig.modules || {};
      var moduleWins = [];

      for (var _i2 = 0, _Object$keys3 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(modulesConfs); _i2 < _Object$keys3.length; _i2++) {
        var key = _Object$keys3[_i2];
        var moduleOpts = appConfig.modules[key];

        if (moduleOpts.win === target) {
          // hide detail filter module in case of mobile view
          // respective button is hidden in app.css
          // TODO: alternatively change target to floating window
          var detailWindowAndMobileView = this.$vuetify.breakpoint.xs && key === 'ids-detail-filter-module';

          if (!detailWindowAndMobileView) {
            moduleWins.push(_objectSpread({
              type: key + '-win'
            }, moduleOpts));
          }
        }
      }

      return moduleWins;
    },

    /**
     * Sets the document title from language file.
     */
    setDocumentTitle: function setDocumentTitle() {
      document.title = this.$t('app.browserTitle') || document.title;
    }
  },
  watch: {
    /**
     * Watch for locale changes.
     */
    '$i18n.locale': function $i18nLocale() {
      this.setDocumentTitle();
    }
  }
});

/***/ }),

/***/ "0ZKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-measurewin",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon},on:{"visibility-change":_vm.show}},'wgu-module-card',_vm.$attrs,false),[_c('v-card-title',{attrs:{"primary-title":""}},[_c('wgu-measure-type-chooser',{attrs:{"measureType":_vm.measureType},on:{"wgu-measuretype-change":_vm.applyMeasureType}})],1),_vm._v(" "),_c('v-card-actions',[_c('wgu-measure-result',{attrs:{"measureGeom":_vm.measureGeom}})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "1iCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js__ = __webpack_require__("388n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js__ = __webpack_require__("XEfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_string_match_js__ = __webpack_require__("LBAN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_string_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_string_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_canvas_record__ = __webpack_require__("UG1j");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-maprecorder-win',
  inheritAttrs: false,
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_Mapable__["a" /* Mapable */]],
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_6__modulecore_ModuleCard__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'mdi-video'
    }
  },
  data: function data() {
    var mimeTypes = this.getSupportedMimeTypes();
    return {
      moduleName: 'wgu-maprecorder',

      /**
       * Custom canvas element for drawing the OpenLayers map.
       */
      mapCanvas: null,

      /**
       * Context of the custom canvas element.
       */
      mapContext: null,

      /**
       * Canvas recorder.
       */
      recorder: null,

      /**
       * Recording state.
       */
      recording: false,

      /**
       * Filename of the video. Defaults to 'Recording YYYY-MM-DD'.
       */
      filename: undefined,

      /**
       * The frame rate used by the MediaRecorder.
       */
      frameRate: 25,

      /**
       * The video encoding bit rate in MBits/s.
       */
      videoMBitsPerSecond: 2.5,

      /**
       * The selected video codec.
       */
      mimeType: mimeTypes.length > 0 ? mimeTypes[0] : undefined,

      /**
       * The video codecs supported by the browser.
       */
      mimeTypes: mimeTypes,

      /**
       * Timer handle for canvas draw callbacks.
       */
      timerHandle: null,

      /**
       * An error occured on recording.
       */
      error: false
    };
  },
  methods: {
    /**
     * Starting from OpenLayers 6, layers are no longer composed to a single
     * Canvas element. The following function does custom rendering of all map
     * layers, code is taken from this example:
     * https://openlayers.org/en/latest/examples/export-map.html
     */
    drawCanvas: function drawCanvas() {
      var me = this;
      me.mapContext.fillStyle = 'white';
      me.mapContext.fillRect(0, 0, me.mapCanvas.width, me.mapCanvas.height);
      Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function (canvas) {
        if (canvas.width > 0) {
          var _context;

          var opacity = canvas.parentNode.style.opacity;
          me.mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity); // Get the transform parameters from the style's transform matrix
          // and apply the transform to the export map context.

          var transform = canvas.style.transform;
          /* eslint-disable-next-line no-useless-escape */

          var matrix = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = transform.match(/^matrix\(([^\(]*)\)$/)[1].split(',')).call(_context, Number);

          CanvasRenderingContext2D.prototype.setTransform.apply(me.mapContext, matrix);
          me.mapContext.drawImage(canvas, 0, 0);
        }
      });
    },

    /**
     * Starts / stops recording
     */
    toggleRecord: function toggleRecord() {
      var me = this;

      if (me.recording) {
        me.stopRecording();
      } else {
        me.startRecording();
      }
    },

    /**
     * Resize the canvas when the map changes. Only happens when recording
     * is active.
     */
    mapSizeChanged: function mapSizeChanged() {
      var me = this;

      var size = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).getSize();

      me.mapCanvas.width = size[0];
      me.mapCanvas.height = size[1];
    },

    /**
     * Create a custom canvas to render into, a map recorder and start the
     * capturing process.
     */
    startRecording: function startRecording() {
      var me = this;
      me.mapCanvas = document.createElement('canvas');
      me.mapSizeChanged();
      me.mapContext = me.mapCanvas.getContext('2d');
      me.drawCanvas();

      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).on('change:size', me.mapSizeChanged);

      me.timerHandle = setInterval(me.drawCanvas, 1000 / me.frameRate);

      try {
        me.recorder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_canvas_record__["a" /* default */])(me.mapCanvas, {
          filename: me.filename,
          frameRate: me.frameRate,
          recorderOptions: {
            videoBitsPerSecond: me.videoMBitsPerSecond * 1048576,
            mimeType: me.mimeType
          }
        });
        me.recorder.start();
      } catch (e) {
        me.error = true;
        me.stopRecording();
        return;
      }

      me.error = false;
      me.recording = true;
    },

    /**
     * Stop recording and free all associated resources.
     */
    stopRecording: function stopRecording() {
      var me = this;

      if (me.recorder) {
        me.recorder.stop();
        me.recorder.dispose();
        me.recorder = null;
      }

      clearInterval(me.timerHandle);
      me.timerHandle = null;

      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).un('change:size', me.mapSizeChanged);

      me.mapContext = me.mapCanvas = null;
      me.recording = false;
    },

    /**
     * Returns video codecs supported by the browser. See
     * https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Containers
     */
    getSupportedMimeTypes: function getSupportedMimeTypes() {
      var _context2;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context2 = ['video/webm', 'video/mp4', 'video/ogg', 'video/x-matroska', 'video/quicktime', 'video/3gpp']).call(_context2, function (mimeType) {
        return MediaRecorder.isTypeSupported(mimeType);
      });
    }
  }
});

/***/ }),

/***/ "1l2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PermalinkController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map__ = __webpack_require__("aEal");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_proj_Projection__ = __webpack_require__("7rnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Url__ = __webpack_require__("v9hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_extent__ = __webpack_require__("/LWt");











/**
 * Class holding the logic for permalinks.
 */

var PermalinkController = /*#__PURE__*/function () {
  /* the OL map for permalink */
  function PermalinkController(map, permalinkConf) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, PermalinkController);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "map", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "shouldUpdate", false);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "projection", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "conf", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "urlParams", null);

    this.map = map;
    this.conf = permalinkConf || {};
    this.projection = this.conf.projection ? new __WEBPACK_IMPORTED_MODULE_7_ol_proj_Projection__["a" /* default */]({
      'code': this.conf.projection
    }) : null;
    this.conf.paramPrefix = this.conf.paramPrefix || '';
    this.conf.location = this.conf.location || 'hash';
    this.conf.separator = this.conf.location === 'hash' ? '#' : '?';
    this.conf.history = this.conf.history ? this.conf.history : false;
    this.conf.extent = this.conf.extent ? this.conf.extent : false;
    this.conf.layers = this.conf.layers ? this.conf.layers : false;
    this.conf.precision = this.conf.precision ? this.conf.precision : 4;
    this.urlParams = __WEBPACK_IMPORTED_MODULE_9__util_Url__["a" /* default */].getParams(this.conf.location);
    this.layerListeners = [];
  }
  /**
   * Initializes the map permalink functionality:
   * Registers a 'moveend' event to update the permalink
   * 'hoverAttribute' if the layer is configured as 'hoverable'
   */


  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(PermalinkController, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      this.shouldUpdate = true; // Listen to map state changes (pan, zoom)

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).on('moveend', function () {
        _this.onMapChange();
      }); // Listen to visibility changes in Map Layers.


      this.subscribeLayers(); // Listen to Layer Collection (dynamically Layers added/removed)

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().on('change:length', function () {
        _this.subscribeLayers();
      });

      if (this.conf.history === false) {
        return;
      } // restore the view state when navigating through the history (browser back/forward buttons), see
      // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate


      window.addEventListener('popstate', function (event) {
        if (event.state === null || __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this) === null) {
          return;
        }

        var view = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).getView();

        var state = event.state;
        _this.shouldUpdate = false;
        view.setRotation(state.rotation); // Use extent (bbox) or center+zoom based on config

        if (_this.conf.extent) {
          _this.applyExtent(state.extent);
        } else {
          _this.applyCenter(state.center);
        } // somehow we also need zoom (or resolution) for extent:
        // See: https://stackoverflow.com/questions/47770782/openlayers-fit-to-current-extent-is-zooming-out


        view.setZoom(state.zoom);

        if (_this.conf.layers) {
          var _context;

          _this.applyLayers(new __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map___default.a(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = state.layers).call(_context, function (lid) {
            return [lid, lid];
          })));
        }
      });
    }
    /**
     * Stop this instance.
     */

  }, {
    key: "tearDown",
    value: function tearDown() {
      this.unsubscribeLayers();
      this.map = null;
    }
    /**
     * Subscribe to Layer visibility changes.
     */

  }, {
    key: "subscribeLayers",
    value: function subscribeLayers() {
      var _this2 = this;

      if (!__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)) {
        return;
      } // First unsubscribe from all


      this.unsubscribeLayers(); // Listen to each Layer's visibility changes.

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().forEach(function (layer) {
        var key = layer.on('change:visible', function () {
          _this2.onMapChange();
        });

        _this2.layerListeners.push({
          'key': key,
          'layer': layer
        });
      });
    }
    /**
     * Unsubscribe to Layer visibility changes.
     */

  }, {
    key: "unsubscribeLayers",
    value: function unsubscribeLayers() {
      if (!__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)) {
        return;
      } // Listen to each Layer's visibility changes.


      this.layerListeners.forEach(function (item) {
        item.layer.un(item.key.type, item.key.listener);
      });
      this.layerListeners = [];
    }
    /**
     * Applies map (View) rotation, center+zoom-level or extent
     * from permalink params in current URL 'location'
     */

  }, {
    key: "apply",
    value: function apply() {
      var permalinkParams = __WEBPACK_IMPORTED_MODULE_9__util_Url__["a" /* default */].getParams(this.conf.location);
      var prefix = this.conf.paramPrefix;

      var mapView = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView();

      var r = "".concat(prefix, "r");
      var c = "".concat(prefix, "c");
      var e = "".concat(prefix, "e");
      var z = "".concat(prefix, "z");
      var l = "".concat(prefix, "l");

      if (permalinkParams[r]) {
        mapView.setRotation(parseFloat(permalinkParams[r]));
      } // Both extent (bbox) or center+zoom supported.


      if (permalinkParams[e]) {
        var _context2;

        var extent = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context2 = permalinkParams[e].split(',')).call(_context2, function (n) {
          return parseFloat(n);
        });

        this.applyExtent(extent);
      } else if (permalinkParams[c]) {
        var _context3;

        var center = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context3 = permalinkParams[c].split(',')).call(_context3, function (n) {
          return parseFloat(n);
        });

        this.applyCenter(center);
      } // Always set zoom, even with extent
      // See: https://stackoverflow.com/questions/47770782/openlayers-fit-to-current-extent-is-zooming-out


      if (permalinkParams[z]) {
        mapView.setZoom(parseFloat(permalinkParams[z]));
      } // Set layer(s) visible


      if (permalinkParams[l]) {
        var _context4;

        this.applyLayers(new __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map___default.a(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context4 = permalinkParams[l].split(',')).call(_context4, function (lid) {
          return [lid, lid];
        })));
      }
    }
    /**
     * Make only the layers for given array of layer ids visible.
     */

  }, {
    key: "applyLayers",
    value: function applyLayers(layers) {
      if (!layers) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().forEach(function (layer) {
        var layerId = layer.get('lid');
        layer.setVisible(layerId === layers.get(layerId));
      });
    }
    /**
     * Position map at provided center.
     */

  }, {
    key: "applyCenter",
    value: function applyCenter(center) {
      if (!center) {
        return;
      }

      var mapView = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView(); // Permalink coordinates may have specific Projection like WGS84


      if (this.projection) {
        center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ol_proj__["p" /* transform */])(center, this.projection, mapView.getProjection());
      }

      mapView.setCenter(center);
    }
    /**
     * Position map at provided map extent.
     */

  }, {
    key: "applyExtent",
    value: function applyExtent(extent) {
      if (!extent) {
        return;
      }

      var mapView = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView(); // Permalink coordinates may have specific Projection like WGS84


      if (this.projection) {
        extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_ol_extent__["i" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ol_proj__["b" /* getTransform */])(this.projection, mapView.getProjection()));
      } // Fit the map in extent


      mapView.fit(extent, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getSize());
    }
    /**
     * Get the URL parameter permalink string as query or hash.
     */

  }, {
    key: "getParamStr",
    value: function getParamStr() {
      var round = function round(num, places) {
        return +(Math.round(num + 'e+' + places) + 'e-' + places);
      };

      var state = this.getState();
      var prefix = this.conf.paramPrefix;
      var prec = this.conf.precision; // Use extent (bbox) or center+zoom based on config

      this.urlParams["".concat(prefix, "z")] = "".concat(round(state.zoom, prec));

      if (this.conf.extent) {
        var _context5;

        this.urlParams["".concat(prefix, "e")] = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context5 = state.extent).call(_context5, function (n) {
          return round(n, prec);
        }).join(',');
      } else {
        var _context6;

        this.urlParams["".concat(prefix, "c")] = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context6 = state.center).call(_context6, function (n) {
          return round(n, prec);
        }).join(',');
      }

      this.urlParams["".concat(prefix, "r")] = "".concat(round(state.rotation, prec));

      if (this.conf.layers) {
        this.urlParams["".concat(prefix, "l")] = state.layers.join(',');
      }

      return this.conf.separator + __WEBPACK_IMPORTED_MODULE_9__util_Url__["a" /* default */].toQueryString(this.urlParams);
    }
    /**
     * Get full URL with permalink string for sharing.
     */

  }, {
    key: "getShareUrl",
    value: function getShareUrl() {
      return location.href.split(this.conf.separator)[0] + this.getParamStr();
    }
    /**
     * Get (IFrame) code fragment for embedding the permalink in an HTML page.
     */

  }, {
    key: "getEmbedHTML",
    value: function getEmbedHTML() {
      var _context7, _context8;

      var mapSize = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getSize();

      return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context7 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context8 = "<iframe width=\"".concat(mapSize[0], "\" height=\"")).call(_context8, mapSize[1], "\" src=\"")).call(_context7, this.getShareUrl(), "\" style=\"border:none;\"></iframe>");
    }
    /**
     * Get array of visible and not ignored layer IDs.
     */

  }, {
    key: "getLayerIds",
    value: function getLayerIds() {
      var _context9, _context10;

      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context9 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context10 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray()).call(_context10, function (layer) {
        return !!layer.get('lid') && layer.getVisible() && layer.get('supportsPermalink');
      })).call(_context9, function (layer) {
        return layer.get('lid');
      });
    }
    /**
     * Get total State of the Map.
     */

  }, {
    key: "getState",
    value: function getState() {
      var mapView = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView();

      var center = mapView.getCenter();
      var extent = mapView.calculateExtent(); // Optionally reproject to permalink projection (e.g. WGS84 on WebMerc).

      if (this.projection) {
        center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ol_proj__["p" /* transform */])(center, mapView.getProjection(), this.projection);
        extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_ol_extent__["i" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ol_proj__["b" /* getTransform */])(mapView.getProjection(), this.projection));
      }

      return {
        zoom: mapView.getZoom(),
        center: center,
        extent: extent,
        rotation: mapView.getRotation(),
        layers: this.getLayerIds()
      };
    }
    /**
     * Callback when Map View has changed, e.g. 'moveend' or a Layer's visibility.
     */

  }, {
    key: "onMapChange",
    value: function onMapChange() {
      // console.log('mapchange');
      if (!this.shouldUpdate) {
        // do not update the URL when the view was changed in the 'popstate' handler
        this.shouldUpdate = true;
        return;
      }

      if (this.conf.history === false) {
        return;
      } // This changes the URL in address bar.


      window.history.pushState(this.getState(), 'map', this.getParamStr());
    }
  }]);

  return PermalinkController;
}();



/***/ }),

/***/ "1nz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geolocator_vue__ = __webpack_require__("N/gh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1349be6c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geolocator_vue__ = __webpack_require__("/UKJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("UzS5")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1349be6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geolocator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1349be6c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geolocator_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1349be6c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geolocator_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1pk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LayerList__ = __webpack_require__("mucN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_0__modulecore_ModuleCard__["a" /* default */],
    'wgu-layerlist': __WEBPACK_IMPORTED_MODULE_1__LayerList__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'layers'
    },
    showLegends: {
      type: Boolean,
      required: false,
      default: true
    },
    showOpacityControls: {
      type: Boolean,
      required: false,
      default: true
    }
  }
});

/***/ }),

/***/ "1yXK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsDetailFilterModuleWin_vue__ = __webpack_require__("9jWB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203546e6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsDetailFilterModuleWin_vue__ = __webpack_require__("00qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fLNA")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsDetailFilterModuleWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203546e6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsDetailFilterModuleWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203546e6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsDetailFilterModuleWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1ywd":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de.json": "tdkq",
	"./en.json": "NuBg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ywd";

/***/ }),

/***/ "29fi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListWin_vue__ = __webpack_require__("1pk9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5701b1e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListWin_vue__ = __webpack_require__("IJqu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5701b1e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5701b1e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2XVS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',{staticClass:"mb-1",attrs:{"multiple":""},model:{value:(_vm.expandState),callback:function ($$v) {_vm.expandState=$$v},expression:"expandState"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{attrs:{"color":"secondary","dark":"","dense":""}},[_c('v-icon',{staticClass:"ids-expansion-header-left-icon pr-2"},[_vm._v("\n        mdi-flag\n      ")]),_vm._v("\n      "+_vm._s(_vm.headerText)+"\n    ")],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-container',{staticClass:"mlr-2",attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"mt-3 ids-geo-sel-loading",attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-select',{ref:"selectEl",staticClass:"ml-3",attrs:{"items":_vm.geoList,"item-text":"name","outlined":"","placeholder":_vm.placeHolderText,"return-object":""},on:{"change":_vm.onUserChange},model:{value:(_vm.dataSelection),callback:function ($$v) {_vm.dataSelection=$$v},expression:"dataSelection"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "36PU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ColorTheme__ = __webpack_require__("ATxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AttributeTable__ = __webpack_require__("odA+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-attributetable-win',
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: false,
      default: 'table_chart'
    },
    syncTableMapSelection: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      moduleName: 'wgu-attributetable',
      layers: [],
      selLayer: null
    };
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Mapable__["a" /* Mapable */], __WEBPACK_IMPORTED_MODULE_4__mixins_ColorTheme__["a" /* ColorTheme */]],
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_2__modulecore_ModuleCard__["a" /* default */],
    'wgu-attributetable': __WEBPACK_IMPORTED_MODULE_6__AttributeTable__["a" /* default */]
  },
  methods: {
    show: function show() {
      // resize map properly after closing
      // the AttributeTable
      this.resizeOlMap();
    },
    onResize: function onResize() {
      // change map size when window is changing
      this.resizeOlMap();
    },

    /**
     * Update the OpenLayers map size.
     *
     * Necessary because the map does not automatically
     * notice when its size is changed externally.
     */
    resizeOlMap: function resizeOlMap() {
      var _this = this;

      this.$nextTick(function () {
        // must be within '$nextTick' to take effect
        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).updateSize();
      });
    },

    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound: function onMapBound() {
      this.layers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray();
    }
  },
  computed: {
    /**
     * Reactive property to return the OpenLayers vector layers to be shown in the selection menu.
     */
    displayedLayers: function displayedLayers() {
      var _context;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = this.layers).call(_context, function (layer) {
        return layer instanceof __WEBPACK_IMPORTED_MODULE_5_ol_layer_Vector__["a" /* default */] && layer.get('lid') !== 'wgu-measure-layer' && layer.get('lid') !== 'wgu-geolocator-layer';
      }).reverse();
    }
  }
});

/***/ }),

/***/ "3GfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__ = __webpack_require__("0WSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator__ = __webpack_require__("I3KW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DgdMockDataLoader__ = __webpack_require__("h4Lm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IdsFilterGenerator__ = __webpack_require__("KzfC");






var DgdDataLoader = {
  /** base URL for API */
  baseUrl: 'dgd/pragdb.geo',

  /**
   * Returns a list of all location types (Ortstypen) as JSON array.
   *
   * @returns The JSON array with all location types (key: 'v_ortstyp')
   */
  getLocationTypeList: function getLocationTypeList() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee() {
      var _context;

      var endpoint, resp;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$devMode === true)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_4__DgdMockDataLoader__["a" /* default */].getLocationTypeList());

            case 2:
              endpoint = 'get_ortstypen_list';
              _context2.next = 5;
              return fetch(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context = "".concat(_this.baseUrl, ".")).call(_context, endpoint), {});

            case 5:
              resp = _context2.sent;

              if (!(resp.status === 200)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", resp.json());

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * Returns a list of all corpora (Korpora) as JSON array.
   *
   * @returns The GeoJSON for the given filter parameters
   */
  getCorpusList: function getCorpusList() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee2() {
      var _context3;

      var endpoint, resp;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee2$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$devMode === true)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_4__DgdMockDataLoader__["a" /* default */].getCorpusList());

            case 2:
              endpoint = 'get_corpus_list';
              _context4.next = 5;
              return fetch(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context3 = "".concat(_this2.baseUrl, ".")).call(_context3, endpoint), {});

            case 5:
              resp = _context4.sent;

              if (!(resp.status === 200)) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("return", resp.json());

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   * Returns a list of all countries as JSON array.
   *
   * @returns The country JSON array
   */
  getCountryList: function getCountryList(locationType) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee3() {
      var _context5;

      var locTypeFilter, endpoint, resp, countries, modCountries;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee3$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$devMode === true)) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return", __WEBPACK_IMPORTED_MODULE_4__DgdMockDataLoader__["a" /* default */].getCountryList());

            case 2:
              locTypeFilter = __WEBPACK_IMPORTED_MODULE_5__IdsFilterGenerator__["a" /* default */].createLocationTypeFilter(locationType);
              endpoint = "get_country_list?".concat(locTypeFilter);
              _context6.next = 6;
              return fetch(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context5 = "".concat(_this3.baseUrl, ".")).call(_context5, endpoint), {});

            case 6:
              resp = _context6.sent;

              if (!(resp.status === 200)) {
                _context6.next = 15;
                break;
              }

              _context6.next = 10;
              return resp.json();

            case 10:
              countries = _context6.sent;
              // we ensure a client ID for all object to get a harmonized structure
              modCountries = [];
              countries.forEach(function (r) {
                modCountries.push({
                  // TODO mixed up props in API => switch when fixed in API
                  name: r.Langname,
                  iso: r['ISO-Code'],
                  clientId: r['ISO-Code']
                });
              });
              modCountries.unshift({
                name: '- Keine Auswahl -',
                clientId: null
              });
              return _context6.abrupt("return", modCountries);

            case 15:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee3);
    }))();
  },

  /**
   * Returns a list of all regions for the given country as JSON array.
   *
   * @returns The region JSON array
   */
  getRegionList: function getRegionList(countryCode, locationType) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee4() {
      var _context7, _context8;

      var locTypeFilter, endpoint, resp, regions, modRegions;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee4$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$devMode === true)) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt("return", __WEBPACK_IMPORTED_MODULE_4__DgdMockDataLoader__["a" /* default */].getRegionList(countryCode));

            case 2:
              locTypeFilter = __WEBPACK_IMPORTED_MODULE_5__IdsFilterGenerator__["a" /* default */].createLocationTypeFilter(locationType);
              endpoint = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context7 = "get_region_list?v_iso=".concat(countryCode, "&")).call(_context7, locTypeFilter);
              _context9.next = 6;
              return fetch(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context8 = "".concat(_this4.baseUrl, ".")).call(_context8, endpoint), {});

            case 6:
              resp = _context9.sent;

              if (!(resp.status === 200)) {
                _context9.next = 15;
                break;
              }

              _context9.next = 10;
              return resp.json();

            case 10:
              regions = _context9.sent;
              modRegions = [];
              regions.forEach(function (r) {
                modRegions.push({
                  name: r.Region,
                  clientId: r.Region
                });
              });
              modRegions.unshift({
                name: '- Keine Auswahl -',
                clientId: null
              });
              return _context9.abrupt("return", modRegions);

            case 15:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /**
   * Returns a list of all districts for the given country and region as
   * JSON array.
   *
   * @returns The region JSON array
   */
  getDistrictList: function getDistrictList(countryCode, regionName, locationType) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee5() {
      var _context10, _context11, _context12;

      var locTypeFilter, endpoint, resp, districts, modDistricts;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee5$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$devMode === true)) {
                _context13.next = 2;
                break;
              }

              return _context13.abrupt("return", __WEBPACK_IMPORTED_MODULE_4__DgdMockDataLoader__["a" /* default */].getDistrictList(countryCode, regionName));

            case 2:
              locTypeFilter = __WEBPACK_IMPORTED_MODULE_5__IdsFilterGenerator__["a" /* default */].createLocationTypeFilter(locationType);
              endpoint = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context10 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context11 = "get_landkreis_list?".concat(locTypeFilter, "&v_iso=")).call(_context11, countryCode, "&v_region_name=")).call(_context10, regionName);
              _context13.next = 6;
              return fetch(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context12 = "".concat(_this5.baseUrl, ".")).call(_context12, endpoint), {});

            case 6:
              resp = _context13.sent;

              if (!(resp.status === 200)) {
                _context13.next = 15;
                break;
              }

              _context13.next = 10;
              return resp.json();

            case 10:
              districts = _context13.sent;
              modDistricts = [];
              districts.forEach(function (d) {
                modDistricts.push({
                  name: d.Landkreis,
                  clientId: d.Landkreis
                });
              });
              modDistricts.unshift({
                name: '- Keine Auswahl -',
                clientId: null
              });
              return _context13.abrupt("return", modDistricts);

            case 15:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * Returns a list of locations (Ortsdaten) as GeoJSON FeatureCollection.
   *
   * @param {String} corpusSelection
   * @param {String} locationType
   * @returns The GeoJSON for the given filter parameters
   */
  getLocationList: function getLocationList(corpusSelection, locationType) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee6() {
      var _context14, _context15;

      var endpoint, filterQueryString, resp;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee6$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$devMode === true)) {
                _context16.next = 2;
                break;
              }

              return _context16.abrupt("return", __WEBPACK_IMPORTED_MODULE_4__DgdMockDataLoader__["a" /* default */].getLocationList());

            case 2:
              endpoint = 'get_location_list';
              filterQueryString = __WEBPACK_IMPORTED_MODULE_5__IdsFilterGenerator__["a" /* default */].createFilter(locationType, corpusSelection);
              _context16.next = 6;
              return fetch(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context14 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context15 = "".concat(_this6.baseUrl, ".")).call(_context15, endpoint, "?")).call(_context14, filterQueryString), {});

            case 6:
              resp = _context16.sent;

              if (!(resp.status === 200)) {
                _context16.next = 9;
                break;
              }

              return _context16.abrupt("return", resp.json());

            case 9:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee6);
    }))();
  },

  /**
   * Returns a list of locations (Ortsdaten) as GeoJSON FeatureCollection,
   * based on a geographic filter.
   *
   * @param {Object} geoFilter
   * @param {String} locationType
   * @returns The GeoJSON for the given filter parameters
   */
  getLocationListGeo: function getLocationListGeo(geoFilter, locationType) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee7() {
      var _context17, _context18;

      var endpoint, filterQueryString, resp;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee7$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$devMode === true)) {
                _context19.next = 2;
                break;
              }

              return _context19.abrupt("return", __WEBPACK_IMPORTED_MODULE_4__DgdMockDataLoader__["a" /* default */].getLocationListGeo());

            case 2:
              endpoint = 'get_location_list_geographic';
              filterQueryString = __WEBPACK_IMPORTED_MODULE_5__IdsFilterGenerator__["a" /* default */].createFilter(locationType, null, geoFilter);
              _context19.next = 6;
              return fetch(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context17 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context18 = "".concat(_this7.baseUrl, ".")).call(_context18, endpoint, "?")).call(_context17, filterQueryString), {});

            case 6:
              resp = _context19.sent;
              return _context19.abrupt("return", resp.json());

            case 8:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee7);
    }))();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (DgdDataLoader);

/***/ }),

/***/ "3fUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.legendURL)?_c('img',{attrs:{"src":_vm.legendURL}}):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "3wTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',{attrs:{"color":"secondary","prepend-icon":"opacity","value":_vm.layer.getOpacity(),"min":"0","max":"1","step":"0.01","thumb-label":"","hide-details":""},on:{"input":_vm.onOpacitySliderInput}})}
var staticRenderFns = []


/***/ }),

/***/ "4pN3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-helpwin",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon,"width":_vm.width}},'wgu-module-card',_vm.$attrs,false),[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[(_vm.$t('wgu-helpwin.textTitle'))?_c('h3',{staticClass:"headline mb-0"},[_vm._v("\n        "+_vm._s(_vm.$t('wgu-helpwin.textTitle')))]):_vm._e()])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text--primary",domProps:{"innerHTML":_vm._s(_vm.$t('wgu-helpwin.htmlContent'))}})]),_vm._v(" "),_c('v-card-actions',[(_vm.$t('wgu-helpwin.infoLinkUrl'))?_c('a',{staticClass:"info-link",attrs:{"href":_vm.$t('wgu-helpwin.infoLinkUrl'),"target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.$t('wgu-helpwin.infoLinkText') || _vm.$t('wgu-helpwin.infoLinkUrl'))+"\n      ")]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),

/***/ "4uSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.logoSrc)?_c('v-avatar',{staticClass:"wgu-app-logo",attrs:{"width":_vm.logoWidth,"height":_vm.logoHeight,"tile":true}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":_vm.$t('app.logo')}})]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "4z3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeasureTypeChooser__ = __webpack_require__("w/12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MeasureResult__ = __webpack_require__("cspx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OlMeasureController__ = __webpack_require__("VT4C");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measuretool-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_1__modulecore_ModuleCard__["a" /* default */],
    'wgu-measure-type-chooser': __WEBPACK_IMPORTED_MODULE_3__MeasureTypeChooser__["a" /* default */],
    'wgu-measure-result': __WEBPACK_IMPORTED_MODULE_4__MeasureResult__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__["a" /* Mapable */]],
  props: {
    icon: {
      type: String,
      required: false,
      default: 'photo_size_select_small'
    }
  },
  data: function data() {
    return {
      moduleName: 'wgu-measuretool',
      measureGeom: null,
      measureType: 'distance'
    };
  },
  destroy: function destroy() {
    if (this.olMapCtrl) {
      this.olMapCtrl.destroy();
      this.olMapCtrl = undefined;
    }
  },
  watch: {
    measureType: function measureType() {
      if (!this.olMapCtrl) {
        return;
      } // reset old geom


      this.measureGeom = {};
      this.olMapCtrl.addInteraction(this.measureType, this.onMeasureVertexSet);
    }
  },
  methods: {
    /**
     * (Un-)Register map interactions when the visibility of the module changes.
     *
     * @param  {boolean} visible New visibility state
     */
    show: function show(visible) {
      if (!this.olMapCtrl) {
        return;
      }

      if (visible) {
        this.olMapCtrl.addInteraction(this.measureType, this.onMeasureVertexSet);
      } else {
        this.olMapCtrl.removeInteraction();
      }
    },

    /**
     * Applies the changed measure value to this.measureType.
     * Called as callback of MeasureTypeChooser
     *
     * @param  {String} newMeasureType New measure type
     * @param  {String} oldMeasureType Old measure type
     */
    applyMeasureType: function applyMeasureType(newMeasureType, oldMeasureType) {
      this.measureType = newMeasureType;
    },

    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     */
    onMapBound: function onMapBound() {
      if (this.unbound) {
        return;
      } // TODO: Should we explicitly declare all attributes as props?


      this.olMapCtrl = new __WEBPACK_IMPORTED_MODULE_5__OlMeasureController__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this), this.$attrs);
      this.olMapCtrl.createMeasureLayer();
    },

    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     */
    onMapUnbound: function onMapUnbound() {
      if (this.olMapCtrl) {
        this.olMapCtrl.destroy();
        this.olMapCtrl = undefined;
      }
    },

    /**
     * Callback function executed when user sets a measure point on the map.
     *
     * @param  {ol/geom/Geometry} geom The geometry object of the map
     */
    onMeasureVertexSet: function onMeasureVertexSet(geom) {
      // wrap geom into object, otherwise the injection into childs does
      // not work. Maybe the OL object does not feel changed for Vue
      this.measureGeom = {
        geom: geom
      };
    }
  }
});

/***/ }),

/***/ "6OvL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleCard_vue__ = __webpack_require__("kQCp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9e521ca_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleCard_vue__ = __webpack_require__("DiDp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9e521ca_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9e521ca_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6lHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsGeographicFilter_vue__ = __webpack_require__("H6Sa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627fecf4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsGeographicFilter_vue__ = __webpack_require__("eMo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ty8j")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-627fecf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsGeographicFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627fecf4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsGeographicFilter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627fecf4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsGeographicFilter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "75l9":
/***/ (function(module, exports) {

module.exports = {"_from":"axios@0.21.4","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.4","name":"axios","escapedName":"axios","rawSpec":"0.21.4","saveSpec":null,"fetchSpec":"0.21.4"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@0.21.4","_where":"/home/meggs/workspace/meggsimum/leibniz-ids/frontend","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),

/***/ "7OTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modulecore_ModuleCard__ = __webpack_require__("6OvL");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-helpwin-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_1__modulecore_ModuleCard__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'help'
    },
    width: {
      type: Number,
      required: false,
      default: 300
    }
  },
  data: function data() {
    return {
      moduleName: 'wgu-helpwin'
    };
  }
});

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8SDf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8tls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-toggle-btn',
  props: {
    moduleName: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      show: this.visible
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$on(this.moduleName + '-visibility-change', function (visible) {
      _this.show = visible;
    });
  },
  methods: {
    toggleUi: function toggleUi() {
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$emit(this.moduleName + '-visibility-change', !this.show);
    }
  }
});

/***/ }),

/***/ "9BwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"wgu-app-sidebar",attrs:{"app":"","clipped":"","bottom":this.$vuetify.breakpoint.xs,"hide-overlay":this.$vuetify.breakpoint.xs,"width":_vm.width},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('v-btn',{staticClass:"wgu-app-sidebar-toggle-btn px0",attrs:{"small":"","absolute":"","top":"","color":"secondary"},on:{"click":function($event){_vm.sidebarOpen = !_vm.sidebarOpen}}},[(_vm.sidebarOpen)?_c('v-icon',{attrs:{"color":"onsecondary"}},[_vm._v("chevron_left")]):_c('v-icon',{attrs:{"color":"onsecondary"}},[_vm._v("chevron_right")])],1)]},proxy:true}]),model:{value:(_vm.sidebarOpen),callback:function ($$v) {_vm.sidebarOpen=$$v},expression:"sidebarOpen"}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "9HAY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_pad_end__ = __webpack_require__("I9wc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_JsUtil_js__ = __webpack_require__("kURA");




/**
 * Lookup for corpus data
 */

var IdsCorpusLookup = {
  /** The initially selected and loaded corpus IDs */
  initialCorpusIds: [],

  /** The current corpus list used in the application */
  corpusList: [],

  /** Link template for the corpus description website */
  corpusLinkTpl: 'https://agd.ids-mannheim.de/{0}_extern.shtml',

  /**
   * Sets the given corpus list to the #corpusList lookup variable.
   *
   * @param {Array} corpusList The new corpus list to set
   */
  setCorpusList: function setCorpusList(corpusList) {
    IdsCorpusLookup.corpusList = corpusList;
  },

  /**
   * Returns the corpus object delivered by the API.
   *
   * @param {String} corpusId The corpus ID as returned from the API (e.g. 'ZW')
   * @returns The corpus object
   */
  getCorpus: function getCorpus(corpusId) {
    var _context;

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context = IdsCorpusLookup.corpusList).call(_context, function (c) {
      return c.v_corpus_id === corpusId;
    });
  },

  /**
   * Detects if the given corpus is in the list of available corpora.
   *
   * @param {String} corpusId The ID of the corpus, e.g. "PF--"
   * @returns true => is in corpus list, false => not in list
   */
  isExistingCorpus: function isExistingCorpus(corpusId) {
    var existing = false;
    IdsCorpusLookup.corpusList.forEach(function (korp) {
      if (korp.v_corpus_id === corpusId) {
        existing = true;
      }
    });
    return existing;
  },

  /**
   * Returns the selection array with all corpus selected for the given
   * category.
   *
   * @param {String} corpusCat
   * @returns Array with all corpus entries as selected
   */
  getAllSelected: function getAllSelected(corpusCat) {
    var aggregate = [];
    IdsCorpusLookup.corpusList.forEach(function (korp) {
      if (korp.v_corpus_cat === corpusCat) {
        aggregate.push(korp.v_corpus_id);
      }
    });
    return aggregate;
  },

  /**
   * Returns the selection object for the 'ids-filter-module-win'
   * component.
   * Like {"SPRACHVARIETÄTENKORPORA - DEUTSCHSPRACHIGES KERNGEBIET": [null, null, "MV--", null]}
   *
   * @param {Array} corpusIds Array of IDs of the corpora, e.g. ["PF--", "MV--"]
   * @returns The selection object
   */
  getSelectionObjectByArr: function getSelectionObjectByArr(corpusIds) {
    var aggregate = {};
    IdsCorpusLookup.corpusList.forEach(function (korp) {
      var corpusId = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find___default()(corpusIds).call(corpusIds, function (x) {
        return x === korp.v_corpus_id;
      });

      if (!aggregate[korp.v_corpus_cat]) {
        aggregate[korp.v_corpus_cat] = [];
      }

      if (korp.v_corpus_id === corpusId) {
        aggregate[korp.v_corpus_cat].push(corpusId);
      } else {
        aggregate[korp.v_corpus_cat].push(null);
      }
    });
    return aggregate;
  },

  /**
   * Returns a selection object with no selection, can be used to reset all
   * corpus selections over all categories.
   *
   * @returns The emty selection object
   */
  getEmptySelectionObject: function getEmptySelectionObject() {
    var aggregate = {};
    IdsCorpusLookup.corpusList.forEach(function (korp) {
      if (!aggregate[korp.v_corpus_cat]) {
        aggregate[korp.v_corpus_cat] = [];
      }

      aggregate[korp.v_corpus_cat].push(null);
    });
    return aggregate;
  },

  /**
   * Returns the label for a corpus.
   *
   * @param {String} corpusId The corpus ID as returned from the API (e.g. 'ZW')
   * @returns The corpus label, e.g. 'Deutsche Mundarten: Zwirner-Korpus (ZW--)'
   */
  getCorpusLabel: function getCorpusLabel(corpusId) {
    var _context2;

    var corpus = IdsCorpusLookup.getCorpus(corpusId);

    if (!corpus) {
      return;
    }

    var corpId = corpus.v_corpus_id;

    var paddedCorpId = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_pad_end___default()(corpId).call(corpId, 4, '-'); // ensure 4 chars ZW => ZW--


    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context2 = "".concat(corpus.v_corpus_name, " (")).call(_context2, paddedCorpId, ")");
  },

  /**
   * Returns the URL to the corpus description website.
   *
   * @param {String} corpusId The corpus ID as returned from the API (e.g. 'ZW')
   * @returns URL, like https://agd.ids-mannheim.de/ZW--_extern.shtml
   */
  getCorpusLink: function getCorpusLink(corpusId) {
    var corpus = IdsCorpusLookup.getCorpus(corpusId);

    if (!corpus) {
      return;
    }

    var padCorpId = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_pad_end___default()(corpusId).call(corpusId, 4, '-'); // ensure 4 chars ZW => ZW--


    return __WEBPACK_IMPORTED_MODULE_3__util_JsUtil_js__["a" /* default */].formatString(IdsCorpusLookup.corpusLinkTpl, padCorpId);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (IdsCorpusLookup);

/***/ }),

/***/ "9OJY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMap_vue__ = __webpack_require__("znPh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617bd38a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMap_vue__ = __webpack_require__("+yZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617bd38a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMap_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617bd38a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMap_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9OlX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = json;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__("xtLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_promise__ = __webpack_require__("SBIS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat__);




// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// TODO: may use Axios/Axios-jsonp
function json(obj) {
  return new __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_promise___default.a(function (resolve, reject) {
    var url = encodeUrlXhr(obj.url, obj.data);
    var config = {
      method: 'GET',
      mode: 'cors',
      credentials: 'same-origin'
    };

    if (obj.jsonp) {
      jsonp(url, obj.callbackName, resolve);
    } else {
      fetch(url, config).then(function (r) {
        return r.json();
      }).then(resolve).catch(reject);
    }
  });
}

function toQueryString(obj) {
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys___default()(obj).reduce(function (a, k) {
    var _context;

    a.push(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(obj[k]) === 'object' ? toQueryString(obj[k]) : __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context = "".concat(encodeURIComponent(k), "=")).call(_context, encodeURIComponent(obj[k])));
    return a;
  }, []).join('&');
}

function encodeUrlXhr(url, data) {
  if (data && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(data) === 'object') {
    url += (/\?/.test(url) ? '&' : '?') + toQueryString(data);
  }

  return url;
}

function jsonp(url, key, callback) {
  // https://github.com/Fresheyeball/micro-jsonp/blob/master/src/jsonp.js
  var head = document.head;
  var script = document.createElement('script'); // generate minimally unique name for callback function

  var callbackName = 'f' + Math.round(Math.random() * Date.now()); // set request url

  script.setAttribute('src',
  /*  add callback parameter to the url
        where key is the parameter key supplied
        and callbackName is the parameter value */
  url + (url.indexOf('?') > 0 ? '&' : '?') + key + '=' + callbackName);
  /*  place jsonp callback on window,
      the script sent by the server should call this
      function as it was passed as a url parameter */

  window[callbackName] = function (data) {
    window[callbackName] = undefined; // clean up script tag created for request

    setTimeout(function () {
      return head.removeChild(script);
    }, 0); // hand data back to the user

    callback(data);
  }; // actually make the request


  head.appendChild(script);
}

/***/ }),

/***/ "9jWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_util_Layer__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_JsUtil__ = __webpack_require__("kURA");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ids-detail-filter-module-win',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__src_mixins_Mapable__["a" /* Mapable */]],
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_3__src_components_modulecore_ModuleCard__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'filter'
    },
    filterMinYear: {
      type: Number,
      required: false
    },
    filterMaxYear: {
      type: Number,
      required: false
    },
    filterYearAttribute: {
      type: String,
      required: false,
      default: 'Aufnahmejahr'
    }
  },
  data: function data() {
    return {
      filterInterval: [1900, 2000],
      minYear: null,
      maxYear: null,
      lastLowerYear: null,
      lastUpperYear: null,
      allLocationFeatures: null,
      // lookup for all locations currently loaded
      yearAttribute: null,
      initialFilter: true
    };
  },
  created: function created() {
    // apply values from module config (see app-conf.json)
    // min / max limits of slider
    this.minYear = __WEBPACK_IMPORTED_MODULE_7__util_JsUtil__["a" /* default */].isNumeric(this.filterMinYear) ? parseInt(this.filterMinYear) : this.filterInterval[0];
    this.maxYear = __WEBPACK_IMPORTED_MODULE_7__util_JsUtil__["a" /* default */].isNumeric(this.filterMaxYear) ? parseInt(this.filterMaxYear) : new Date().getFullYear(); // set initial filter interval

    this.filterInterval = [this.minYear, this.maxYear]; // property name/key of the year attribute

    this.yearAttribute = this.filterYearAttribute;
  },
  watch: {
    filterInterval: function filterInterval(rangeVals) {
      var lowerYear = parseInt(rangeVals[0], 10);
      var upperYear = parseInt(rangeVals[1], 10); // check if initial locations are already loaded

      var locationLayer = __WEBPACK_IMPORTED_MODULE_6__src_util_Layer__["a" /* default */].getLayerByLid('ids-result-layer', __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this));
      var clusterSource = locationLayer.getSource();
      var locationSource = clusterSource.getSource();

      if (this.initialFilter && locationSource.getFeatures().length === 0) {
        return; // skip initial run when creating this UI
      } // only apply new filter if values changed


      if (this.lastLowerYear !== lowerYear || this.lastUpperYear !== upperYear) {
        this.filterLocationData(lowerYear, upperYear);
      } // preserve old filter filterInterval


      this.lastLowerYear = lowerYear;
      this.lastUpperYear = upperYear;
      this.initialFilter = false; // first initial run is done
    }
  },
  methods: {
    onMapBound: function onMapBound() {
      var _this = this;

      // reset all location items if new locations were load from backend
      __WEBPACK_IMPORTED_MODULE_5__src_WguEventBus__["a" /* WguEventBus */].$on('ids-new-locations-load', function () {
        // reset all feature lookup
        _this.allLocationFeatures = null; // reset filter to maximum interval

        _this.filterInterval = [_this.minYear, _this.maxYear];
      });
    },

    /**
     * Handles the 'input' event of the lower time range limit.
     *
     * @param {String} inputLowerYear the new input val for lower filter year
     */
    onLowerInputText: function onLowerInputText(inputLowerYear) {
      var lowerYear = parseInt(inputLowerYear, 10); // check if in mix/max range of filter interval

      if (lowerYear >= this.minYear && lowerYear <= this.maxYear) {
        this.filterInterval = [lowerYear, this.filterInterval[1]];
      }
    },

    /**
     * Handles the 'input' event of the upper time range limit.
     *
     * @param {String} inputUpperYear the new input val for upper filter year
     */
    onUpperInputText: function onUpperInputText(inputUpperYear) {
      var upperYear = parseInt(inputUpperYear, 10); // check if in mix/max range of filter interval

      if (upperYear >= this.minYear && upperYear <= this.maxYear) {
        this.filterInterval = [this.filterInterval[0], upperYear];
      }
    },

    /**
     * Filters the location data on the map by the given years.
     *
     * @param {Number} lowerYear The lower year boundary
     * @param {Number} upperYear The upper year boundary
     */
    filterLocationData: function filterLocationData(lowerYear, upperYear) {
      var _context,
          _this2 = this;

      var locationLayer = __WEBPACK_IMPORTED_MODULE_6__src_util_Layer__["a" /* default */].getLayerByLid('ids-result-layer', __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this));
      var clusterSource = locationLayer.getSource();
      var locationSource = clusterSource.getSource();

      if (!this.allLocationFeatures) {
        this.allLocationFeatures = locationSource.getFeatures();
      } // check if we have a dataset with time filter property
      // we assume if the first feature doesn't have the whole dataset doesn't


      var firstFeat = this.allLocationFeatures[0];

      if (!this.featuresHaveFilterProp(firstFeat)) {
        return;
      }

      ;

      var filteredFeatures = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = this.allLocationFeatures).call(_context, function (subFeat) {
        var year = subFeat.get(_this2.yearAttribute);

        if (!__WEBPACK_IMPORTED_MODULE_7__util_JsUtil__["a" /* default */].isNumeric(year)) {
          return false; // filter out data with no attribute for a year
        }

        return year >= lowerYear && year <= upperYear;
      }); // reset the old data with newly filtered locations


      locationSource.clear();
      locationSource.addFeatures(filteredFeatures);
    },

    /**
     * Resets the filter to the initial min/max values
     */
    resetFilterInterval: function resetFilterInterval() {
      // set initial filter interval
      this.filterInterval = [this.minYear, this.maxYear];
    },

    /**
     * Checks if the given feature has a time filter property defined in
     * #yearAttribute
     */
    featuresHaveFilterProp: function featuresHaveFilterProp(feat) {
      return feat && __WEBPACK_IMPORTED_MODULE_7__util_JsUtil__["a" /* default */].isNumeric(feat.get(this.yearAttribute));
    }
  }
});

/***/ }),

/***/ "9x2o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ATxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__("xtLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Color__ = __webpack_require__("nF/d");


/**
 * Mixin for colorTheme utils
 */

var ColorTheme = {
  computed: {
    /**
     * Checks if the theme is in dark mode
     * @returns true if dark mode
     */
    isDarkTheme: function isDarkTheme() {
      return this.$vuetify.theme.dark;
    },

    /**
     * Checks the luminance level of the primary color.
     * @returns true if primary is a dark color
     */
    isPrimaryDark: function isPrimaryDark() {
      // Get current theme
      var theme = this.$vuetify.theme.currentTheme;
      var primary = theme.primary; // "primary" can be either an hexa string or
      // an object of hexa string. In the later,
      // we check the luminance for the primary
      // base.

      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(primary) === 'object') {
        primary = primary.base;
      }

      return __WEBPACK_IMPORTED_MODULE_1__util_Color__["a" /* default */].checkLuminance(primary);
    }
  }
};

/***/ }),

/***/ "Bik2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Photon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat__);




// Code modified from: https://github.com/jonataswalker/ol-geocoder version: Aug 01, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//

/**
 * Photon Provider. See https://photon.komoot.de.
 *
 * @class Photon
 */
var Photon = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function Photon() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, Photon);

    this.settings = {
      url: 'https://photon.komoot.de/api/',
      params: {
        q: '',
        limit: 10,
        lang: 'en'
      },
      langs: ['de', 'it', 'fr', 'en']
    };
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(Photon, [{
    key: "getParameters",
    value: function getParameters(options) {
      options.lang = options.lang.toLowerCase();
      return {
        url: this.settings.url,
        params: {
          q: options.query,
          limit: options.limit || this.settings.params.limit,
          lang: this.settings.langs.indexOf(options.lang) > -1 ? options.lang : this.settings.params.lang
        }
      };
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(results) {
      var _context;

      if (!results.features.length) return;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = results.features).call(_context, function (feature) {
        var _context2, _context3, _context4, _context5;

        // Response is GeoJSON
        var geometry = feature.geometry;
        var properties = feature.properties;

        var displayName = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context3 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context4 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context5 = "".concat(properties.name, " ")).call(_context5, properties.city || '', " ")).call(_context4, properties.postcode || '', " ")).call(_context3, properties.state || '', " ")).call(_context2, properties.country || '');

        var result = {
          lon: geometry.coordinates[0],
          lat: geometry.coordinates[1],
          address: {
            name: displayName,
            postcode: properties.postcode || '',
            city: properties.city || '',
            state: properties.state || '',
            country: properties.country || ''
          },
          original: {
            formatted: displayName,
            details: properties
          }
        }; // Sometimes has bbox

        if (properties.extent) {
          result.boundingbox = properties.extent;
        }

        return result;
      });
    }
  }]);

  return Photon;
}();

/***/ }),

/***/ "BjgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"elevation":"8"}},[_c('v-slide-group',{ref:"slideGroup",staticClass:"pa-1",attrs:{"mandatory":"","show-arrows":"","value":_vm.selectedLayer},on:{"change":_vm.onSelectLayer}},_vm._l((_vm.displayedLayers),function(layer){return _c('v-slide-item',{key:layer.lid,attrs:{"value":layer},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-card',{class:{
          'ma-1': true,
          'secondary': active,
          'onsecondary--text': active
        },attrs:{"hover":"","width":_vm.imageWidth},on:{"click":toggle}},[_c('wgu-layerpreviewimage',{attrs:{"layer":layer,"mapView":_vm.map.getView(),"width":_vm.imageWidth,"height":_vm.imageHeight,"previewIcon":_vm.previewIcon}}),_vm._v(" "),_c('v-card-title',{staticClass:"caption"},[_c('span',{staticClass:"d-inline-block text-truncate"},[_vm._v("\n            "+_vm._s(layer.get('name'))+"\n          ")])])],1)]}}],null,true)})}),1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "C8Cu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"color":"secondary","mandatory":""},model:{value:(_vm.measureTypeData),callback:function ($$v) {_vm.measureTypeData=$$v},expression:"measureTypeData"}},[_c('v-btn',{attrs:{"large":"","value":"distance"}},[_vm._v("\n     "+_vm._s(_vm.$t("wgu-measuretool.distance"))+"\n   ")]),_vm._v(" "),_c('v-btn',{attrs:{"large":"","value":"area"}},[_vm._v("\n     "+_vm._s(_vm.$t("wgu-measuretool.area"))+"\n   ")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "DCNi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-app-tpl',[_c('v-btn',{attrs:{"slot":"wgu-tb-after-title","icon":"","dense":"","color":"onprimary"},on:{"click":_vm.openHelpPage},slot:"wgu-tb-after-title"},[_c('v-icon',{attrs:{"color":"onprimary","medium":""}},[_vm._v("help")])],1),_vm._v(" "),_c('div',{staticClass:"ids-agd-logo-ct",attrs:{"slot":"wgu-tb-end"},slot:"wgu-tb-end"},[_c('a',{attrs:{"href":"https://agd.ids-mannheim.de/","target":"_blank"}},[_c('img',{attrs:{"src":"static/img/agd_logo_weiss-1.png","alt":"AGD Logo"}})])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "DgqD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerPreviewImage_vue__ = __webpack_require__("h9kb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_462fe1a7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerPreviewImage_vue__ = __webpack_require__("wHUX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerPreviewImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_462fe1a7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerPreviewImage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_462fe1a7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerPreviewImage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DiDp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card',_vm._b({directives:[{name:"draggable-win",rawName:"v-draggable-win",value:(_vm.cardDraggable),expression:"cardDraggable"}],class:_vm.cardClasses,style:(_vm.cardStyles)},'v-card',_vm.cardAttr,false),[_c('v-img',{attrs:{"src":_vm.backgroundImage}},[_c('v-toolbar',_vm._b({},'v-toolbar',_vm.toolbarAttr,false),[_c('v-icon',{staticClass:"mr-4",attrs:{"color":"onprimary"}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.$t(_vm.moduleName + '.title')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("wgu-win-toolbar"),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.minimizable)?_c('v-btn',{attrs:{"color":"onprimary","icon":"","small":""},on:{"click":function($event){_vm.minimized = !_vm.minimized}}},[(_vm.minimized)?_c('v-icon',[_vm._v("web_asset")]):_c('v-icon',[_vm._v("remove")])],1):_vm._e(),_vm._v(" "),(_vm.closable)?_c('v-btn',{staticClass:"mr-0",attrs:{"color":"onprimary","icon":"","small":""},on:{"click":_vm.toggleUi}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.minimized),expression:"!minimized"}]},[_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "ETGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__ = __webpack_require__("u4kD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17db530_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__ = __webpack_require__("9BwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17db530_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17db530_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EnnV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_LayerLegend__ = __webpack_require__("MZWz");








function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//

/**
 * Module for one legend element.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlegendimage',
  props: {
    mapView: {
      type: Object,
      required: true
    },
    layer: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      resolution: this.mapView.getResolution(),
      viewResolutionChanged: undefined
    };
  },

  /**
   * Register for an event to update the legend on resolution change.
   */
  created: function created() {
    var viewResolutionChanged = function (event) {
      this.resolution = event.target.getResolution();
    }.bind(this);

    this.mapView.on('change:resolution', viewResolutionChanged);
    this.viewResolutionChanged = viewResolutionChanged;
  },

  /**
   * Unregister the event fired on resolution change.
   */
  destroyed: function destroyed() {
    if (this.viewResolutionChanged) {
      this.mapView.un('change:resolution', this.viewResolutionChanged);
    }
  },
  computed: {
    /**
     * Returns a URL to the layers legend image.
     */
    legendURL: function legendURL() {
      var options = _objectSpread({
        language: this.$i18n.locale
      }, this.layer.get('legendOptions'));

      return __WEBPACK_IMPORTED_MODULE_7__util_LayerLegend__["a" /* default */].getUrl(this.layer, this.resolution, options, this.layer.get('legendUrl'));
    }
  }
});

/***/ }),

/***/ "F+zM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_geom_LineString__ = __webpack_require__("grfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_geom_Polygon__ = __webpack_require__("ZYQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__ = __webpack_require__("1avf");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measure-result',
  props: {
    measureGeom: {
      type: Object
    }
  },
  data: function data() {
    return {
      area: ' -- ',
      distance: ' -- '
    };
  },
  watch: {
    measureGeom: function measureGeom() {
      var me = this;
      var geom = me.measureGeom.geom;
      var output;

      if (geom instanceof __WEBPACK_IMPORTED_MODULE_1_ol_geom_Polygon__["a" /* default */]) {
        output = me.formatArea(geom);
        me.area = output;
      } else if (geom instanceof __WEBPACK_IMPORTED_MODULE_0_ol_geom_LineString__["a" /* default */]) {
        output = me.formatLength(geom);
        me.distance = output;
      } else {
        me.area = ' -- ';
        me.distance = ' -- ';
      }
    }
  },
  methods: {
    /**
     * Calculates and formats the length of the given line.
     *
     * @param  {ol.geom.LineString} line The LineString object to calculate length for
     */
    formatLength: function formatLength(line) {
      var length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__["c" /* getLength */])(line);
      var output;

      if (length > 100) {
        output = this.$t('wgu-measuretool.lengthKm', [Math.round(length / 1000 * 100) / 100]);
      } else {
        output = this.$t('wgu-measuretool.lengthMeter', [Math.round(length * 100) / 100]);
      }

      return output;
    },

    /**
     * Calculates and formats the area of the given polygon.
     *
     * @param  {ol.geom.Polygon} polygon The Polygon object to calculate area for
     */
    formatArea: function formatArea(polygon) {
      var area = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__["d" /* getArea */])(polygon);
      var output;

      if (area > 10000) {
        output = this.$t('wgu-measuretool.areaSquareKm', [Math.round(area / 1000000 * 100) / 100]);
      } else {
        output = this.$t('wgu-measuretool.areaSquareMeter', [Math.round(area * 100) / 100]);
      }

      return output;
    }
  }
});

/***/ }),

/***/ "G9tR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerOpacityControl_vue__ = __webpack_require__("kRhf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f9d4ceb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerOpacityControl_vue__ = __webpack_require__("3wTJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerOpacityControl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f9d4ceb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerOpacityControl_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f9d4ceb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerOpacityControl_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GgOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__ = __webpack_require__("0WSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator__ = __webpack_require__("I3KW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WguAppTemplate_vue__ = __webpack_require__("c0QU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_format_GeoJSON__ = __webpack_require__("aUhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_source__ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_layer__ = __webpack_require__("ItK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ids_DgdDataLoader_js__ = __webpack_require__("3GfT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ids_IdsStyleFactory__ = __webpack_require__("bvM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_JsUtil__ = __webpack_require__("kURA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ids_IdsCorpusLookup_js__ = __webpack_require__("9HAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ids_components_filter_IdsFilterModuleWin_vue__ = __webpack_require__("JETI");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-wgu-app',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__src_mixins_Mapable__["a" /* Mapable */]],
  components: {
    'wgu-app-tpl': __WEBPACK_IMPORTED_MODULE_5__WguAppTemplate_vue__["a" /* default */],
    'ids-filter-panel': __WEBPACK_IMPORTED_MODULE_16__ids_components_filter_IdsFilterModuleWin_vue__["a" /* default */]
  },
  // add Vue methods and hooks here
  props: {
    clusterDistance: {
      type: Number,
      required: false,
      default: 20
    },
    clusterMinDistance: {
      type: Number,
      required: false,
      default: 10
    }
  },
  data: function data() {
    return {
      resultLayer: null,
      resultSource: null,
      corpusList: [],
      initLocationsLoaded: false,
      initFilterDataLoaded: false,
      helpPageLink: 'https://agd.ids-mannheim.de'
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.mark(function _callee() {
      var appConfig, baseUrlConf, corpLinkTpl, helpPageLink;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Apply app config
              appConfig = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$appConfig; // set to true in static/app-conf.json to get local API mock data

              __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$devMode = appConfig.ids.devMode; // optional overwrite of the API base URL from app config

              baseUrlConf = appConfig.ids.baseUrl;

              if (baseUrlConf && __WEBPACK_IMPORTED_MODULE_14__util_JsUtil__["a" /* default */].isString(baseUrlConf) && baseUrlConf !== '') {
                __WEBPACK_IMPORTED_MODULE_12__ids_DgdDataLoader_js__["a" /* default */].baseUrl = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$appConfig.ids.baseUrl;
              }

              corpLinkTpl = appConfig.ids.corpusLinkTpl;

              if (corpLinkTpl && __WEBPACK_IMPORTED_MODULE_14__util_JsUtil__["a" /* default */].isString(corpLinkTpl) && corpLinkTpl !== '') {
                __WEBPACK_IMPORTED_MODULE_15__ids_IdsCorpusLookup_js__["a" /* default */].corpusLinkTpl = corpLinkTpl;
              }

              helpPageLink = appConfig.ids.helpPageLink;

              if (helpPageLink && __WEBPACK_IMPORTED_MODULE_14__util_JsUtil__["a" /* default */].isString(helpPageLink) && helpPageLink !== '') {
                _this.helpPageLink = helpPageLink;
              } // set initial corpus IDs for map data and selection in filter UI


              if (appConfig.ids.initialCorpusIds && Array.isArray(appConfig.ids.initialCorpusIds)) {
                __WEBPACK_IMPORTED_MODULE_15__ids_IdsCorpusLookup_js__["a" /* default */].initialCorpusIds = appConfig.ids.initialCorpusIds;
              } // set cluster distance (min. distance in pixels between clusters)


              _this.clusterDistance = __WEBPACK_IMPORTED_MODULE_14__util_JsUtil__["a" /* default */].isNumeric(appConfig.ids.mapClusterDistance) ? parseInt(appConfig.ids.mapClusterDistance) : _this.clusterDistance; // END Apply app config
              // signal that filter base data is loaded (corpus list, ...)

              __WEBPACK_IMPORTED_MODULE_7__src_WguEventBus__["a" /* WguEventBus */].$on('ids-filter-base-data-load', function () {
                _this.initFilterDataLoaded = true;

                _this.checkForInitialDataLoaded();
              }); // workaround timeout of 1 to make this work

              setTimeout(function () {
                // hide and decrease size of the sidebar for small mobile screens
                if (_this.$vuetify.breakpoint.xs) {
                  __WEBPACK_IMPORTED_MODULE_7__src_WguEventBus__["a" /* WguEventBus */].$emit('sidebar-toggle');
                }
              }, 1);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    onMapBound: function onMapBound() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // show loading mask on startup
                __WEBPACK_IMPORTED_MODULE_7__src_WguEventBus__["a" /* WguEventBus */].$emit('app-loading-mask-toggle', true);
                __WEBPACK_IMPORTED_MODULE_7__src_WguEventBus__["a" /* WguEventBus */].$on('ids-new-locations-load', _this2.updateLocationLayer);

                _this2.createResultClusterLayer(); // load base data, such as corpus list


                _context2.next = 5;
                return _this2.loadInitialData();

              case 5:
                _this2.loadInitialLocations();

                _this2.registerMapClick();

                _this2.setInitialFilters();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * Loads the initial data
     * default dataset (Ortsdaten) for the application and
     * adds it to the source of the result layer.
     */
    loadInitialData: function loadInitialData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__ids_DgdDataLoader_js__["a" /* default */].getCorpusList();

              case 2:
                _this3.corpusList = _context3.sent;
                // save in lookup, so we can access data app-wide
                __WEBPACK_IMPORTED_MODULE_15__ids_IdsCorpusLookup_js__["a" /* default */].setCorpusList(_this3.corpusList);
                __WEBPACK_IMPORTED_MODULE_7__src_WguEventBus__["a" /* WguEventBus */].$emit('ids-corpus-list-load'); // TODO load more data if needed ...

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * Creates a clustered vector layer for the results data (Ortsdaten) and
     * adds it to the map.
     */
    createResultClusterLayer: function createResultClusterLayer() {
      var source = new __WEBPACK_IMPORTED_MODULE_9_ol_source__["a" /* Vector */]({}); // empty vector source

      var clusterSource = new __WEBPACK_IMPORTED_MODULE_9_ol_source__["b" /* Cluster */]({
        distance: this.clusterDistance,
        source: source
      }); // de-cluster helper layer

      var declusterSource = new __WEBPACK_IMPORTED_MODULE_9_ol_source__["a" /* Vector */]();
      var declusterLayer = new __WEBPACK_IMPORTED_MODULE_10_ol_layer__["a" /* Vector */]({
        name: 'ids-decluster-layer',
        lid: 'ids-decluster-layer',
        source: declusterSource
      });

      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).addLayer(declusterLayer);

      var clusters = new __WEBPACK_IMPORTED_MODULE_10_ol_layer__["a" /* Vector */]({
        lid: 'ids-result-layer',
        source: clusterSource
      });

      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).addLayer(clusters);

      var styleCache = {};
      var clusterStyle = __WEBPACK_IMPORTED_MODULE_13__ids_IdsStyleFactory__["a" /* default */].createClusterStyle(styleCache, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this));
      clusters.setStyle(clusterStyle); // make accessible as members

      this.locationLayer = clusters;
      this.locationSource = source;
      this.locationDeclusterLayer = declusterLayer;
      this.locationDeclusterSource = declusterLayer.getSource();
    },

    /**
     * Registers a click handler on the map in order to zoom to cluster
     * features when clicking a cluster.
     */
    registerMapClick: function registerMapClick() {
      var _this4 = this;

      // zoom to cluster features on click
      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).on('click', function (e) {
        _this4.locationLayer.getFeatures(e.pixel).then(function (clickedClusterFeats) {
          if (clickedClusterFeats.length) {
            // get clustered coordinates
            var features = clickedClusterFeats[0].get('features'); // currently points at same location prevent this

            if (features.length > 1) {
              var extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_ol_extent__["a" /* boundingExtent */])(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(features).call(features, function (r) {
                return r.getGeometry().getCoordinates();
              })); // zoom to cluster extent

              __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this4).getView().fit(extent, {
                duration: 1000,
                padding: [50, 50, 50, 50],
                maxZoom: 18
              });
            }
          }
        });
      });
    },

    /**
     * Loads the initial data
     * default dataset (Ortsdaten) for the application and
     * adds it to the source of the result layer.
     */
    loadInitialLocations: function loadInitialLocations() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.mark(function _callee4() {
        var initCorpusIds, initCorpusSelectionObj, locationType, personType, geoJsonData;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                initCorpusIds = __WEBPACK_IMPORTED_MODULE_15__ids_IdsCorpusLookup_js__["a" /* default */].initialCorpusIds;
                initCorpusSelectionObj = __WEBPACK_IMPORTED_MODULE_15__ids_IdsCorpusLookup_js__["a" /* default */].getSelectionObjectByArr(initCorpusIds); // TODO make all defaults configurable

                locationType = ['Aufnahmeort'];
                personType = 'Sprecher'; // load 'Ortsdaten' as GeoJSON

                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_12__ids_DgdDataLoader_js__["a" /* default */].getLocationList(initCorpusSelectionObj, locationType, personType);

              case 6:
                geoJsonData = _context4.sent;

                _this5.updateLocationLayer(geoJsonData); // signal that initial locations are loaded


                __WEBPACK_IMPORTED_MODULE_7__src_WguEventBus__["a" /* WguEventBus */].$emit('ids-init-locations-load');
                _this5.initLocationsLoaded = true;

                _this5.checkForInitialDataLoaded();

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },

    /**
     * Checks if the initial data is loaded and hides the loading mask
     */
    checkForInitialDataLoaded: function checkForInitialDataLoaded() {
      if (this.initLocationsLoaded && this.initFilterDataLoaded) {
        // hide loading mask
        __WEBPACK_IMPORTED_MODULE_7__src_WguEventBus__["a" /* WguEventBus */].$emit('app-loading-mask-toggle', false);
      }
    },

    /**
     * Handler for app-wide 'ids-new-locations-load' event
     * (see IdsFilterModuleWin).
     * Updates the location layer with the given GeoJSON features.
     *
     * @param {Object} GeoJSON FeatureCollection
     */
    updateLocationLayer: function updateLocationLayer(geoJsonData) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.mark(function _callee5() {
        var geojsonParser, features, extent;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // parse GeoJSON
                geojsonParser = new __WEBPACK_IMPORTED_MODULE_8_ol_format_GeoJSON__["a" /* default */]({
                  featureProjection: 'EPSG:3857'
                });
                features = geojsonParser.readFeatures(geoJsonData); // clear old features

                _this6.locationSource.clear();

                _this6.locationDeclusterSource.clear(); // add new features


                _this6.locationSource.addFeatures(features); // zoom map to new features


                extent = _this6.locationSource.getExtent();

                __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this6).getView().fit(extent, {
                  duration: 1000,
                  padding: [50, 50, 50, 50],
                  maxZoom: 18
                });

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    /**
     * Sets the initial filters in our global app-wide filter state object.
     */
    setInitialFilters: function setInitialFilters() {},

    /**
     * Opens the help page by opening the link in a new browser tab.
     */
    openHelpPage: function openHelpPage() {
      window.open(this.helpPageLink, '_blank');
    }
  }
});

/***/ }),

/***/ "H6Sa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__ = __webpack_require__("0WSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator__ = __webpack_require__("I3KW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IdsGeoSelector_vue__ = __webpack_require__("ijcu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_JsUtil__ = __webpack_require__("kURA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DgdDataLoader__ = __webpack_require__("3GfT");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ids-geographic-filter',
  components: {
    'ids-geo-selector': __WEBPACK_IMPORTED_MODULE_2__IdsGeoSelector_vue__["a" /* default */]
  },
  props: {
    countries: {
      type: Array,
      required: true
    },
    countrySelection: {
      type: Object,
      required: false
    },
    regionSelection: {
      type: Object,
      required: false
    },
    districtSelection: {
      type: Object,
      required: false
    },
    locationType: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      regions: [],
      districts: [],
      dataCountrySelection: __WEBPACK_IMPORTED_MODULE_3__util_JsUtil__["a" /* default */].cloneObject(this.countrySelection),
      dataRegionSelection: __WEBPACK_IMPORTED_MODULE_3__util_JsUtil__["a" /* default */].cloneObject(this.regionSelection),
      dataDistrictSelection: __WEBPACK_IMPORTED_MODULE_3__util_JsUtil__["a" /* default */].cloneObject(this.districtSelection),
      countryLoading: false,
      regionLoading: false,
      districtLoading: false
    };
  },
  watch: {
    locationType: function locationType(newValue) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // when location type changes we need to reset and reload the select boxes
                _this.setNewCountry({
                  clientId: null
                }); // => reset selects
                // re-load the countries for changed location type


                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__DgdDataLoader__["a" /* default */].getCountryList(_this.locationType);

              case 3:
                _this.regions = _context.sent;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    // restore the prev. selection without resetting as it would be on
    // selection of a user
    var skipReset = true;

    if (this.dataCountrySelection) {
      this.setNewCountry(this.dataCountrySelection, skipReset);
    }

    if (this.dataCountrySelection) {
      this.setNewRegion(this.dataRegionSelection, skipReset);
    }

    if (this.dataDistrictSelection) {
      this.setNewDistrict(this.dataDistrictSelection);
    }
  },
  computed: {
    showRegion: function showRegion() {
      return __WEBPACK_IMPORTED_MODULE_3__util_JsUtil__["a" /* default */].isObject(this.dataCountrySelection);
    },
    showDistrict: function showDistrict() {
      return __WEBPACK_IMPORTED_MODULE_3__util_JsUtil__["a" /* default */].isObject(this.dataRegionSelection);
    }
  },
  methods: {
    /**
     * Handler for 'ids-geo-selection-change' of <ids-geo-selector>.
     */
    onGeoSelectionChange: function onGeoSelectionChange(geoType, newGeoObj) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee2() {
        var geoObj;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                geoObj = newGeoObj;

                if (geoType === 'country') {
                  _this2.setNewCountry(geoObj);
                } else if (geoType === 'region') {
                  _this2.setNewRegion(geoObj);
                } else if (geoType === 'district') {
                  _this2.setNewDistrict(geoObj);
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * Sets the new country selection and loads underlying regions.
     */
    setNewCountry: function setNewCountry(countryObj, skipReset) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(countryObj.clientId === null)) {
                  _context3.next = 4;
                  break;
                }

                _this3.resetRegion();

                _this3.resetCountry();

                return _context3.abrupt("return");

              case 4:
                _this3.dataCountrySelection = countryObj;

                _this3.$emit('ids-geog-filter-change', 'country', countryObj);

                if (!skipReset) {
                  _this3.resetRegion(); // reset data and UI

                }

                if (!countryObj) {
                  _context3.next = 13;
                  break;
                }

                // show loading indicator
                _this3.regionLoading = true; // load dependent data

                _context3.next = 11;
                return __WEBPACK_IMPORTED_MODULE_4__DgdDataLoader__["a" /* default */].getRegionList(countryObj.clientId, _this3.locationType);

              case 11:
                _this3.regions = _context3.sent;
                // hide loading indicator
                _this3.regionLoading = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * Sets the new region selection and loads underlying districts.
     */
    setNewRegion: function setNewRegion(regionObj, skipReset) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(regionObj.clientId === null)) {
                  _context4.next = 3;
                  break;
                }

                _this4.resetRegion();

                return _context4.abrupt("return");

              case 3:
                _this4.dataRegionSelection = regionObj;

                _this4.$emit('ids-geog-filter-change', 'region', regionObj);

                if (!skipReset) {
                  _this4.resetDistrict(); // reset data and UI

                }

                if (!regionObj) {
                  _context4.next = 12;
                  break;
                }

                // show loading indicator
                _this4.districtLoading = true; // load dependent data

                _context4.next = 10;
                return __WEBPACK_IMPORTED_MODULE_4__DgdDataLoader__["a" /* default */].getDistrictList(_this4.dataCountrySelection.clientId, regionObj.clientId, _this4.locationType);

              case 10:
                _this4.districts = _context4.sent;
                // hide loading indicator
                _this4.districtLoading = false;

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },

    /**
     * Sets the new district selection.
     */
    setNewDistrict: function setNewDistrict(districtObj) {
      if (districtObj.clientId === null) {
        this.resetDistrict();
        return;
      }

      this.dataDistrictSelection = districtObj;
      this.$emit('ids-geog-filter-change', 'district', districtObj);
    },

    /**
     * Resets the country data and selection in UI
     */
    resetCountry: function resetCountry() {
      this.dataCountrySelection = null;

      if (this.$refs && this.$refs.idsCountrySelector) {
        this.$refs.idsCountrySelector.dataSelection = null; // workaround
      }

      this.$emit('ids-geog-filter-change', 'country', null);
    },

    /**
     * Resets the region data and selection in UI
     */
    resetRegion: function resetRegion() {
      // first reset underlying district selector
      this.resetDistrict();
      this.dataRegionSelection = null;

      if (this.$refs && this.$refs.idsRegionSelector) {
        this.$refs.idsRegionSelector.dataSelection = null; // workaround
      }

      this.$emit('ids-geog-filter-change', 'region', null);
    },

    /**
     * Resets the district data and selection in UI
     */
    resetDistrict: function resetDistrict() {
      this.dataDistrictSelection = null;

      if (this.$refs && this.$refs.idsDistrictSelector) {
        this.$refs.idsDistrictSelector.dataSelection = null; // workaround
      }

      this.$emit('ids-geog-filter-change', 'district', null);
    }
  }
});

/***/ }),

/***/ "HD/1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OverviewMapController__ = __webpack_require__("aDNC");




//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-overviewmap-panel',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_Mapable__["a" /* Mapable */]],
  props: {
    rotateWithView: {
      type: Boolean,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      layers: []
    };
  },
  mounted: function mounted() {
    this.createOverviewMapCtrl();
  },
  destroyed: function destroyed() {
    this.destroyOverviewMapCtrl();
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound: function onMapBound() {
      this.layers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray();
      this.createOverviewMapCtrl();
    },

    /**
     * This function is executed, before the map is unbound (see mixins/Mapable)
     */
    onMapUnbound: function onMapUnbound() {
      this.destroyOverviewMapCtrl();
    },

    /**
     * Creates the OpenLayers overview map control.
     */
    createOverviewMapCtrl: function createOverviewMapCtrl() {
      var panel = this.$refs.overviewmapPanel;

      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this) && panel && !this.overviewMap) {
        this.overviewMap = new __WEBPACK_IMPORTED_MODULE_5__OverviewMapController__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this), panel.$el, this.$props);
      }
    },

    /**
     * Tears down the OpenLayers overview map control.
     */
    destroyOverviewMapCtrl: function destroyOverviewMapCtrl() {
      if (this.overviewMap) {
        this.overviewMap.destroy();
        this.overviewMap = undefined;
      }
    }
  },
  computed: {
    /**
     * Reactive property to return the currently visible OpenLayers background layer.
     * To disambiguate multiple selected background layers - which may occur programmatically -
     * this returns the first in the list of background layers.
     */
    selectedBgLayer: function selectedBgLayer() {
      var _context, _context2;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context2 = this.layers).call(_context2, function (layer) {
        return layer.get('isBaseLayer');
      }).reverse()).call(_context, function (layer) {
        return layer.getVisible();
      });
    }
  },
  watch: {
    /**
     * Watch for background layer selection change.
     */
    selectedBgLayer: function selectedBgLayer() {
      this.overviewMap.setLayer(this.selectedBgLayer);
    }
  }
});

/***/ }),

/***/ "HrcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{ 'wgu-app': true, 'wgu-app-embedded': _vm.isEmbedded },attrs:{"id":"wgu-app","data-app":""}},[_vm._t("wgu-app-begin"),_vm._v(" "),_c('wgu-app-header',[_vm._t("wgu-tb-start",null,{"slot":"wgu-tb-start"}),_vm._v(" "),_vm._t("wgu-tb-after-title",null,{"slot":"wgu-tb-after-title"}),_vm._v(" "),_vm._t("wgu-tb-before-auto-buttons",null,{"slot":"wgu-tb-before-auto-buttons"}),_vm._v(" "),_vm._t("wgu-tb-after-auto-buttons",null,{"slot":"wgu-tb-after-auto-buttons"}),_vm._v(" "),_vm._t("wgu-tb-end",null,{"slot":"wgu-tb-end"})],2),_vm._v(" "),_vm._t("wgu-after-header"),_vm._v(" "),(_vm.sidebarWins.length)?_c('wgu-app-sidebar',_vm._b({},'wgu-app-sidebar',_vm.sidebarConfig,false),[_vm._l((_vm.sidebarWins),function(moduleWin,index){return [_c(moduleWin.type,_vm._b({key:index,tag:"component"},'component',moduleWin,false))]})],2):_vm._e(),_vm._v(" "),_vm._t("wgu-before-content"),_vm._v(" "),_c('v-content',{attrs:{"app":""}},[_c('v-container',{staticClass:"pa-0",attrs:{"id":"ol-map-container","fluid":"","fill-height":""}},[_c('wgu-map'),_vm._v(" "),_c('wgu-maploading-status'),_vm._v(" "),_vm._t("wgu-after-map"),_vm._v(" "),_c('portal-target',{attrs:{"name":"map-overlay"}}),_vm._v(" "),_c('wgu-app-logo'),_vm._v(" "),_c('wgu-bglayerswitcher'),_vm._v(" "),(_vm.overviewMapConfig)?_c('wgu-overviewmap',_vm._b({},'wgu-overviewmap',_vm.overviewMapConfig,false)):_vm._e(),_vm._v(" "),_c('wgu-hover-tooltip')],2)],1),_vm._v(" "),_vm._l((_vm.floatingWins),function(moduleWin,index){return [_c(moduleWin.type,_vm._b({key:index,tag:"component"},'component',moduleWin,false))]}),_vm._v(" "),_vm._t("wgu-before-footer"),_vm._v(" "),_c('wgu-app-footer',{attrs:{"footerTextLeft":_vm.$t('app.footerTextLeft'),"footerTextRight":_vm.$t('app.footerTextRight'),"showCopyrightYear":_vm.showCopyrightYear}}),_vm._v(" "),_vm._t("wgu-after-footer"),_vm._v(" "),_c('wgu-app-loading-mask'),_vm._v(" "),_vm._t("wgu-app-end")],2)}
var staticRenderFns = []


/***/ }),

/***/ "HyBD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LayerPreviewImage__ = __webpack_require__("DgqD");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-bglayerlist',
  components: {
    'wgu-layerpreviewimage': __WEBPACK_IMPORTED_MODULE_6__LayerPreviewImage__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Mapable__["a" /* Mapable */]],
  props: {
    imageWidth: {
      type: Number,
      required: true
    },
    imageHeight: {
      type: Number,
      required: true
    },
    previewIcon: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      layers: []
    };
  },
  mounted: function mounted() {
    // Work around a bug in vuetify which doesn't realize the overflow of slideGroups properly,
    // when the control is initially rendered. The underlying implementation relies on the clientWidth
    // property of DOM elements, which is not computed on mount time. The bug is related to
    // https://github.com/vuejs/Discussion/issues/394 .The following works in Firefox and Chrome.
    var slideGroup = this.$refs.slideGroup;

    if (slideGroup) {
      this.timerHandle = setTimeout(function () {
        slideGroup.onResize();
      }, 10);
    }
  },
  destroyed: function destroyed() {
    if (this.timerHandle) {
      clearTimeout(this.timerHandle);
    }
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound: function onMapBound() {
      this.layers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray();
    },

    /**
     * Handler for click on item in layer list:
     * Set the selected background layer to visible and hide all other background layers.
     * @param  {Object} selLayer  Layer selected by the user
     */
    onSelectLayer: function onSelectLayer(selLayer) {
      var _context;

      selLayer.setVisible(true);

      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = this.displayedLayers).call(_context, function (layer) {
        return layer !== selLayer;
      }).forEach(function (layer) {
        layer.setVisible(false);
      });
    }
  },
  computed: {
    /**
     * Reactive property to return the OpenLayers layers marked as 'isBaseLayer'.
     */
    displayedLayers: function displayedLayers() {
      var _context2;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context2 = this.layers).call(_context2, function (layer) {
        return layer.get('isBaseLayer');
      }).reverse();
    },

    /**
     * Reactive property to return the currently visible OpenLayers background layer.
     * To disambiguate multiple selected background layers - which may occur programmatically -
     * this returns the first in the list of background layers.
     */
    selectedLayer: function selectedLayer() {
      var _context3;

      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context3 = this.displayedLayers).call(_context3, function (layer) {
        return layer.getVisible();
      });
    }
  }
});

/***/ }),

/***/ "I1J2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('v-progress-circular',{staticClass:"wgu-maploading-status",attrs:{"value":80,"indeterminate":"","color":"secondary"}}):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "IIm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HoverController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray__ = __webpack_require__("mF7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_promise__ = __webpack_require__("SBIS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_source_TileWMS__ = __webpack_require__("DwLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_source_ImageWMS__ = __webpack_require__("j0xK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_source_VectorTile__ = __webpack_require__("hGhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_format_WMSGetFeatureInfo__ = __webpack_require__("P2CA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);














var HoverController = /*#__PURE__*/function () {
  /**
   * Initializes the map hover functionality:
   * Adds a little tooltip like DOM element, wrapped as OL Overlay to the
   * map.
   * Registers a 'pointermove' event on the map and shows the layer's
   * 'hoverAttribute' if the layer is configured as 'hoverable'
   *
   * @param {ol.Map} map OpenLayers map.
   * @param {Number} pointerRestInterval Timespan in milliseconds, by which displaying the tooltip is deferred.
   */
  function HoverController(map, pointerRestInterval) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck___default()(this, HoverController);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_defineProperty___default()(this, "DEFAULT_POINTER_REST_INTERVAL", 150);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_defineProperty___default()(this, "DEFAULT_HOVER_OVERLAY", 'wgu-hover-tooltip');

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_defineProperty___default()(this, "map", null);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_defineProperty___default()(this, "timerHandle", null);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_defineProperty___default()(this, "activeOverlayId", null);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_defineProperty___default()(this, "pendingRequestsCancelSrc", null);

    var me = this;
    me.map = map; // To limit the amount of asynchronous requests, implement a "pointer rest" behavior,
    // which will potentially show a tooltip after the mouse has not moved for a given time period.

    var timeout = pointerRestInterval !== null && pointerRestInterval !== void 0 ? pointerRestInterval : me.DEFAULT_POINTER_REST_INTERVAL;
    map.on('pointermove', function (event) {
      if (me.timerHandle) {
        clearTimeout(me.timerHandle);
      }

      me.timerHandle = setTimeout(function () {
        me.onPointerRest(event);
      }, timeout);
    });
  }
  /**
   * Tears down this controller.
   */


  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass___default()(HoverController, [{
    key: "destroy",
    value: function destroy() {
      var me = this;

      if (me.timerHandle) {
        clearTimeout(me.timerHandle);
        me.timerHandle = null;
      }

      if (me.pendingRequestsCancelSrc) {
        me.pendingRequestsCancelSrc.cancel();
        me.pendingRequestsCancelSrc = null;
      }

      if (me.activeOverlayId) {
        __WEBPACK_IMPORTED_MODULE_11__WguEventBus__["a" /* WguEventBus */].$emit(me.activeOverlayId + '-update-overlay', false);
        me.activeOverlayId = null;
      }

      me.map = null;
    }
    /**
     * Shows the hover tooltip on the map if an appropriate feature of a
     * 'hoverable' layer was hit with the mouse. In the case of overlapping features,
     * only the first detected feature is displayed.
     * @param  {Object} event The OL event for pointermove
     */

  }, {
    key: "onPointerRest",
    value: function onPointerRest(event) {
      var me = this;

      var map = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_map___default()(me);

      var pixel = event.pixel;
      var coordinate = event.coordinate;
      var cancelToken = __WEBPACK_IMPORTED_MODULE_12_axios___default.a.CancelToken;
      var featureInfos = [];
      var resetTooltip = true; // Cancel pending requests and create a new cancel token source which corresponds
      // to all async requests sent in this iteration.

      if (me.pendingRequestsCancelSrc) {
        me.pendingRequestsCancelSrc.cancel();
      }

      me.pendingRequestsCancelSrc = cancelToken.source(); // Acquire features for all layers.

      map.forEachLayerAtPixel(pixel, function (layer) {
        if (!layer.get('hoverable')) {
          return;
        }

        var source = layer.getSource();

        if (source instanceof __WEBPACK_IMPORTED_MODULE_6_ol_source_TileWMS__["a" /* default */] || source instanceof __WEBPACK_IMPORTED_MODULE_7_ol_source_ImageWMS__["a" /* default */]) {
          resetTooltip = false;
          me.getWMSFeaturesAsync(map, layer, coordinate, me.pendingRequestsCancelSrc).then(function (features) {
            featureInfos.push.apply(featureInfos, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_map___default()(features).call(features, function (feat) {
              return {
                layer: layer,
                feature: feat
              };
            })));
            me.displayTooltip(featureInfos, coordinate);
          }).catch(function (error) {
            if (!__WEBPACK_IMPORTED_MODULE_12_axios___default.a.isCancel(error)) {
              console.error(error.message);
            }
          });
        } else if (source instanceof __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__["a" /* default */] || source instanceof __WEBPACK_IMPORTED_MODULE_9_ol_source_VectorTile__["a" /* default */]) {
          resetTooltip = false;
          var features = me.getVectorFeatures(map, layer, pixel);
          featureInfos.push.apply(featureInfos, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_map___default()(features).call(features, function (feat) {
            return {
              layer: layer,
              feature: feat
            };
          })));
          me.displayTooltip(featureInfos, coordinate);
        }
      });

      if (resetTooltip) {
        me.displayTooltip(null);
      }
    }
    /**
     * Get the features of a vector layer at the current pixel.
     * @param {ol.Map} map OpenLayers map.
     * @param {ol.layer.Vector | ol/layer/VectorTile} layer The layer to acquire the features for.
     * @param {ol.pixel} pixel The pixel on the viewport.
     * @returns {Array<ol.Feature>}
     */

  }, {
    key: "getVectorFeatures",
    value: function getVectorFeatures(map, layer, pixel) {
      var features = map.getFeaturesAtPixel(pixel, {
        layerFilter: function layerFilter(layerCand) {
          return layerCand === layer;
        }
      });
      return features;
    }
    /**
     * Get the features of a vector layer at the current pixel.
     * @param {ol.Map} map OpenLayers map.
     * @param {ol.layer.Tile | ol.layer.Image} layer The layer to acquire the features for.
     * @param {ol.Coordinate} coordinate The coordinate in map projection.
     * @param {axios.CancelTokenSource} cancelTokenSrc An optional cancel token to abort the request.
     * @returns {Promise<Array<ol.Feature>>}
     */

  }, {
    key: "getWMSFeaturesAsync",
    value: function getWMSFeaturesAsync(map, layer, coordinate, cancelTokenSrc) {
      var view = map.getView();
      return new __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_promise___default.a(function (resolve, reject) {
        var url = layer.getSource().getFeatureInfoUrl(coordinate, view.getResolution(), view.getProjection(), {
          'INFO_FORMAT': 'application/vnd.ogc.gml/3.1.1'
        });

        if (!url) {
          reject(new Error('URL is undefined'));
        }

        var request = {
          method: 'GET',
          url: url,
          cancelToken: cancelTokenSrc === null || cancelTokenSrc === void 0 ? void 0 : cancelTokenSrc.token
        };
        __WEBPACK_IMPORTED_MODULE_12_axios___default()(request).then(function (response) {
          var features = new __WEBPACK_IMPORTED_MODULE_10_ol_format_WMSGetFeatureInfo__["a" /* default */]().readFeatures(response.data);
          resolve(features);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
    /**
     * Displays a tooltip for the first feature among featureInfos.
     * If no feature is present, hide the active hover tooltip.
     * @param {Array} featureInfos List of features with their respective layers.
     * @param {*} coordinate Coordinate in map projection of the mouse cursor.
     */

  }, {
    key: "displayTooltip",
    value: function displayTooltip(featureInfos, coordinate) {
      var me = this;

      if (!featureInfos || featureInfos.length === 0) {
        if (me.activeOverlayId) {
          __WEBPACK_IMPORTED_MODULE_11__WguEventBus__["a" /* WguEventBus */].$emit(me.activeOverlayId + '-update-overlay', false);
          me.activeOverlayId = null;
        }

        return;
      }

      var featureInfo = featureInfos[0];
      var feature = featureInfo.feature;
      var layer = featureInfo.layer;
      var hoverAttr = layer.get('hoverAttribute');
      var overlayId = layer.get('hoverOverlay') || me.DEFAULT_HOVER_OVERLAY;

      if (me.activeOverlayId !== overlayId) {
        __WEBPACK_IMPORTED_MODULE_11__WguEventBus__["a" /* WguEventBus */].$emit(me.activeOverlayId + '-update-overlay', false);
      }

      ;
      __WEBPACK_IMPORTED_MODULE_11__WguEventBus__["a" /* WguEventBus */].$emit(overlayId + '-update-overlay', true, coordinate, {
        feature: feature,
        hoverAttribute: hoverAttr
      });
      me.activeOverlayId = overlayId;
    }
  }]);

  return HoverController;
}();



/***/ }),

/***/ "IJqu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-layerlist",attrs:{"moduleName":"wgu-layerlist","icon":_vm.icon}},'wgu-module-card',_vm.$attrs,false),[_c('wgu-layerlist',{attrs:{"showLegends":_vm.showLegends,"showOpacityControls":_vm.showOpacityControls}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "ILVl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapRecorderWin_vue__ = __webpack_require__("1iCm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3aa56b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapRecorderWin_vue__ = __webpack_require__("Yg4S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapRecorderWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3aa56b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapRecorderWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3aa56b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapRecorderWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Iw4/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J/cV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":"onprimary","title":_vm.$t('wgu-zoomtomaxextent.title')},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []


/***/ }),

/***/ "JETI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsFilterModuleWin_vue__ = __webpack_require__("SrJs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dcf406b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsFilterModuleWin_vue__ = __webpack_require__("XxAX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fHet")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5dcf406b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsFilterModuleWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dcf406b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsFilterModuleWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dcf406b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsFilterModuleWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jzb7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K6sL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_Overlay__ = __webpack_require__("kZ1N");


//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-map-overlay',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Mapable__["a" /* Mapable */]],
  inheritAttrs: false,
  props: {
    overlayId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: false,
      default: true
    },
    offset: {
      type: Array,
      required: false,
      default: undefined
    },
    positioning: {
      type: String,
      required: false,
      default: 'top-left'
    },
    coordinates: {
      type: Array,
      required: false,
      default: undefined
    },
    autoPan: {
      type: Boolean,
      required: false,
      default: false
    },
    autoPanDuration: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: function data() {
    return {
      show: this.visible,
      position: this.coordinates,
      olOverlay: null,
      contentData: null
    };
  },

  /**
   * Register for an event to update the overlays visiblity, position and content.
   */
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$on(this.overlayId + '-update-overlay', this.onUpdateOverlay);
  },

  /**
   * Destroy the overlay component.
   */
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$off(this.overlayId + '-update-overlay', this.onUpdateOverlay);
    this.destroyOlOverlay();
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Create the overlay if visible.
     */
    onMapBound: function onMapBound() {
      if (this.show) {
        this.createOlOverlay();
      }
    },

    /**
     * Event handler to update the overlays visibility, position and content.
     * The derived class can receive the content inside it's slot scope, in case
     * the overlay is populated with dynamic data.
     */
    onUpdateOverlay: function onUpdateOverlay(visible, position, data) {
      if (visible) {
        this.position = position;
        this.contentData = data;
      }

      this.show = visible;
    },

    /**
     * Creates the OpenLayers overlay control and adds it to the map.
     */
    createOlOverlay: function createOlOverlay() {
      if (!this.olOverlay) {
        var overlayContainer = this.$refs.overlayContainer;
        this.olOverlay = new __WEBPACK_IMPORTED_MODULE_4_ol_Overlay__["a" /* default */]({
          element: overlayContainer,
          id: this.overlayId,
          offset: this.offset,
          positioning: this.positioning,
          position: this.position,
          autoPan: this.autoPan,
          autoPanAnimation: {
            autoPanDuration: this.autoPanDuration
          }
        });

        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).addOverlay(this.olOverlay);
      }
    },

    /**
     * Destroys the OpenLayers overlay control and removes it from the map.
     */
    destroyOlOverlay: function destroyOlOverlay() {
      if (this.olOverlay) {
        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).removeOverlay(this.olOverlay);

        this.olOverlay = undefined;
      }
    }
  },
  watch: {
    /**
     * Create / destroy the OpenLayers overlay control when the visibility toggles.
     */
    show: function show() {
      if (this.show) {
        this.createOlOverlay();
      } else {
        this.destroyOlOverlay();
      }
    },

    /**
     * Update the position of the OpenLayers overlay control.
     */
    position: function position() {
      if (this.olOverlay) {
        this.olOverlay.setPosition(this.position);
      }
    }
  }
});

/***/ }),

/***/ "Kp7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-loading-mask',
  components: {},
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$on('app-loading-mask-toggle', function (visible) {
      // toggle or force a visibility of the loading mask
      if (typeof visible === 'boolean') {
        _this.show = visible;
      } else {
        _this.show = !_this.show;
      }
    });
  }
});

/***/ }),

/***/ "KzfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);



/**
 * Util to generate URL params based filters.
 */
var IdsFilterGenerator = {
  /**
   * Creates the filter URL params for the given filter state / data.
   *
   * @param {String} locationTypeSelection
   * @param {Object} corpusSelection
   * @param {Object} [geographicSelection=Null]
   * @returns {String} The filter as URL params
   */
  createFilter: function createFilter(locationTypeSelection, corpusSelection, geographicSelection) {
    var locTypeFilter = IdsFilterGenerator.createLocationTypeFilter(locationTypeSelection);
    var filter;

    if (geographicSelection && geographicSelection.countrySelection) {
      var _context;

      var geogFilter = IdsFilterGenerator.createGeographicFilter(geographicSelection);
      filter = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context = "".concat(locTypeFilter, "&")).call(_context, geogFilter);
    } else if (corpusSelection) {
      var _context2;

      var corpusFilter = IdsFilterGenerator.createCorpusFilter(corpusSelection);
      filter = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context2 = "".concat(corpusFilter, "&")).call(_context2, locTypeFilter);
    }

    return filter;
  },

  /**
   * Creates the filter URL param for the given location type selection.
   *
   * @param {String} locationTypeSelection Single location type selection
   * @returns {String} The filter as URL param 'v_ortstyp=Aufnahmeort'
   */
  createLocationTypeFilter: function createLocationTypeFilter(locationTypeSelection) {
    return 'v_ortstyp=' + locationTypeSelection;
  },

  /**
   * Creates the filter URL param for the given location type selection array.
   *
   * NOT IN USE AT THE MOMENT
   *
   * @param {Array} locationTypeSelection location type selection
   * @returns {String} The filter as URL param 'v_ortstyp=foo|bar'
   */
  createLocationTypeFilterMulti: function createLocationTypeFilterMulti(locationTypeSelection) {
    // remove null items
    var selectionWoNulls = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(locationTypeSelection).call(locationTypeSelection, function (item) {
      return item !== null;
    });

    var filterVal = selectionWoNulls.join('|');
    return 'v_ortstyp=' + filterVal;
  },

  /**
   * Creates the filter URL param for the given corpus selection selection.
   *
   * @param {Array} corpusSelection location type selection
   * @returns {String} The filter as URL param 'v_location_type=...'
   */
  createCorpusFilter: function createCorpusFilter(corpusSelection) {
    // iterate all selections based on corpus category
    var mergedSelection = [];

    for (var category in corpusSelection) {
      var _context3;

      // merges and removes duplicates
      mergedSelection = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat___default()(mergedSelection).call(mergedSelection, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context3 = corpusSelection[category]).call(_context3, function (item) {
        return item !== null && mergedSelection.indexOf(item) < 0;
      }));
    } // v_corpus_id=IS--|ISW-|ISZ-


    return "v_corpus_id=".concat(mergedSelection.join('|'));
  },

  /**
   * Creates the filter URL param for the given geographic selection.
   *
   * @param {Object} geographicSelection geographic selection object aggregating
   *   the filters with the keys 'countrySelection', regionSelection', 'districtSelection'
   * @returns {String} The filter as URL param string
   */
  createGeographicFilter: function createGeographicFilter(geographicSelection) {
    var filter = '';

    for (var key in geographicSelection) {
      var geogSel = geographicSelection[key];

      if (!geogSel) {
        continue;
      }

      if (key === 'countrySelection') {
        filter += "v_iso=".concat(geogSel.iso);
      } else if (key === 'regionSelection') {
        filter += "&v_region=".concat(geogSel.name);
      } else if (key === 'districtSelection') {
        filter += "&v_landkreis=".concat(geogSel.name);
      }
    }

    return filter;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (IdsFilterGenerator);

/***/ }),

/***/ "L1xf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_to_fixed_js__ = __webpack_require__("9P18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_to_fixed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_to_fixed_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_proj_js__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_coordinate__ = __webpack_require__("IZoy");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-coords-table',
  props: {
    coordsData: {
      type: Object
    },
    showMapPos: {
      type: Boolean,
      required: false,
      default: true
    },
    showWgsPos: {
      type: Boolean,
      required: false,
      default: true
    },
    showHdms: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      coordRows: null
    };
  },
  methods: {},
  watch: {
    coordsData: function coordsData() {
      var me = this;
      var coordinate = me.coordsData.coordinate;
      var projection = me.coordsData.projection;
      var coordinateWgs84 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ol_proj_js__["p" /* transform */])(coordinate, projection, 'EPSG:4326');
      var coordRows = {};

      if (me.showMapPos) {
        // show coordinate in map' SRS
        coordRows['MAP PROJ'] = coordinate[1].toFixed(2) + ' ' + coordinate[0].toFixed(2);
      }

      if (me.showWgsPos) {
        // show coordinate in WGS 84
        var _coordinateWgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ol_proj_js__["p" /* transform */])(coordinate, projection, 'EPSG:4326');

        coordRows['WGS 84'] = _coordinateWgs[1].toFixed(7) + '° ' + _coordinateWgs[0].toFixed(7) + '°';
      }

      if (me.showHdms) {
        // show coordinate in WGS 84 as formatted degree / min / secs
        var hdms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_coordinate__["m" /* toStringHDMS */])(coordinateWgs84);
        coordRows['HDMS'] = hdms;
      }

      me.coordRows = coordRows;
    }
  }
});

/***/ }),

/***/ "LaCf":
/***/ (function(module, exports) {

module.exports = {"app":{"title":"Ortsdaten der Variationskorpora des Archivs für Gesprochenes Deutsch","browserTitle":"AGD-Kartenanwendung Variationskorpora","footerTextLeft":"Powered by <a href='https://meggsimum.de/wegue/' target='_blank'>Wegue WebGIS</a>","footerTextRight":"<a href='https://agd.ids-mannheim.de/impressum.shtml' target='_blank'>Impressum</a> | <a href='https://www.ids-mannheim.de/allgemein/datenschutz/' target='_blank'>Datenschutz</a>"},"mapLayers":{"osm-bg":{"name":"OpenStreetMap"}},"ids-filter-module":{"title":"Filtereinstellungen"},"ids-feature-info-module":{"title":"Objektinformation","welcomeText":"Zoomen Sie die Karte auf Ihr Gebiet von Interesse und selektieren Sie einen Datensatz in der Karte, um Detailinformationen abzurufen."},"ids-detail-filter-module":{"title":"Filter nach Jahren","description":"Ortsdaten auf folgenden Zeitraum einschränken:"},"wgu-zoomtomaxextent":{"title":"Zurück zur Startansicht"}}

/***/ }),

/***/ "MPh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DraggableWin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

/**
 * Directive to make a window component draggable by dragging it's header.
 * Proudly inspired by and most of the essential code taken from
 * https://github.com/branu-ws/v-drag/blob/master/src/index.js
 */

var DraggableWin = {
  dragConfig: {
    // if this is present, only a specific area of the draggable will respond to
    // dragging (e. g. header bar).
    draggableElementSelector: null,
    down: false,
    height: 0,
    width: 0,
    initialX: 0,
    initialY: 0,
    constraintToWindow: true,
    cursorPreviousX: 0,
    cursorPreviousY: 0,
    draggerOffsetLeft: 0,
    draggerOffsetTop: 0,
    overlay: null,
    draggableEl: null,
    initialZIndex: undefined
  },
  bind: function bind(elmnt, binding, vnode) {
    if (binding.value === false) {
      // disable this directive if set to v-draggable-win="false"
      return;
    } // get the header element to bind the events on it


    var header = elmnt.querySelector('div.wgu-win-title');

    if (!header) {
      return;
    }

    var dragConfig = DraggableWin.dragConfig; // restrict the dragging at least to window title

    dragConfig.draggableElementSelector = binding.arg || 'wgu-win-title'; // set cursor so it's signal that the user can drag the window

    header.style.cursor = 'move';
    elmnt.addEventListener('mouseup', function (e) {
      return DraggableWin.mouseup(e, elmnt, dragConfig);
    });
    elmnt.addEventListener('mousedown', function (e) {
      return DraggableWin.mousedown(e, elmnt, dragConfig);
    });
    elmnt.addEventListener('mousemove', function (e) {
      return DraggableWin.mousemove(e, elmnt, dragConfig);
    });
    dragConfig.initialZIndex = elmnt.style.zIndex;
    /**
     * Creates an overlay in order to bind the mouse events to it.
     * @private
     */

    function createOverlay(e, el, _data) {
      var overlay = document.createElement('div');
      overlay.setAttribute('style', "\n        width: 100vw;\n        height: 100vh;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 10000;\n      ");
      overlay.addEventListener('mouseup', function (e) {
        return mouseup(e, el, _data);
      });
      overlay.addEventListener('mousedown', function (e) {
        return mousedown(e, el, _data);
      });
      overlay.addEventListener('mousemove', function (e) {
        return mousemove(e, el, _data);
      });
      document.body.appendChild(overlay);
      return overlay;
    }
    /**
     * Checks if the given selector (id or class) occurs in the given path
     */


    function checkIfSelectorInPath(selector, path) {
      if (!path) {
        return false;
      }

      for (var i = 0; i < path.length; i++) {
        // check for ID
        if (path[i].id === selector) {
          return true;
        } // also check for a class name


        if (path[i].classList && path[i].classList.contains(selector)) {
          return true;
        }
      }

      return false;
    }
    /**
     * Adjusts element's z-index.
     */


    function adjustElementZIndex(el, index) {
      el.style.zIndex = index;
    }
    /**
     * Event handler for mouse down.
     */


    function mousedown(e, el, _data) {
      // if the user set a argument to v-drag,
      // it means they only want a specific area to be draggable
      // eg: `v-drag:drag-header` means only the element with
      // id="drag-header" or class="drag-header" should be draggable.
      // If the user clicked another area, do nothing.
      // By default it is restricted to class="wgu-win-title"
      // get the element path
      var path = e.path || e.composedPath && e.composedPath();

      if (_data.draggableElementSelector && !checkIfSelectorInPath(_data.draggableElementSelector, path)) {
        return;
      } // set the offset for each mousedown


      setDraggerOffset(el, _data);

      if (_data.overlay) {
        _data.overlay.remove();
      } // set the width each click
      // just in case it changed since last time (by external plugin, for example)


      _data.width = el.offsetWidth;
      _data.height = el.offsetHeight;
      _data.down = true;
      _data.initialX = e.clientX;
      _data.initialY = e.clientY;
      var overlay = createOverlay(e, el, _data);
      _data.overlay = overlay;
      adjustElementZIndex(el, 10001);
    }

    DraggableWin.mousedown = mousedown;
    /**
     * Event handler for mouse up.
     */

    function mouseup(e, el, _data) {
      _data.down = false;

      if (!_data.overlay) {
        return;
      }

      _data.overlay.removeEventListener('mouseup', mouseup);

      _data.overlay.removeEventListener('mousedown', mousedown);

      _data.overlay.removeEventListener('mousemove', mousemove);

      _data.overlay.remove();

      adjustElementZIndex(el, _data.initialZIndex);
      setDraggerOffset(el, _data); // preserve the current position as property of the vue / Wegue window
      // so it can be restored when the window is re-opened

      vnode.componentInstance.$parent.top = _data.draggerOffsetTop + 'px';
      vnode.componentInstance.$parent.left = _data.draggerOffsetLeft + 'px';
    }

    DraggableWin.mouseup = mouseup;
    /**
     * Checks if left window boundary is reached.
     */

    function reachedLeft(el, _data, movingLeft) {
      return el.offsetLeft + _data.width >= window.innerWidth && !movingLeft;
    }
    /**
     * Checks if right window boundary is reached.
     */


    function reachedRight(el, _data, movingRight) {
      return el.offsetLeft <= 0 && !movingRight;
    }
    /**
     * Checks if top window boundary is reached.
     */


    function reachedTop(el, _data, movingUp) {
      return el.offsetTop <= 0 && !movingUp;
    }
    /**
     * Checks if bottom window boundary is reached.
     */


    function reachedBottom(el, _data, movingDown) {
      return el.offsetTop + _data.height >= window.innerHeight && !movingDown;
    }
    /**
     * Event handler for mouse move.
     */


    function mousemove(e, el, _data) {
      if (_data.down) {
        var movingLeft = _data.cursorPreviousX > e.clientX;
        var movingRight = _data.cursorPreviousX < e.clientX;
        var movingUp = _data.cursorPreviousY < e.clientY;
        var movingDown = _data.cursorPreviousY > e.clientY;

        if (_data.constraintToWindow && (reachedLeft(el, _data, movingLeft) || reachedRight(el, _data, movingRight))) {// do now allow moving outside the window horizontally
        } else {
          el.style.left = _data.draggerOffsetLeft + (e.clientX - _data.initialX) + 'px';
        }

        if (_data.constraintToWindow && (reachedTop(el, _data, movingUp) || reachedBottom(el, _data, movingDown))) {// do now allow moving outside the window vertically
        } else {
          el.style.top = _data.draggerOffsetTop + (e.clientY - _data.initialY) + 'px';
        }
      }

      _data.cursorPreviousX = e.clientX;
      _data.cursorPreviousY = e.clientY;
    }

    DraggableWin.mousemove = mousemove;
    /**
     * Applies the offset values of the element.
     */

    function setDraggerOffset(el, _data) {
      _data.draggerOffsetLeft = el.offsetLeft;
      _data.draggerOffsetTop = el.offsetTop;
    }
  }
}; // Make directive available globally

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('draggable-win', DraggableWin);

/***/ }),

/***/ "MV43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeTableWin_vue__ = __webpack_require__("36PU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7d59c04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTableWin_vue__ = __webpack_require__("vUPf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Wi6V")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7d59c04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeTableWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7d59c04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTableWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7d59c04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTableWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_source_TileWMS__ = __webpack_require__("DwLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_source_ImageWMS__ = __webpack_require__("j0xK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");







function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }

/**
 * Implements URL parametrization to obtain legend images for layers.
 */



var CustomLegend = {
  /**
   * Returns a URL to the legend image.
   * This replaces the parameter placeholders in formatUrl.
   * @param {ol.Source} source The source to produce the legend for.
   * @param {Number} resolution Resolution of the legend image.
   * @param {Object} options Optional configuration params.
   * @param {String} formatUrl  A custom format URL.
   * @returns {String} The legend URL.
   */
  getUrl: function getUrl(source, resolution, options, formatUrl) {
    var url = formatUrl;
    var placeholders = options || {}; // Remarks: Resolution to scale conversion taken from OL - TileWMS.js.

    if (resolution !== undefined) {
      var mpu = source.getProjection() ? source.getProjection().getMetersPerUnit() : 1;
      var pixelSize = 0.00028;
      placeholders['SCALE'] = resolution * mpu / pixelSize;
    }

    for (var key in placeholders) {
      var regex = new RegExp('{{' + key + '}}', 'gi');
      url = url.replace(regex, placeholders[key]);
    }

    return url;
  }
};
var WMSSourceLegend = {
  /**
   * Returns a URL to the legend image.
   * @param {ol.Source} source The source to produce the legend for.
   * @param {Number} resolution Resolution of the legend image.
   * @param {Object} options Optional configuration params.
   * @returns {String} The legend URL.
   */
  getUrl: function getUrl(source, resolution, options) {
    return source.getLegendUrl(resolution, options);
  }
};
var LayerLegend = {
  /**
   * Merges the given legend options with the legend options configured
   * in the application context. The provided options will take precedence.
   * @param {Object} options Optional configuration params.
   * @returns {Object} Merged configuration params.
   */
  getOptions: function getOptions(options) {
    var appConfig = __WEBPACK_IMPORTED_MODULE_8_vue__["default"].prototype.$appConfig;
    return _objectSpread(_objectSpread({}, appConfig === null || appConfig === void 0 ? void 0 : appConfig.legend), options);
  },

  /**
   * Returns a URL to the layers legend image.
   * @param {ol.Layer} layer The layer to produce the legend for.
   * @param {Number} resolution Resolution of the legend image.
   * @param {Object} options Optional configuration params.
   * @param {String} formatUrl A custom format URL.
   * @returns {String} Legend URL or undefined if no legend can be produced.
   */
  getUrl: function getUrl(layer, resolution, options, formatUrl) {
    var opts = this.getOptions(options);
    var source = layer.getSource(); // If we cannot obtain a source, no legend can be produced.

    if (!source) {
      return undefined;
    } // If a formatUrl is provided, the legend is custom.


    if (formatUrl) {
      return CustomLegend.getUrl(source, resolution, opts, formatUrl);
    } // For WMS based sources, use the in-built legend URL formatter.


    if (source instanceof __WEBPACK_IMPORTED_MODULE_6_ol_source_TileWMS__["a" /* default */] || source instanceof __WEBPACK_IMPORTED_MODULE_7_ol_source_ImageWMS__["a" /* default */]) {
      return WMSSourceLegend.getUrl(source, resolution, opts);
    }

    return undefined;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LayerLegend);

/***/ }),

/***/ "MyfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"borderless":"","dense":"","color":"onprimary","background-color":"transparent","title":_vm.$t(_vm.moduleName + '.title')},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-btn',{attrs:{"icon":"","value":true,"color":"onprimary"},on:{"click":_vm.toggleUi}},[_c('v-icon',{attrs:{"color":"onprimary","medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "N/gh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_array_map_js__ = __webpack_require__("/TzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_geom_Point__ = __webpack_require__("T18w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_Feature__ = __webpack_require__("nq2H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_layer__ = __webpack_require__("ItK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_source__ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_style__ = __webpack_require__("beD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ViewAnimation__ = __webpack_require__("ntKu");



//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-geolocator',
  props: {
    markerColor: {
      type: String,
      required: false,
      default: 'blue'
    },
    markerText: {
      type: String,
      required: false,
      default: 'person_pin_circle'
    }
  },
  data: function data() {
    return {
      isGeolocationAPIAvailable: null,
      isGeolocationFound: false,
      isSearchingForGeolocation: false,
      geolocationMarker: new __WEBPACK_IMPORTED_MODULE_8_ol_style__["a" /* Style */]({
        text: new __WEBPACK_IMPORTED_MODULE_8_ol_style__["e" /* Text */]({
          text: this.markerText,
          font: 'normal 30px Material Icons',
          fill: new __WEBPACK_IMPORTED_MODULE_8_ol_style__["d" /* Fill */]({
            color: this.markerColor
          })
        })
      })
    };
  },
  created: function created() {
    var me = this;
    __WEBPACK_IMPORTED_MODULE_9__WguEventBus__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
      me.map = olMap;
    });

    if (!navigator.geolocation) {
      me.isGeolocationAPIAvailable = false;
    } else {
      me.isGeolocationAPIAvailable = true;
    }
  },
  methods: {
    /**
     *
     */
    createAndRemoveExistingLayer: function createAndRemoveExistingLayer(layers, layerId) {
      var _context;

      // if the geolocationLayer is already included it has to be removed
      layers.remove(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = layers.getArray()).call(_context, function (layer) {
        return layerId === layer.get('lid');
      })[0]); // create new layer

      var layer = new __WEBPACK_IMPORTED_MODULE_6_ol_layer__["a" /* Vector */]({
        source: new __WEBPACK_IMPORTED_MODULE_7_ol_source__["a" /* Vector */](),
        style: this.geolocationMarker
      });
      layer.setProperties({
        lid: layerId
      });
      return layer;
    },

    /**
     *
     */
    geolocateUserAndShowMarkerOnMap: function geolocateUserAndShowMarkerOnMap() {
      var _this = this;

      if (this.isGeolocationAPIAvailable) {
        this.isSearchingForGeolocation = true; // access current geolocation position and show on map

        navigator.geolocation.getCurrentPosition(function (position) {
          if (typeof __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this) !== 'undefined') {
            // create location point and reproject to map's projection
            var mapProjection = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).getView().getProjection();

            var projCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj__["i" /* fromLonLat */])([position.coords.longitude, position.coords.latitude], mapProjection);
            var currentPosGeom = new __WEBPACK_IMPORTED_MODULE_4_ol_geom_Point__["a" /* default */](projCoords);
            _this.isGeolocationFound = true;
            _this.isSearchingForGeolocation = false; // get a layer to draw the current position on

            var geolocLayer = _this.createAndRemoveExistingLayer(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).getLayers(), 'wgu-geolocator-layer');

            geolocLayer.getSource().addFeature(new __WEBPACK_IMPORTED_MODULE_5_ol_Feature__["a" /* default */]({
              geometry: currentPosGeom
            }));

            __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).addLayer(geolocLayer); // zoom to geolocation position


            __WEBPACK_IMPORTED_MODULE_10__util_ViewAnimation__["a" /* default */].to(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).getView(), currentPosGeom);
          } else {
            console.error('The map is not defined in the getCurrentPosition callback');
          }
        }, // error handling for geolocation
        function (error) {
          // log the error without displaying it, simply allows debugging
          console.error('Geolocation error : code ' + error.code + ' - ' + error.message); // display user friendly error message

          alert('Geolocation error : code ' + error.code + ' - ' + error.message);
          _this.isGeolocationAPIAvailable = false;
          _this.isSearchingForGeolocation = false;
        }, {
          enableHighAccuracy: true,
          maximumAge: 60000,
          timeout: 27000
        });
      } else {
        this.isGeolocationAPIAvailable = false;
      }
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_slice__ = __webpack_require__("J849");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_array_from__ = __webpack_require__("XK4L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_symbol__ = __webpack_require__("X78b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_get_iterator_method__ = __webpack_require__("8Qmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_get_iterator_method___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_get_iterator_method__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_get_iterator__ = __webpack_require__("uiEL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portal_vue__ = __webpack_require__("TX8X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mdi_font_css_materialdesignicons_css__ = __webpack_require__("csSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_icons_iconfont_material_icons_css__ = __webpack_require__("aqYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__node_modules_ol_ol_css__ = __webpack_require__("ktr9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__node_modules_ol_ol_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__node_modules_ol_ol_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_WguApp__ = __webpack_require__("y+0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Url__ = __webpack_require__("v9hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_Locale__ = __webpack_require__("e/Tm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_Object__ = __webpack_require__("XSiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_ColorTheme__ = __webpack_require__("njir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_axios__);
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_symbol___default.a === "undefined" || __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_get_iterator_method___default()(o) == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_get_iterator___default()(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_slice___default()(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_array_from___default()(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }









// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_portal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]);

__webpack_require__("SPmS"); // try to load an optional app specific CSS file (set project-specific styles)


try {
  __webpack_require__("Op2c");
} catch (e) {}

__WEBPACK_IMPORTED_MODULE_8_vue__["default"].config.productionTip = false; // Detect isEmbedded state by attribute embedded and
// make accessible for all components
// recommended by https://vuejs.org/v2/cookbook/adding-instance-properties.html

var appEl = document.querySelector('#app');
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].prototype.$isEmbedded = appEl.hasAttribute('embedded'); // Detect an URL parameter for a custom app context

var appCtx = __WEBPACK_IMPORTED_MODULE_16__util_Url__["a" /* default */].getQueryParam('appCtx');
var appCtxFile = '';

if (appCtx) {
  // simple aproach to avoid path traversal
  appCtxFile = '-' + appCtx.replace(/(\.\.[/])+/g, '');
}
/**
 * Creates the active vuetify instance.
 *
 * @param {Object} appConfig Global application context.
 * @returns The active vuetify instance.
 */


var createVuetify = function createVuetify(appConfig) {
  var preset = {
    theme: __WEBPACK_IMPORTED_MODULE_19__util_ColorTheme__["a" /* default */].buildTheme(appConfig.colorTheme),
    icons: {
      iconfont: 'mdiSvg'
    },
    lang: {
      current: __WEBPACK_IMPORTED_MODULE_17__util_Locale__["a" /* default */].getPreferredLanguage(appConfig),
      locales: __WEBPACK_IMPORTED_MODULE_17__util_Locale__["a" /* default */].importVuetifyLocales()
    }
  };
  return new __WEBPACK_IMPORTED_MODULE_9_vuetify___default.a(preset);
};
/**
 * Creates the VueI18n object used for internationalization.
 *
 * @param {Object} appConfig Global application context.
 * @returns The active I18n instance.
 */


var createVueI18n = function createVueI18n(appConfig) {
  var preset = {
    locale: __WEBPACK_IMPORTED_MODULE_17__util_Locale__["a" /* default */].getPreferredLanguage(appConfig),
    fallbackLocale: __WEBPACK_IMPORTED_MODULE_17__util_Locale__["a" /* default */].getFallbackLanguage(appConfig),
    messages: __WEBPACK_IMPORTED_MODULE_17__util_Locale__["a" /* default */].importVueI18nLocales()
  };
  return new __WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */](preset);
};
/**
 * Backwards compatibility layer for legacy features in app-conf.json.
 *
 * @param {Object} appConfig Global application context.
 * @returns The migrated application context.
 */


var migrateAppConfig = function migrateAppConfig(appConfig) {
  // Warning for deprecated baseColor
  if (appConfig.baseColor) {
    console.warn('The configuration path ".baseColor" is deprecated, ' + 'instead declare a path ".colorTheme"');
  } // Migrate boolean values for module.win.


  if (appConfig.modules) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(appConfig.modules).forEach(function (name) {
      var module = appConfig.modules[name];

      if (typeof module.win === 'boolean') {
        module.win = module.win ? 'floating' : undefined;
      }
    });
  } // Create warnings for text based configuration properties,
  // which are no longer supported and have been moved to the language files.

  /* eslint-disable no-useless-escape */


  var deprecatedTextProps = {
    'title': 'app.title',
    'browserTitle': 'app.browserTitle',
    'footerTextLeft': 'app.footerTextLeft',
    'footerTextRight': 'app.footerTextRight',
    'mapGeodataDragDop\\.layerName': 'mapLayers.wgu-drag-drop-layer.name',
    'modules.\\.wgu-attributetable\\.selectorLabel': 'wgu-attributetable.selectorLabel',
    'modules\\.wgu-geocoder\\.placeHolder': 'wgu-geocoder.placeHolder',
    'modules\\.wgu-infoclick\\.mediaInfoLinkText': 'wgu-infoclick.mediaInfoLinkText',
    'modules\\.wgu-zoomtomaxextent\\.text': 'wgu-zoomtomaxextent.text',
    'modules\\.wgu-helpwin\\.windowTitle': 'wgu-helpwin.title',
    'modules\\.wgu-helpwin\\.textTitle': 'wgu-helpwin.textTitle',
    'modules\\.wgu-helpwin\\.htmlContent': 'wgu-helpwin.htmlContent',
    'modules\\.wgu-helpwin\\.infoLinkUrl': 'wgu-helpwin.infoLinkUrl',
    'modules\\.wgu-helpwin\\.infoLinkText': 'wgu-helpwin.infoLinkText',
    'modules\\..*\\.title': '<moduleName>.title'
  };
  /* eslint-enable no-useless-escape */

  var configPaths = __WEBPACK_IMPORTED_MODULE_18__util_Object__["a" /* default */].toPaths(appConfig);

  var _iterator = _createForOfIteratorHelper(configPaths),
      _step;

  try {
    var _loop = function _loop() {
      var _context;

      var path = _step.value;

      var match = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(deprecatedTextProps)).call(_context, function (pattern) {
        var regex = new RegExp('^\\.' + pattern + '$', 'g');
        return regex.test(path);
      });

      if (match) {
        console.warn('The configuration path "' + path + '" is deprecated, ' + 'instead declare a path "' + deprecatedTextProps[match] + '" in all language files in your "/app/locales" folder');
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  ; // Create warnings and migrate settings related to mapLayers configuration:

  if (appConfig.mapLayers) {
    appConfig.mapLayers.forEach(function (layer, i) {
      if (!layer.lid) {
        console.warn('mapLayers[' + i + '] does not declare a lid property');
      }

      if (layer.type === 'WMS') {
        console.warn('mapLayers[' + i + '] uses the depreated type WMS. Use TILEWMS instead.');
        layer.type = 'TILEWMS';
      }
    });
  } // Create warnings, if one of the module specific animation properties is declared,
  // which are no longer supported due to global view animation configuration.

  /* eslint-disable no-useless-escape */


  var deprecatedAnimProps = {
    'modules\\.wgu-geolocator\\.zoomAnimation': 'viewAnimation.type',
    'modules\\.wgu-geolocator\\.zoomAnimationDuration': 'viewAnimation.options.duration',
    'modules\\.wgu-geolocator\\.maxZoom': 'viewAnimation.options.maxZoom',
    'modules\\.wgu-geocoder\\.selectZoom': 'viewAnimation.options.zoom'
  };
  /* eslint-enable no-useless-escape */

  var _iterator2 = _createForOfIteratorHelper(configPaths),
      _step2;

  try {
    var _loop2 = function _loop2() {
      var _context2;

      var path = _step2.value;

      var match = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(deprecatedAnimProps)).call(_context2, function (pattern) {
        var regex = new RegExp('^\\.' + pattern + '$', 'g');
        return regex.test(path);
      });

      if (match) {
        console.warn('The configuration path "' + path + '" is deprecated, ' + 'instead declare the "viewAnimation" option and configure the "' + deprecatedAnimProps[match] + '" property');
      }
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  ;
  return appConfig;
};
/**
 * Create the vue application.
 *
 * @param {Object} appConfig Global application context.
 */


var createApp = function createApp(appConfig) {
  // make app config accessible for all components
  __WEBPACK_IMPORTED_MODULE_8_vue__["default"].prototype.$appConfig = migrateAppConfig(appConfig);
  /* eslint-disable no-new */

  new __WEBPACK_IMPORTED_MODULE_8_vue__["default"]({
    vuetify: createVuetify(appConfig),
    i18n: createVueI18n(appConfig),
    el: '#app',
    template: '<wgu-app/>',
    components: {
      WguApp: __WEBPACK_IMPORTED_MODULE_15__app_WguApp__["a" /* default */]
    }
  });
}; // Look in the static dir for an app-specific config file.


var configFile = 'static/app-conf' + appCtxFile + '.json';
var request = {
  method: 'GET',
  url: configFile
};
__WEBPACK_IMPORTED_MODULE_21_axios___default()(request).then(function (response) {
  createApp(response.data);
}).catch(function (error) {
  var _context3;

  console.error(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context3 = "Cannot load config file ".concat(configFile, ", ")).call(_context3, error));
});

/***/ }),

/***/ "Nkpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_array_map_js__ = __webpack_require__("/TzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropertyTable__ = __webpack_require__("ZY9t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoordsTable__ = __webpack_require__("R3+W");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-infoclick-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_2__modulecore_ModuleCard__["a" /* default */],
    'wgu-property-table': __WEBPACK_IMPORTED_MODULE_4__PropertyTable__["a" /* default */],
    'wgu-coords-table': __WEBPACK_IMPORTED_MODULE_5__CoordsTable__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'info'
    },
    showMedia: {
      type: Boolean,
      required: false,
      default: false
    },
    // below props only have an effect if showMedia=true
    mediaInfoLinkUrlProp: {
      type: String,
      required: false
    },
    imageProp: {
      type: String,
      required: false
    },
    imageDescriptionProp: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      moduleName: 'wgu-infoclick',
      attributeData: null,
      coordsData: null
    };
  },
  created: function created() {
    var me = this; // Listen to the ol-map-mounted event and receive the OL map instance

    __WEBPACK_IMPORTED_MODULE_3__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
      // make the OL map accessible in this component
      me.map = olMap;
    });
  },
  methods: {
    registerMapClick: function registerMapClick(unregister) {
      var me = this;

      if (unregister === true) {
        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).un('singleclick', me.onMapClick);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).on('singleclick', me.onMapClick);
      }
    },

    /**
     * Handler for 'singleclick' on the map.
     * Collects data and passes it to corresponding objects.
     *
     * @param  {ol/MapBrowserEvent} evt The OL event of 'singleclick' on the map
     */
    onMapClick: function onMapClick(evt) {
      var me = this;

      var featureLayer = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        return [feature, layer];
      }); // collect feature attributes --> PropertyTable


      if (featureLayer) {
        var feat = featureLayer[0];
        var props = feat.getProperties(); // do not show geometry property

        delete props.geometry;
        me.attributeData = props;
      } else {
        me.attributeData = null;
      } // collect click coordinate + projection --> CoordsTable


      me.coordsData = {
        coordinate: evt.coordinate,
        projection: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).getView().getProjection().getCode()
      };
    },

    /**
     * (Un-)Register map interactions when the visibility of the module changes.
     *
     * @param  {boolean} visible New visibility state
    */
    show: function show(visible) {
      var me = this;

      if (visible) {
        me.registerMapClick();
      } else {
        // cleanup old data
        me.attributeData = null;
        me.coordsData = null;
      }
    }
  }
});

/***/ }),

/***/ "NuBg":
/***/ (function(module, exports) {

module.exports = {"app":{"title":"Vue.js / OpenLayers WebGIS","browserTitle":"Wegue Demo App","footerTextLeft":"Powered by <a href='https://meggsimum.de/wegue/' target='_blank'>Wegue WebGIS</a>","footerTextRight":"meggsimum","logo":"App Logo"},"mapLayers":{"wgu-geolocator-layer":{"name":"Current Position"},"wgu-measure-layer":{"name":"Measure Layer"},"wgu-drag-drop-layer":{"name":"Drag/Drop Data"}},"wgu-toolbar-menu":{"title":"Open toolbar menu"},"wgu-attributetable":{"title":"Attribute Table","selectorLabel":"Choose a layer","loadingText":"Loading... Please move to an area where the layer is visible"},"wgu-bglayerswitcher":{"title":"Change background map"},"wgu-overviewmap":{"title":"Show overview map"},"wgu-geocoder":{"title":"Address Search","placeHolder":"Search for an address"},"wgu-geolocator":{"title":"Geolocation"},"wgu-helpwin":{"title":"About","textTitle":"About Wegue","htmlContent":"<b>WebGIS with OpenLayers and Vue.js</b> Template and re-usable components for webmapping applications with OpenLayers and Vue.js","infoLinkUrl":"http://wegue.org/","infoLinkText":"More info"},"wgu-infoclick":{"title":"Map Click Info","mapClick":"Click on the map to get information for the clicked map position.","mediaClick":"Click on a feature on the map to show connected media information.","mediaInfoLinkText":null},"wgu-layerlist":{"title":"Layers"},"wgu-maprecorder":{"title":"Map recorder","options":"Options","videoFormat":"Video format","frameRate":"Frame rate (frames/s)","bitRate":"Bit rate (MBits/s)","fileName":"Filename","start":"Start","stop":"Stop","error":"Failed to start recording."},"wgu-zoomtomaxextent":{"title":"Reset Map Extent"},"wgu-measuretool":{"title":"Measure","distance":"Distance","length":"Length","area":"Area","lengthKm":"{0} km","lengthMeter":"{0} m","areaSquareKm":"{0} km²","areaSquareMeter":"{0} m²"},"wgu-localeswitcher":{"title":"Language Settings"},"wgu-themeswitcher":{"title":"Dark mode"}}

/***/ }),

/***/ "OUzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayerFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_is_integer__ = __webpack_require__("MO7B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_starts_with__ = __webpack_require__("4gXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_layer__ = __webpack_require__("ItK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_source_ImageWMS__ = __webpack_require__("j0xK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_source_TileWMS__ = __webpack_require__("DwLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_source_OSM__ = __webpack_require__("WiOa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_layer_VectorTile__ = __webpack_require__("fZPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_source_VectorTile__ = __webpack_require__("hGhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_format_MVT__ = __webpack_require__("fGhu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ol_format_GeoJSON__ = __webpack_require__("aUhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ol_format_TopoJSON__ = __webpack_require__("UjZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ol_format_KML__ = __webpack_require__("srNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_ol_format_GML2__ = __webpack_require__("aodK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ol_format_GML3__ = __webpack_require__("X0BE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_ol_format_GML32__ = __webpack_require__("z8pl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_ol_source_XYZ__ = __webpack_require__("irp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_ol_loadingstrategy__ = __webpack_require__("f2+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__OlStyle__ = __webpack_require__("fT5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__util_Object__ = __webpack_require__("XSiL");









function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }























/**
 * Factory, which creates OpenLayers layer instances according to a given config
 * object.
 */

var LayerFactory = {
  /**
   * Maps the format literal of the config to the corresponding OL module.
   * @type {Object}
   */
  formatMapping: {
    'MVT': __WEBPACK_IMPORTED_MODULE_14_ol_format_MVT__["a" /* default */],
    'GeoJSON': __WEBPACK_IMPORTED_MODULE_15_ol_format_GeoJSON__["a" /* default */],
    'TopoJSON': __WEBPACK_IMPORTED_MODULE_16_ol_format_TopoJSON__["a" /* default */],
    'KML': __WEBPACK_IMPORTED_MODULE_17_ol_format_KML__["a" /* default */],
    'GML2': __WEBPACK_IMPORTED_MODULE_18_ol_format_GML2__["a" /* default */],
    'GML3': __WEBPACK_IMPORTED_MODULE_19_ol_format_GML3__["a" /* default */],
    'GML32': __WEBPACK_IMPORTED_MODULE_20_ol_format_GML32__["a" /* default */]
  },

  /**
   * Maps the format literal of the config to the corresponding WFS outputFormat.
   * @type {Object}
   */
  wfsFormatMapping: {
    'GeoJSON': 'application/json',
    'GML2': 'text/xml; subtype=gml/2.1.2',
    'GML3': 'text/xml; subtype=gml/3.1.1',
    'GML32': 'text/xml; subtype=gml/3.2'
  },

  /**
   * Returns an OpenLayers layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @param  {ol/Map} olMap  Optional OL map we work on
   * @return {ol/layer/Base} OL layer instance
   */
  getInstance: function getInstance(lConf, olMap) {
    // create correct layer type
    if (lConf.type === 'TILEWMS') {
      return this.createTileWmsLayer(lConf);
    } else if (lConf.type === 'IMAGEWMS') {
      return this.createImageWmsLayer(lConf);
    } else if (lConf.type === 'WFS') {
      return this.createWfsLayer(lConf, olMap);
    } else if (lConf.type === 'XYZ') {
      return this.createXyzLayer(lConf);
    } else if (lConf.type === 'OSM') {
      return this.createOsmLayer(lConf);
    } else if (lConf.type === 'VECTOR') {
      return this.createVectorLayer(lConf);
    } else if (lConf.type === 'VECTORTILE') {
      return this.createVectorTileLayer(lConf);
    } else {
      return null;
    }
  },

  /**
   * Returns an OL layer options initialization object, containing
   * attributes common to all layer types.
   * @param  {Object} lConf  Layer config object
   * @return {Object} OL layer options
   */
  getCommonLayerOptions: function getCommonLayerOptions(lConf) {
    return {
      lid: lConf.lid,
      isBaseLayer: lConf.isBaseLayer,
      previewImage: lConf.previewImage,
      displayInLayerList: lConf.displayInLayerList,
      supportsPermalink: lConf.supportsPermalink,
      extent: lConf.extent,
      visible: lConf.visible,
      opacity: lConf.opacity,
      opacityControl: lConf.opacityControl,
      zIndex: lConf.zIndex,
      confName: lConf.name,
      confAttributions: lConf.attributions,
      legend: lConf.legend,
      legendUrl: lConf.legendUrl,
      legendOptions: lConf.legendOptions
    };
  },

  /**
   * Returns an OpenLayers WMS layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Image} OL WMS layer instance
   */
  createImageWmsLayer: function createImageWmsLayer(lConf) {
    // apply additional HTTP params
    var params = {
      'LAYERS': lConf.layers
    };
    __WEBPACK_IMPORTED_MODULE_29__util_Object__["a" /* default */].mergeDeep(params, lConf.params);
    var layer = new __WEBPACK_IMPORTED_MODULE_8_ol_layer__["b" /* Image */](_objectSpread(_objectSpread({}, this.getCommonLayerOptions(lConf)), {}, {
      source: new __WEBPACK_IMPORTED_MODULE_9_ol_source_ImageWMS__["a" /* default */]({
        url: lConf.url,
        params: params,
        serverType: lConf.serverType,
        ratio: lConf.ratio,
        interpolate: lConf.interpolate,
        projection: lConf.projection,
        crossOrigin: lConf.crossOrigin,
        hoverable: lConf.hoverable,
        hoverAttribute: lConf.hoverAttribute,
        hoverOverlay: lConf.hoverOverlay
      })
    }));
    return layer;
  },

  /**
   * Returns an OpenLayers Tiled WMS layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL Tiled WMS layer instance
   */
  createTileWmsLayer: function createTileWmsLayer(lConf) {
    // apply additional HTTP params
    var params = {
      'LAYERS': lConf.layers
    };
    __WEBPACK_IMPORTED_MODULE_29__util_Object__["a" /* default */].mergeDeep(params, lConf.params);
    var layer = new __WEBPACK_IMPORTED_MODULE_8_ol_layer__["c" /* Tile */](_objectSpread(_objectSpread({}, this.getCommonLayerOptions(lConf)), {}, {
      source: new __WEBPACK_IMPORTED_MODULE_10_ol_source_TileWMS__["a" /* default */]({
        url: lConf.url,
        params: params,
        serverType: lConf.serverType,
        tileGrid: lConf.tileGrid,
        projection: lConf.projection,
        crossOrigin: lConf.crossOrigin,
        hoverable: lConf.hoverable,
        hoverAttribute: lConf.hoverAttribute,
        hoverOverlay: lConf.hoverOverlay
      })
    }));
    return layer;
  },

  /**
   * Returns an OpenLayers WFS layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @param  {ol/Map} olMap  The OpenLayers map we work on
   * @return {ol.layer.Tile} OL WFS layer instance
   */
  createWfsLayer: function createWfsLayer(lConf, olMap) {
    var mapSrs = olMap.getView().getProjection().getCode(); // set a default projection if not set in config

    if (!lConf.projection) {
      lConf.projection = mapSrs;
    } // set a default WFS version if not set in config


    if (!lConf.version) {
      lConf.version = '1.1.0';
    }

    if (!lConf.format) {
      lConf.format = 'GML3';
    } // detect the WFS output format


    var outputFormat = this.wfsFormatMapping[lConf.format]; // overwrite format options, so they fit to the SRS (map vs. data)

    if (mapSrs !== lConf.projection) {
      lConf.formatConfig.dataProjection = lConf.projection;
      lConf.formatConfig.featureProjection = mapSrs;
    }

    var vectorSource = new __WEBPACK_IMPORTED_MODULE_22_ol_source_Vector__["a" /* default */]({
      format: new this.formatMapping[lConf.format](lConf.formatConfig),
      loader: function loader(extent) {
        // assemble WFS GetFeature request
        var wfsRequest = lConf.url + '?service=WFS&' + 'version=' + lConf.version + '&request=GetFeature&' + 'typename=' + lConf.typeName + '&' + 'outputFormat=' + outputFormat + '&srsname=' + lConf.projection; // add WFS version dependent feature limitation

        if (__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_is_integer___default()(parseInt(lConf.maxFeatures))) {
          var _context;

          if (__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_starts_with___default()(_context = lConf.version).call(_context, '1.')) {
            wfsRequest += '&maxFeatures=' + lConf.maxFeatures;
          } else {
            wfsRequest += '&count=' + lConf.maxFeatures;
          }
        } // add bbox filter


        if (lConf.loadOnlyVisible !== false) {
          if (mapSrs !== lConf.projection) {
            extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_ol_extent__["i" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_ol_proj__["b" /* getTransform */])(mapSrs, lConf.projection));
          }

          wfsRequest += '&bbox=' + extent.join(',') + ',' + lConf.projection + '';
        } // load data from WFS, parse and add to vector source


        var request = {
          method: 'GET',
          url: wfsRequest
        };
        __WEBPACK_IMPORTED_MODULE_28_axios___default()(request).then(function (response) {
          var feats = vectorSource.getFormat().readFeatures(response.data);
          vectorSource.addFeatures(feats);
        }).catch(function () {
          vectorSource.removeLoadedExtent(extent);
        });
      },
      strategy: lConf.loadOnlyVisible !== false ? __WEBPACK_IMPORTED_MODULE_24_ol_loadingstrategy__["b" /* bbox */] : undefined
    });
    var vector = new __WEBPACK_IMPORTED_MODULE_21_ol_layer_Vector__["a" /* default */](_objectSpread(_objectSpread({}, this.getCommonLayerOptions(lConf)), {}, {
      source: vectorSource,
      style: __WEBPACK_IMPORTED_MODULE_25__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      columnMapping: lConf.columnMapping,
      hoverable: lConf.hoverable,
      hoverAttribute: lConf.hoverAttribute,
      hoverOverlay: lConf.hoverOverlay
    }));
    return vector;
  },

  /**
   * Returns an XYZ based tile layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL XYZ layer instance
   */
  createXyzLayer: function createXyzLayer(lConf) {
    var xyzLayer = new __WEBPACK_IMPORTED_MODULE_8_ol_layer__["c" /* Tile */](_objectSpread(_objectSpread({}, this.getCommonLayerOptions(lConf)), {}, {
      source: new __WEBPACK_IMPORTED_MODULE_23_ol_source_XYZ__["a" /* default */]({
        url: lConf.url,
        tileGrid: lConf.tileGrid,
        projection: lConf.projection,
        crossOrigin: lConf.crossOrigin
      })
    }));
    return xyzLayer;
  },

  /**
   * Returns an OpenLayers OSM layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL OSM layer instance
   */
  createOsmLayer: function createOsmLayer(lConf) {
    var layer = new __WEBPACK_IMPORTED_MODULE_8_ol_layer__["c" /* Tile */](_objectSpread(_objectSpread({}, this.getCommonLayerOptions(lConf)), {}, {
      source: new __WEBPACK_IMPORTED_MODULE_11_ol_source_OSM__["b" /* default */]({
        crossOrigin: lConf.crossOrigin
      })
    }));
    return layer;
  },

  /**
   * Returns an OpenLayers vector layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Vector} OL vector layer instance
   */
  createVectorLayer: function createVectorLayer(lConf) {
    var vectorLayer = new __WEBPACK_IMPORTED_MODULE_21_ol_layer_Vector__["a" /* default */](_objectSpread(_objectSpread({}, this.getCommonLayerOptions(lConf)), {}, {
      source: new __WEBPACK_IMPORTED_MODULE_22_ol_source_Vector__["a" /* default */]({
        url: lConf.url,
        format: new this.formatMapping[lConf.format](lConf.formatConfig)
      }),
      style: __WEBPACK_IMPORTED_MODULE_25__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      columnMapping: lConf.columnMapping,
      hoverable: lConf.hoverable,
      hoverAttribute: lConf.hoverAttribute,
      hoverOverlay: lConf.hoverOverlay
    }));
    return vectorLayer;
  },

  /**
   * Returns an OpenLayers vector tile layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.VectorTile} OL vector tile layer instance
   */
  createVectorTileLayer: function createVectorTileLayer(lConf) {
    var vtLayer = new __WEBPACK_IMPORTED_MODULE_12_ol_layer_VectorTile__["a" /* default */](_objectSpread(_objectSpread({}, this.getCommonLayerOptions(lConf)), {}, {
      source: new __WEBPACK_IMPORTED_MODULE_13_ol_source_VectorTile__["a" /* default */]({
        url: lConf.url,
        format: new this.formatMapping[lConf.format](),
        tileGrid: lConf.tileGrid,
        projection: lConf.projection
      }),
      style: __WEBPACK_IMPORTED_MODULE_25__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      hoverable: lConf.hoverable,
      hoverAttribute: lConf.hoverAttribute,
      hoverOverlay: lConf.hoverOverlay
    }));
    return vtLayer;
  }
};

/***/ }),

/***/ "Og0H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-infoclick-win",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon},on:{"visibility-change":_vm.show}},'wgu-module-card',_vm.$attrs,false),[(!this.showMedia)?_c('div',[_c('v-card-title',{staticClass:"wgu-infoclick-win-title",attrs:{"primary-title":""}},[(!this.attributeData && !this.coordsData)?_c('v-card-text',{staticClass:"no-data"},[_vm._v("\n        "+_vm._s(_vm.$t('wgu-infoclick.mapClick'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('wgu-property-table',{attrs:{"properties":_vm.attributeData}}),_vm._v(" "),_c('wgu-coords-table',{attrs:{"coordsData":_vm.coordsData}})],1)],1):_vm._e(),_vm._v(" "),(this.showMedia)?_c('div',[(!this.attributeData)?_c('v-card-text',{staticClass:"no-data"},[_vm._v(" \n      "+_vm._s(_vm.$t('wgu-infoclick.mediaClick'))+"\n    ")]):_vm._e(),_vm._v(" "),(this.attributeData)?_c('v-img',{attrs:{"height":"250","src":this.attributeData[this.imageProp]}}):_vm._e(),_vm._v(" "),(this.attributeData && this.attributeData[_vm.imageDescriptionProp])?_c('v-card-text',[_vm._v("\n      "+_vm._s(this.attributeData[_vm.imageDescriptionProp])+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-card-actions',[(this.attributeData && this.attributeData[_vm.mediaInfoLinkUrlProp])?_c('v-btn',{attrs:{"text":"","color":"secondary","href":this.attributeData[_vm.mediaInfoLinkUrlProp],"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.$t('wgu-infoclick.mediaInfoLinkText') || this.attributeData[_vm.mediaInfoLinkUrlProp])+"\n      ")]):_vm._e()],1)],1):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "Op2c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5f+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-logo',
  data: function data() {
    return {
      logoSrc: this.$appConfig.logo,
      logoSize: this.$appConfig.logoSize,
      logoWidth: this.$appConfig.logoWidth,
      logoHeight: this.$appConfig.logoHeight
    };
  },
  created: function created() {
    // for backwards compat we use logoSize if width and height are missing
    if (this.logoSize && !this.logoWidth && !this.logoHeight) {
      this.logoWidth = this.logoSize;
      this.logoHeight = this.logoSize;
    }
  }
});

/***/ }),

/***/ "PHLi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PJIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__ = __webpack_require__("EmY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_entries__ = __webpack_require__("FRTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_includes__ = __webpack_require__("wk9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Layer__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_MapInteraction__ = __webpack_require__("wO5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_ViewAnimation__ = __webpack_require__("ntKu");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-attributetable',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_Mapable__["a" /* Mapable */]],
  props: {
    /** The ID of the vector layer to display */
    layerId: {
      type: String,
      required: false,
      default: null
    },

    /** The name of the unique feature identifier */
    uniqueRecordKeyName: {
      type: String,
      required: false,
      default: 'fid'
    },

    /**
     * How many rows a page of the table should have.
     * Should be manually adjusted with tableHeight.
     */
    rowsPerPage: {
      type: Number,
      required: false,
      default: 10
    },

    /**
     * The height of the table in pixel.
     * Should be manually adjusted with rowsPerPage.
     */
    tableHeight: {
      type: Number,
      required: false,
      default: 272
    },

    /** If map and table should be synced */
    syncTableMapSelection: {
      type: Boolean,
      required: false,
      default: true
    },

    /** A list of column names that should not be displayed. */
    forbiddenColumnNames: {
      type: Array,
      required: false,
      default: function _default() {
        return ['geometry', 'the_geom'];
      }
    }
  },
  data: function data() {
    return {
      headers: [],
      records: [],
      features: [],
      selectedRow: [],
      layer: null,
      loading: true,
      page: 1
    };
  },
  created: function created() {
    this.populateTable();

    if (this.syncTableMapSelection) {
      this.activateSelectRowOnMapClick();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.layer && this.layer.getSource()) {
      // unregister event after table is closed
      this.layer.getSource().un('change', this.prepareTableDataAndColumns);
    }
  },
  watch: {
    layerId: function layerId() {
      this.populateTable();
    },
    features: function features() {
      var _context,
          _this = this;

      this.records = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = this.features).call(_context, function (feature) {
        var record = feature.getProperties(); // set feature id

        record[_this.uniqueRecordKeyName] = feature.getId();
        return record;
      });
    },
    records: function records() {
      // set loading status depending if records are available
      if (this.records.length === 0) {
        this.loading = true;
      } else {
        this.loading = false;
        this.highlightInitialFeatureSelectionInTable();
      }
    }
  },
  methods: {
    /**
     * Highlight row when feature is already selected
     * before table is opened.
     */
    highlightInitialFeatureSelectionInTable: function highlightInitialFeatureSelectionInTable() {
      var correspondingInteraction = __WEBPACK_IMPORTED_MODULE_11__util_MapInteraction__["a" /* default */].getSelectInteraction(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this), this.layerId);

      if (!correspondingInteraction) {
        return;
      }

      var features = correspondingInteraction.getFeatures();

      if (!features || features.getLength() !== 1) {
        return;
      }

      var feature = features.getArray()[0];

      if (!feature) {
        return;
      }

      var fid = feature.getId();

      if (!fid) {
        return;
      }

      this.highlightRowFromSelectedFeature(fid);
    },

    /**
     * Set the table height depending on desktop
     * or mobile view.
     *
     * @returns {int} The height of the table.
     */
    getTableHeight: function getTableHeight() {
      if (this.$vuetify.breakpoint.xs) {
        // we do not want to set this property
        return undefined;
      } else {
        return this.tableHeight;
      }
    },

    /**
     * Activate behaviour that a selected feature on the
     * map will be selected in the AttributeTable as well.
     */
    activateSelectRowOnMapClick: function activateSelectRowOnMapClick() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_10__WguEventBus__["a" /* WguEventBus */].$on('map-selectionchange', function (lid, featureArray) {
        if (lid !== _this2.layerId || featureArray.length !== 1) {
          return;
        }

        var fid = featureArray[0].getId();

        _this2.highlightRowFromSelectedFeature(fid);
      });
    },

    /**
     * Highlight row matching the feature ID
     * and set correct page of the table.
     *
     * @param {Number} fid The ID of the selected feature.
     */
    highlightRowFromSelectedFeature: function highlightRowFromSelectedFeature(fid) {
      var _context2,
          _this3 = this;

      if (!fid) {
        return;
      }

      var foundRecord = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context2 = this.records).call(_context2, function (record) {
        return record.fid === fid;
      });

      if (!foundRecord) {
        return;
      }

      this.selectedRow = [foundRecord];
      var recIndex = this.records.indexOf(foundRecord);

      if (!recIndex) {
        return;
      }

      this.$nextTick(function () {
        // calculate page and set it
        _this3.page = Math.ceil((recIndex + 1) / _this3.rowsPerPage);
      });
    },

    /**
     * Handler for click on a row.
     *
     * It zooms to the clicked features.
     *
     * If the layer is 'selectable', the corresponding feature on the
     * map will be styled as selected.
     */
    onRowClick: function onRowClick(record) {
      var _context3;

      if (!this.syncTableMapSelection) {
        return;
      }

      var fid = record[this.uniqueRecordKeyName];

      if (!fid) {
        return;
      }

      this.selectedRow = [record];

      var foundFeature = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context3 = this.features).call(_context3, function (feature) {
        return feature.getId() === fid;
      });

      if (!foundFeature) {
        return;
      } // zoom to feature


      __WEBPACK_IMPORTED_MODULE_12__util_ViewAnimation__["a" /* default */].to(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView(), foundFeature.getGeometry());
      var correspondingInteraction = __WEBPACK_IMPORTED_MODULE_11__util_MapInteraction__["a" /* default */].getSelectInteraction(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this), this.layerId); // we can only select layers that have a select interaction

      if (!correspondingInteraction) {
        return;
      } // add to map selection


      correspondingInteraction.getFeatures().clear();
      correspondingInteraction.getFeatures().push(foundFeature);
    },

    /**
     * Load features from layer and display it in
     * in the table.
     */
    populateTable: function populateTable() {
      if (!__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this) || !this.layerId) {
        return;
      } // reset table properties


      this.records = [];
      this.features = [];
      this.headers = [];
      this.selectedRow = [];
      this.page = 1;
      this.layer = __WEBPACK_IMPORTED_MODULE_9__util_Layer__["a" /* default */].getLayerByLid(this.layerId, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)); // load currently available features

      this.prepareTableDataAndColumns(); // features can only be loaded if layer is visible
      // that's why we switch the layers on and retrieve them
      // once the features are available
      // https://github.com/openlayers/openlayers/blob/main/doc/faq.md#why-arent-there-any-features-in-my-source

      this.layer.getSource().on('change', this.prepareTableDataAndColumns);
      this.layer.setVisible(true);
    },

    /**
     * Loads the features from the layer source and
     * prepares the required columns for the table.
     */
    prepareTableDataAndColumns: function prepareTableDataAndColumns() {
      this.features = this.layer.getSource().getFeatures();
      this.applyColumnMapping();
    },

    /**
     * Read column mapping from layer property.
     * Otherwise we retrieve it from the feature
     * properties names.
     */
    applyColumnMapping: function applyColumnMapping() {
      var _this4 = this;

      if (!this.layer.getSource() || !this.layer.getSource().getFeatures() || !this.layer.getSource().getFeatures()[0]) {
        return;
      }

      var headers = [];

      if (this.layer.get('columnMapping')) {
        for (var _i = 0, _Object$entries = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_entries___default()(this.layer.get('columnMapping')); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_Object$entries[_i], 2),
              propertyName = _Object$entries$_i[0],
              displayName = _Object$entries$_i[1];

          headers.push({
            text: displayName,
            value: propertyName
          });
        }
      } else {
        // TODO: taking the first feature assumes that all features
        //       have the same structure
        var keys = this.layer.getSource().getFeatures()[0].getKeys(); // remove keys that contain a geometry

        var filtered = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_filter___default()(keys).call(keys, function (key) {
          var _context4;

          return !__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_includes___default()(_context4 = _this4.forbiddenColumnNames).call(_context4, key);
        });

        filtered.forEach(function (propertyName) {
          headers.push({
            text: propertyName,
            value: propertyName
          });
        });
      }

      this.headers = headers;
    }
  }
});

/***/ }),

/***/ "PKmJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsFeatureInfoModuleWin_vue__ = __webpack_require__("WhIP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31736940_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsFeatureInfoModuleWin_vue__ = __webpack_require__("QU+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("jzAQ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsFeatureInfoModuleWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31736940_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsFeatureInfoModuleWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31736940_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsFeatureInfoModuleWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PSzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"expand":""}},_vm._l((_vm.displayedLayers),function(layer){return _c('wgu-layerlistitem',{key:layer.get('lid'),attrs:{"layer":layer,"mapView":_vm.map.getView(),"showLegends":_vm.showLegends,"showOpacityControls":_vm.showOpacityControls}})}),1)}
var staticRenderFns = []


/***/ }),

/***/ "QU+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"ids-feature-info",attrs:{"moduleName":"ids-feature-info-module","icon":_vm.icon}},'wgu-module-card',_vm.$attrs,false),[(Object.keys(_vm.featureProperties).length === 0)?_c('v-card',{attrs:{"outlined":""}},[(_vm.welcomeImageUrl)?_c('v-img',{attrs:{"src":_vm.welcomeImageUrl,"height":"200px"}}):_vm._e(),_vm._v(" "),_c('v-card-subtitle',{staticStyle:{"font-style":"italic"}},[_vm._v("\n      "+_vm._s(_vm.$t('ids-feature-info-module.welcomeText'))+"\n    ")])],1):_c('wgu-property-table',{attrs:{"properties":_vm.featureProperties}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "R3+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoordsTable_vue__ = __webpack_require__("L1xf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f763f33_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__ = __webpack_require__("cmEL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Iw4/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoordsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f763f33_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f763f33_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RAvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_source___ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_layer_Group__ = __webpack_require__("0uY1");


//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-maploading-status',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__["a" /* Mapable */]],
  data: function data() {
    return {
      loading: 0,
      visible: false
    };
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     * and registers the current map layers.
     */
    onMapBound: function onMapBound() {
      var me = this;
      me.registerLayers(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).getLayerGroup());
    },

    /**
     * Registers the needed events for the passed layer and takes care
     * of layer groups by calling itself recursively.
     *
     * @param  {ol/layer/Base | ol/layer/Group} layer Layer or group to register
     */
    registerLayers: function registerLayers(layer) {
      var me = this;

      if (layer instanceof __WEBPACK_IMPORTED_MODULE_4_ol_layer_Group__["a" /* default */]) {
        // call ourself recursively
        var layers = layer.getLayers();
        layers.forEach(function (child) {
          me.registerLayers(child);
        }); // handle future changes to this group or stop doing so

        layers.on('add', me.onLayerAddedToGroup, me);
        layers.on('remove', me.onLayerRemovedFromGroup, me);
      } else {
        var source = layer.getSource();
        me.bindLoadHandlers(source, true); // reacting on a changed source in a layer

        layer.on('change:source', function (evt) {
          me.bindLoadHandlers(evt.target.getSource(), true);
          me.bindLoadHandlers(evt.oldValue, false);
        });
      }
    },

    /**
     * Registers needed events for the passed source and takes care
     * of sources which do not naturally support load events (`vector`-sources).
     *
     * @param  {ol/source/Source} source The layer source to register
     */
    bindLoadHandlers: function bindLoadHandlers(source, register) {
      var me = this;
      var eventPrefix = '';
      var method = register ? 'on' : 'un';

      if (source instanceof __WEBPACK_IMPORTED_MODULE_3_ol_source___["c" /* Image */]) {
        // includes ImageWms, also e.g. ImageArcGISRest, OSM …
        eventPrefix = 'image';
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_3_ol_source___["d" /* TileImage */]) {
        // includes TileWMS, Bing and more
        eventPrefix = 'tile';
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_3_ol_source___["a" /* Vector */]) {
        if (source instanceof __WEBPACK_IMPORTED_MODULE_3_ol_source___["b" /* Cluster */]) {
          source = source.getSource();
        }

        eventPrefix = 'vector';
      }

      if (eventPrefix) {
        source[method](eventPrefix + 'loadstart', me.incrementLoading, me);
        source[method](eventPrefix + 'loadend', me.decrementLoading, me);
        source[method](eventPrefix + 'loaderror', me.decrementLoading, me);
      }
    },

    /**
     * Called whenever loading of a layer starts.
     * This will increment the internal counter and show this loading indicator.
     */
    incrementLoading: function incrementLoading() {
      var me = this;
      me.loading++;
      me.visible = true;
    },

    /**
     * Called whenever loading stops or errors.
     * This will decrement the internal counter and if nothing is currently
     * loading the counter is reset and the loading indicator is hidden.
     */
    decrementLoading: function decrementLoading() {
      var me = this;
      me.loading--;

      if (me.loading <= 0) {
        me.visible = false;
        me.resetLoading();
      }
    },

    /**
     * Helper method to reset the internal loading counter.
     */
    resetLoading: function resetLoading() {
      this.loading = 0;
    },

    /**
     * Takes care of added layers to any `ol/layer/Group`. These need to get
     * registered to the appropriate handlers.
     *
     * @param {ol/events/Event} evt The add event of the `ol/layer/Group`.
     */
    onLayerAddedToGroup: function onLayerAddedToGroup(evt) {
      this.registerLayers(evt.element);
    },

    /**
     * Takes care of removed layers to any `ol/layer/Group`. These need to get
     * unregistered from the appropriate handlers.
     *
     * @param {ol/events/Event} evt The remove event of the `ol/layer/Group`.
     */
    onLayerRemovedFromGroup: function onLayerRemovedFromGroup(evt) {
      this.registerLayers(evt.element);
    }
  }
});

/***/ }),

/***/ "RCTG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modulecore_ToggleButton_vue__ = __webpack_require__("TVSi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ColorTheme__ = __webpack_require__("ATxE");
// Control to switch between light and dark mode


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__modulecore_ToggleButton_vue__["a" /* default */],
  name: 'wgu-themeswitcher',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_ColorTheme__["a" /* ColorTheme */]],
  watch: {
    isDarkTheme: {
      // When dark theme changes via Vuetify
      handler: function handler(value) {
        // update toggle state of this tool
        if (value !== this.show) {
          this.show = value;
        }
      },
      immediate: true
    },
    show: {
      // When dark theme changes via this tool
      handler: function handler(value) {
        // update Vuetify state
        if (value !== this.$vuetify.theme.dark) {
          // untoggled state of v-btn-toggle
          // returns undefined, so we !!undefined
          this.$vuetify.theme.dark = !!value;
        }
      }
    }
  }
});

/***/ }),

/***/ "RYap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.show,"opacity":0.25}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "SPmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SqAI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SrJs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__ = __webpack_require__("0WSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator__ = __webpack_require__("I3KW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IdsLocationTypeChooser_vue__ = __webpack_require__("uk3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IdsCorporaFilter_vue__ = __webpack_require__("qMls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IdsGeographicFilter_vue__ = __webpack_require__("6lHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DgdDataLoader__ = __webpack_require__("3GfT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IdsFilterGenerator_js__ = __webpack_require__("KzfC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IdsCorpusLookup_js__ = __webpack_require__("9HAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__ = __webpack_require__("ZkkH");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ids-filter-module-win',
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_3__src_components_modulecore_ModuleCard__["a" /* default */],
    'ids-location-type-chooser': __WEBPACK_IMPORTED_MODULE_5__IdsLocationTypeChooser_vue__["a" /* default */],
    'ids-corpora-filter': __WEBPACK_IMPORTED_MODULE_6__IdsCorporaFilter_vue__["a" /* default */],
    'ids-geographic-filter': __WEBPACK_IMPORTED_MODULE_7__IdsGeographicFilter_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__src_mixins_Mapable__["a" /* Mapable */]],
  props: {
    icon: {
      type: String,
      required: false,
      default: 'filter'
    },
    showFilterOnStartup: {
      type: Boolean,
      required: false,
      default: true
    },
    closeFilterAfterApply: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted: function mounted() {
    // load all corpus
    this.loadData();
  },
  data: function data() {
    return {
      locationTypeList: null,
      corpusList: null,
      countryList: null,
      tab: null,
      tabItems: [{
        tab: 'Korpora',
        type: 'corpora'
      }, {
        tab: 'Geographisch',
        type: 'geo'
      }],
      // raw filter selections
      locationType: 'Aufnahmeort',
      corpusSelection: null,
      countrySelection: null,
      // { iso: 'DE', name: 'Deutschland' },
      regionSelection: null,
      // { name: 'Rheinland-Pfalz' }
      districtSelection: null,
      // { name: 'Rhein-Pfalz-Kreis' }
      // END raw filter selections
      apiError: false,
      // dev only, TODO remove
      dummyApiCall: '',
      snackbar: false,
      snackbarTimeout: 3500 // END dev only

    };
  },
  watch: {
    locationType: function locationType() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // firing event to inform IdsCorpusCategory that the location type changed
                // CM - 20230217: normally doable by data propagation, but did not work
                __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__["a" /* WguEventBus */].$emit('ids-locationtype-change');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  methods: {
    /**
     * Handler for 'ids-geog-filter-change' event of <ids-geographic-filter>
     */
    onGeographicFilterChange: function onGeographicFilterChange(type, value) {
      if (type === 'country') {
        this.countrySelection = value;
      } else if (type === 'region') {
        this.regionSelection = value;
      } else if (type === 'district') {
        this.districtSelection = value;
      }
    },

    /**
     * Loads data for underlying filter UIs.
     */
    loadData: function loadData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee2() {
        var initCorpusIds;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(__WEBPACK_IMPORTED_MODULE_10__IdsCorpusLookup_js__["a" /* default */].corpusList.length === 0)) {
                  _context2.next = 5;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__["a" /* WguEventBus */].$on('ids-corpus-list-load', function () {
                  _this.corpusList = __WEBPACK_IMPORTED_MODULE_10__IdsCorpusLookup_js__["a" /* default */].corpusList;

                  _this.loadData();
                });
                return _context2.abrupt("return");

              case 5:
                _this.corpusList = __WEBPACK_IMPORTED_MODULE_10__IdsCorpusLookup_js__["a" /* default */].corpusList;

              case 6:
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8__DgdDataLoader__["a" /* default */].getLocationTypeList();

              case 8:
                _this.locationTypeList = _context2.sent;
                // derive corpus list and its selection
                _this.corpusList = __WEBPACK_IMPORTED_MODULE_10__IdsCorpusLookup_js__["a" /* default */].corpusList;
                initCorpusIds = __WEBPACK_IMPORTED_MODULE_10__IdsCorpusLookup_js__["a" /* default */].initialCorpusIds;
                _this.corpusSelection = __WEBPACK_IMPORTED_MODULE_10__IdsCorpusLookup_js__["a" /* default */].getSelectionObjectByArr(initCorpusIds); // load all countries

                _context2.next = 14;
                return __WEBPACK_IMPORTED_MODULE_8__DgdDataLoader__["a" /* default */].getCountryList(_this.locationType);

              case 14:
                _this.countryList = _context2.sent;
                // signal to WguApp that all filter related base data is loaded
                __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__["a" /* WguEventBus */].$emit('ids-filter-base-data-load'); // show this filter module window, if configured in app.json

                if (_this.showFilterOnStartup) {
                  __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__["a" /* WguEventBus */].$emit('ids-filter-module-visibility-change', true);
                }

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * Creates the current filter and applies it to the request.
     */
    requestLocations: function requestLocations() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee3() {
        var geoJsonData, filter, geoFilter, _filter;

        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // show loading mask
                __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__["a" /* WguEventBus */].$emit('app-loading-mask-toggle', true); // inform that we plan to load new locations by filter

                __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__["a" /* WguEventBus */].$emit('ids-before-new-locations-load');

                if (!(_this2.tab === 0)) {
                  _context3.next = 14;
                  break;
                }

                if (!(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$devMode !== true)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8__DgdDataLoader__["a" /* default */].getLocationList(_this2.corpusSelection, _this2.locationType);

              case 6:
                geoJsonData = _context3.sent;
                _context3.next = 12;
                break;

              case 9:
                // corpora filter
                filter = __WEBPACK_IMPORTED_MODULE_9__IdsFilterGenerator_js__["a" /* default */].createFilter(_this2.locationType, _this2.corpusSelection);
                _this2.dummyApiCall = "get_location_list?".concat(filter);
                _this2.snackbar = true;

              case 12:
                _context3.next = 25;
                break;

              case 14:
                if (!(_this2.tab === 1)) {
                  _context3.next = 25;
                  break;
                }

                // GEOGRAPHIC FILTER
                geoFilter = {
                  countrySelection: _this2.countrySelection,
                  regionSelection: _this2.regionSelection,
                  districtSelection: _this2.districtSelection
                };

                if (!(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$devMode !== true)) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 19;
                return __WEBPACK_IMPORTED_MODULE_8__DgdDataLoader__["a" /* default */].getLocationListGeo(geoFilter, _this2.locationType);

              case 19:
                geoJsonData = _context3.sent;
                _context3.next = 25;
                break;

              case 22:
                // geographic filter
                _filter = __WEBPACK_IMPORTED_MODULE_9__IdsFilterGenerator_js__["a" /* default */].createFilter(_this2.locationType, null, // corpora filter has to be unset to get geographic filter
                geoFilter);
                _this2.dummyApiCall = "get_location_list_geographic?".concat(_filter);
                _this2.snackbar = true;

              case 25:
                if (geoJsonData) {
                  __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__["a" /* WguEventBus */].$emit('ids-new-locations-load', geoJsonData);
                } else {
                  // show a message to user that data could not be loaded
                  _this2.apiError = true;
                } // hide filter module window


                if (_this2.closeFilterAfterApply && geoJsonData && __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$devMode !== true) {
                  _this2.$refs['ids-filter-module-win'].toggleUi();
                } // hide loading mask


                __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__["a" /* WguEventBus */].$emit('app-loading-mask-toggle', false);

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
});

/***/ }),

/***/ "Ss2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{ref:"overviewmapPanel",staticClass:"pa-1",attrs:{"width":_vm.width,"height":_vm.height,"elevation":"8"}})}
var staticRenderFns = []


/***/ }),

/***/ "TVSi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("8tls");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_487cd62e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("MyfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_487cd62e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_487cd62e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TooU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measure-type-chooser',
  props: {
    measureType: {
      type: String,
      default: 'distance'
    }
  },
  data: function data() {
    return {
      measureTypeData: this.measureType
    };
  },
  watch: {
    // listen to changed measurement type and forward to parent component
    measureTypeData: function measureTypeData(newVal, oldVal) {
      this.$emit('wgu-measuretype-change', newVal, oldVal);
    }
  }
});

/***/ }),

/***/ "UTjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),

/***/ "UdpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_map_js__ = __webpack_require__("/TzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_string_split_js__ = __webpack_require__("388n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_string_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_string_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_regexp_exec_js__ = __webpack_require__("XEfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_regexp_exec_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_regexp_exec_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_object_to_string_js__ = __webpack_require__("vw/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_regexp_to_string_js__ = __webpack_require__("q4B+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_number_to_fixed_js__ = __webpack_require__("9P18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_number_to_fixed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_number_to_fixed_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_trim__ = __webpack_require__("9gOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_Map__ = __webpack_require__("trid");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_View__ = __webpack_require__("Lfyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_control_Attribution__ = __webpack_require__("bAyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ol_control_Zoom__ = __webpack_require__("Lmaf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ol_interaction__ = __webpack_require__("TDso");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ol_control_Rotate__ = __webpack_require__("lZ2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_ol_proj_Projection__ = __webpack_require__("7rnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ol_tilegrid_TileGrid__ = __webpack_require__("clnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_ol_proj_proj4__ = __webpack_require__("4Asb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ol_format__ = __webpack_require__("3Zsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_ol_layer__ = __webpack_require__("ItK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_ol_source__ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_proj4__ = __webpack_require__("nvAS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__factory_Layer_js__ = __webpack_require__("OUzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_Layer__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__PermalinkController__ = __webpack_require__("1l2W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__HoverController__ = __webpack_require__("IIm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__util_MapInteraction__ = __webpack_require__("wO5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__util_ViewAnimation__ = __webpack_require__("ntKu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__mixins_ColorTheme__ = __webpack_require__("ATxE");











//
//














 // import the app-wide EventBus









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-map',
  mixins: [__WEBPACK_IMPORTED_MODULE_33__mixins_ColorTheme__["a" /* ColorTheme */]],
  props: {
    collapsibleAttribution: {
      type: Boolean,
      default: false
    },
    rotateableMap: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      zoom: this.$appConfig.mapZoom,
      center: this.$appConfig.mapCenter,
      projection: this.$appConfig.mapProjection,
      projectionObj: null,
      projectionDefs: this.$appConfig.projectionDefs,
      tileGridDefs: this.$appConfig.tileGridDefs || {},
      tileGrids: {},
      permalink: this.$appConfig.permalink,
      mapGeodataDragDop: this.$appConfig.mapGeodataDragDop,
      // mapping format string to OL module / class
      formatMapping: {
        GPX: __WEBPACK_IMPORTED_MODULE_22_ol_format__["a" /* GPX */],
        GeoJSON: __WEBPACK_IMPORTED_MODULE_22_ol_format__["b" /* GeoJSON */],
        IGC: __WEBPACK_IMPORTED_MODULE_22_ol_format__["c" /* IGC */],
        KML: __WEBPACK_IMPORTED_MODULE_22_ol_format__["d" /* KML */],
        TopoJSON: __WEBPACK_IMPORTED_MODULE_22_ol_format__["e" /* TopoJSON */]
      },
      dragDropLayerCreated: false
    };
  },
  mounted: function mounted() {
    var me = this; // Make the OL map accessible for Mapable mixin even 'ol-map-mounted' has
    // already been fired. Don not use directly in cmps, use Mapable instead.

    __WEBPACK_IMPORTED_MODULE_11_vue__["default"].prototype.$map = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(me); // Set the target for the OL canvas and tie it`s size to ol-map-container.
    // Remarks: 'ol-map-container' does not exist in the scope of the current unit test,
    // therefore flag the initialization to prevent errors.

    var container = document.getElementById('ol-map-container');

    if (container) {
      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).setTarget(container);

      var resizeObserver = new ResizeObserver(function () {
        __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).updateSize();
      });
      resizeObserver.observe(container);
    } // Send the event 'ol-map-mounted' with the OL map as payload


    __WEBPACK_IMPORTED_MODULE_26__WguEventBus_js__["a" /* WguEventBus */].$emit('ol-map-mounted', __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(me)); // TODO
    //  Re-evaluate whether and if yes which of the following operations have to be deferred.
    //  If so, a better implementation could be to rely on this.$nextTick(), which currently causes trouble
    //  for the units tests (deferred operations are invoked after the component has already been destroyed).

    me.timerHandle = setTimeout(function () {
      // adjust the bg color of the OL buttons (like zoom, rotate north, ...)
      me.setOlButtonColor();
    }, 200);
  },
  destroyed: function destroyed() {
    // Send the event 'ol-map-unmounted' with the OL map as payload
    __WEBPACK_IMPORTED_MODULE_26__WguEventBus_js__["a" /* WguEventBus */].$emit('ol-map-unmounted', __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)); // Destroy controllers, remove map references

    if (this.timerHandle) {
      clearTimeout(this.timerHandle);
    }

    if (this.permalinkController) {
      this.permalinkController.tearDown();
      this.permalinkController = undefined;
    }

    if (this.hoverController) {
      this.hoverController.destroy();
      this.hoverController = undefined;
    }

    if (__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)) {
      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().clear();

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getInteractions().clear();

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getControls().clear();

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getOverlays().clear();
    }

    this.map = undefined;
  },
  created: function created() {
    var _context,
        _this = this;

    // make map rotateable according to property
    var interactions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_ol_interaction__["a" /* defaults */])({
      altShiftDragRotate: this.rotateableMap,
      pinchRotate: this.rotateableMap
    }); // add geodata drag-drop support according to config

    if (this.mapGeodataDragDop) {
      var dragAndDropInteraction = this.setupGeodataDragDrop();
      interactions.push(dragAndDropInteraction);
    }

    var controls = [new __WEBPACK_IMPORTED_MODULE_15_ol_control_Zoom__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_14_ol_control_Attribution__["a" /* default */]({
      collapsible: this.collapsibleAttribution
    })]; // add a button control to reset rotation to 0, if map is rotateable

    if (this.rotateableMap) {
      controls.push(new __WEBPACK_IMPORTED_MODULE_17_ol_control_Rotate__["a" /* default */]());
    } // Optional projection (EPSG) definitions for Proj4


    if (this.projectionDefs) {
      // Add all (array of array)
      __WEBPACK_IMPORTED_MODULE_25_proj4__["a" /* default */].defs(this.projectionDefs); // Register with OpenLayers

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_ol_proj_proj4__["a" /* register */])(__WEBPACK_IMPORTED_MODULE_25_proj4__["a" /* default */]);
    } // Projection for map, default is Web Mercator


    var projection;

    if (!this.projection) {
      projection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_ol_proj__["a" /* get */])('EPSG:3857');
    } else {
      projection = new __WEBPACK_IMPORTED_MODULE_18_ol_proj_Projection__["a" /* default */](this.projection);
    } // Optional TileGrid definitions by name, for ref in Layers


    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(this.tileGridDefs)).call(_context, function (name) {
      _this.tileGrids[name] = new __WEBPACK_IMPORTED_MODULE_19_ol_tilegrid_TileGrid__["a" /* default */](_this.tileGridDefs[name]);
    });

    this.map = new __WEBPACK_IMPORTED_MODULE_12_ol_Map__["a" /* default */]({
      layers: [],
      controls: controls,
      interactions: interactions,
      view: new __WEBPACK_IMPORTED_MODULE_13_ol_View__["a" /* default */]({
        center: this.center,
        zoom: this.zoom,
        projection: projection
      })
    }); // create layers from config and add them to map

    this.registerLayerEvents();
    var layers = this.createLayers();

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().extend(layers);

    this.hoverController = this.createHoverController();

    if (this.$appConfig.permalink) {
      this.permalinkController = this.createPermalinkController();

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).set('permalinkcontroller', this.permalinkController, true);

      this.permalinkController.apply();
      this.permalinkController.setup();
    }
  },
  methods: {
    /**
     * Creates the OL layers due to the "mapLayers" array in app config.
     * @return {ol.layer.Base[]} Array of OL layer instances
     */
    createLayers: function createLayers() {
      var me = this;
      var layers = [];
      var appConfig = this.$appConfig;
      var mapLayersConfig = appConfig.mapLayers || [];
      mapLayersConfig.reverse().forEach(function (lConf) {
        var _lConf$zIndex, _lConf$supportsPermal;

        // Some Layers may require a TileGrid object
        // Remarks: Passing null instead of undefined as parameters into the
        //  constructor of OpenLayers sources overwrites OpenLayers defaults.
        lConf.tileGrid = lConf.tileGridRef ? me.tileGrids[lConf.tileGridRef] : undefined; // Automatically set the appropriate z-index for the layer type,
        // if not defined explicitly.

        lConf.zIndex = (_lConf$zIndex = lConf.zIndex) !== null && _lConf$zIndex !== void 0 ? _lConf$zIndex : lConf.isBaseLayer ? -1 : 0; // Default usage of permalink to true, if not explicitly defined.

        lConf.supportsPermalink = (_lConf$supportsPermal = lConf.supportsPermalink) !== null && _lConf$supportsPermal !== void 0 ? _lConf$supportsPermal : true;
        var layer = __WEBPACK_IMPORTED_MODULE_27__factory_Layer_js__["a" /* LayerFactory */].getInstance(lConf, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(me));
        layers.push(layer); // if layer is selectable register a select interaction

        if (lConf.selectable) {
          var selectClick = __WEBPACK_IMPORTED_MODULE_31__util_MapInteraction__["a" /* default */].createSelectInteraction(layer, lConf.selectStyle, lConf.doAppendSelectStyle); // register/activate interaction on map

          __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).addInteraction(selectClick);
        }
      });
      return layers;
    },

    /**
     * Hook up events to process newly added and modified OL layers.
     * This is currently used to update locale specific layer properties.
     */
    registerLayerEvents: function registerLayerEvents() {
      var _this2 = this;

      var layers = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers();

      layers.on('add', function (evt) {
        var layer = evt.element;

        _this2.updateLocalizedLayerProps(evt.element);

        layer.on('propertychange', function (evt) {
          if (evt.key === 'lid' || evt.key === 'langKey') {
            _this2.updateLocalizedLayerProps(evt.target);
          }
        });
      });
    },

    /**
     * Creates a HoverController, override in subclass for specializations.
     *
     * @return {HoverController} HoverController instance.
     */
    createHoverController: function createHoverController() {
      return new __WEBPACK_IMPORTED_MODULE_30__HoverController__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this));
    },

    /**
     * Creates a PermalinkController, override in subclass for specializations.
     *
     * @return {PermalinkController} PermalinkController instance.
     */
    createPermalinkController: function createPermalinkController() {
      return new __WEBPACK_IMPORTED_MODULE_29__PermalinkController__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this), this.$appConfig.permalink);
    },

    /**
     * Sets the background color of the OL buttons to the color property.
     */
    setOlButtonColor: function setOlButtonColor() {
      var _context2;

      var colors = 'secondary onsecondary--text'; // apply vuetify color by transforming the color to the corresponding
      // CSS class (see https://vuetifyjs.com/en/framework/colors)

      var classes = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_trim___default()(_context2 = colors.toString()).call(_context2).split(' '); // zoom


      if (document.querySelector('.ol-zoom')) {
        classes.forEach(function (c) {
          document.querySelector('.ol-zoom .ol-zoom-in').classList.add(c);
          document.querySelector('.ol-zoom .ol-zoom-out').classList.add(c);
        });
      } // rotate


      if (document.querySelector('.ol-rotate')) {
        classes.forEach(function (c) {
          document.querySelector('.ol-rotate .ol-rotate-reset').classList.add(c);
        });
      }
    },

    /**
     * Initializes the geodata drag-drop functionality:
     * Adds the ol/interaction/DragAndDrop to the map and draws the dropped
     * features in a vector layer
     */
    setupGeodataDragDrop: function setupGeodataDragDrop() {
      var _context3,
          _context4,
          _this3 = this;

      var mapDdConf = this.mapGeodataDragDop;

      var formats = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context3 = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context4 = mapDdConf.formats).call(_context4, function (formatStr) {
        return _this3.formatMapping[formatStr];
      })).call(_context3, function (fs) {
        return _this3.formatMapping[fs];
      });

      var dragAndDropInteraction = new __WEBPACK_IMPORTED_MODULE_16_ol_interaction__["b" /* DragAndDrop */]({
        formatConstructors: formats
      });
      dragAndDropInteraction.on('addfeatures', function (event) {
        var ddSource;

        if (mapDdConf.replaceData !== false) {
          if (!_this3.dragDropLayerCreated) {
            _this3.createDragDropLayer(mapDdConf);

            _this3.dragDropLayerCreated = true;
          } // replace existing geodata with the newly dropped data set


          var ddLayer = __WEBPACK_IMPORTED_MODULE_28__util_Layer__["a" /* default */].getLayersBy('wegueDragDropLayer', true, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this3))[0];
          ddSource = ddLayer.getSource();
          ddSource.clear();
        } else {
          // add new layer for each dropped data set
          var newDdLayer = _this3.createDragDropLayer(mapDdConf);

          ddSource = newDdLayer.getSource();
        }

        ddSource.addFeatures(event.features);

        if (mapDdConf.zoomToData === true) {
          __WEBPACK_IMPORTED_MODULE_32__util_ViewAnimation__["a" /* default */].to(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this3).getView(), ddSource.getExtent());
        }
      }, this);
      return dragAndDropInteraction;
    },

    /**
     * Creates the vector layer for showing drag/drop geodata on the map.
     *
     * @param {Object} mapDdConf the config object for this functionality
     */
    createDragDropLayer: function createDragDropLayer(mapDdConf) {
      var vectorSource = new __WEBPACK_IMPORTED_MODULE_24_ol_source__["a" /* Vector */]({});
      var vectorLayer = new __WEBPACK_IMPORTED_MODULE_23_ol_layer__["a" /* Vector */]({
        // random unique layer ID
        // For localization the randomized layer ID cannot be used, therefore map it to a fixed key
        // which will be part of the language path ('mapLayers.wgu-drag-drop-layer')
        lid: 'wgu-drag-drop-layer-' + (Math.random() * 1000000).toFixed(0),
        langKey: 'wgu-drag-drop-layer',
        wegueDragDropLayer: true,
        source: vectorSource,
        displayInLayerList: mapDdConf.displayInLayerList
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).addLayer(vectorLayer);

      return vectorLayer;
    },

    /**
     * Updates locale specific layer properties. This is typically invoked after changes to
     * layer attributes, changes to the OpenLayers layer collection to process new layers
     * or after changes to the active locale.
     *
     * Remarks:
     * If a layer definition exists in the application context, any 'name' or 'attribution'
     * property declared there will take precedence over the ones declared in the
     * language packs.
     *
     * @param {ol.layer.Layer} OL layer instance
     */
    updateLocalizedLayerProps: function updateLocalizedLayerProps(layer) {
      var langKey = layer.get('langKey') || layer.get('lid');
      var pathLayer = 'mapLayers.' + langKey; // Update layer name.

      var pathName = pathLayer + '.name';
      layer.set('name', layer.get('confName') || this.$t(pathName)); // Update optional layer attributions.

      var pathAttributions = pathLayer + '.attributions';
      var source = layer.getSource();

      if (source && typeof source.setAttributions === 'function' && (layer.get('confAttributions') || this.$te(pathAttributions))) {
        source.setAttributions(layer.get('confAttributions') || this.$t(pathAttributions));
      }
    }
  },
  watch: {
    /**
     * Watch for locale changes and update language specific layer attributes.
     */
    '$i18n.locale': function $i18nLocale() {
      var _this4 = this;

      var layers = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers();

      layers.forEach(function (layer) {
        _this4.updateLocalizedLayerProps(layer);
      });
    }
  }
});

/***/ }),

/***/ "UkhJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpWin_vue__ = __webpack_require__("7OTJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eacfe428_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__ = __webpack_require__("4pN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Jzb7")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eacfe428"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eacfe428_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eacfe428_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UzS5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VLBH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LayerListItem__ = __webpack_require__("vMuv");


//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist',
  components: {
    'wgu-layerlistitem': __WEBPACK_IMPORTED_MODULE_3__LayerListItem__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__["a" /* Mapable */]],
  props: {
    showLegends: {
      type: Boolean,
      required: true
    },
    showOpacityControls: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      layers: []
    };
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound: function onMapBound() {
      this.layers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray();
    }
  },
  computed: {
    /**
     * Reactive property to return the OpenLayers layers to be shown in the control.
     * Remarks: The 'displayInLayerList' attribute should default to true per convention.
     */
    displayedLayers: function displayedLayers() {
      var _context;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = this.layers).call(_context, function (layer) {
        return layer.get('displayInLayerList') !== false && !layer.get('isBaseLayer');
      }).reverse();
    }
  }
});

/***/ }),

/***/ "VNHm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_trim__ = __webpack_require__("9gOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_function_name_js__ = __webpack_require__("YY9M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ColorTheme__ = __webpack_require__("ATxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GeocoderController__ = __webpack_require__("qbcg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ViewAnimation__ = __webpack_require__("ntKu");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-geocoder-input',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Mapable__["a" /* Mapable */], __WEBPACK_IMPORTED_MODULE_6__mixins_ColorTheme__["a" /* ColorTheme */]],
  props: {
    icon: {
      type: String,
      required: false,
      default: 'search'
    },
    rounded: {
      type: Boolean,
      required: false,
      default: true
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: true
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: true
    },
    debug: {
      type: Boolean,
      required: false,
      default: false
    },
    minChars: {
      type: Number,
      required: false,
      default: 3
    },
    queryDelay: {
      type: Number,
      required: false,
      default: 300
    },
    provider: {
      type: String,
      required: false,
      default: 'osm'
    },
    providerOptions: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      results: [],
      lastQueryStr: '',
      noFilter: true,
      search: null,
      selecting: false,
      selected: null,
      hideSearch: true,
      timeout: null
    };
  },
  computed: {
    resultItems: function resultItems() {
      var _this = this;

      var items = [];

      if (!this.results) {
        return items;
      }

      this.trace("computed.resultItems() - cur results len=".concat(this.results.length)); // Convert results to v-combobox (text, value) Items

      this.results.forEach(function (result) {
        _this.trace("add to this.items: ".concat(result.address.name));

        items.push({
          text: result.address.name,
          value: result
        });
      });
      return items;
    }
  },
  methods: {
    trace: function trace(str) {
      this.debug && console && console.info(str);
    },
    toggle: function toggle() {
      // Show/hide search combobox
      this.hideSearch = !this.hideSearch;
    },
    // Query by string - should return list of selection items (adresses) for ComboBox
    querySelections: function querySelections(queryStr) {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        // Let Geocoder Provider do the query
        // items (item.text fields) will be shown in combobox dropdown suggestions
        _this2.trace("geocoderController.query: ".concat(queryStr));

        _this2.geocoderController.query(queryStr).then(function (results) {
          return _this2.onQueryResults(results);
        }).catch(function (err) {
          return _this2.onQueryError(err);
        });
      }, this.queryDelay);
    },
    onQueryResults: function onQueryResults(results) {
      // Handle query results from GeocoderController
      this.timeout && clearTimeout(this.timeout);
      this.timeout = null;
      this.results = null;

      if (!results || results.length === 0) {
        return;
      } // ASSERT: results is defined and at least one result


      this.trace("results ok: len=".concat(results.length));
      this.results = results;
    },
    onQueryError: function onQueryError(err) {
      if (err) {
        this.trace("onQueryResult error: ".concat(err));
      }
    }
  },
  watch: {
    // Input string value changed
    search: function search(queryStr) {
      if (this.timeout || this.selecting) {
        // Query or selection in progress
        this.trace("query or selection in progress...");
        return;
      }

      if (!queryStr || queryStr.length === 0) {
        // Query reset
        this.trace("queryStr none");
        this.results = null;
        return;
      } // ASSERTION: queryStr is valid


      queryStr = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_trim___default()(queryStr).call(queryStr); // Only query if minimal number chars typed and querystring has changed

      queryStr.length >= this.minChars && queryStr !== this.lastQueryStr && this.querySelections(queryStr);
      this.lastQueryStr = queryStr;
    },
    // User has selected entry from suggested items
    selected: function selected(item) {
      if (!item || !item.hasOwnProperty('text') || !item.hasOwnProperty('value')) {
        return;
      }

      this.selecting = true;
      this.trace("selected=".concat(item.text)); // Position Map on result

      var result = item.value;

      var mapProjection = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView().getProjection();

      var coords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ol_proj__["i" /* fromLonLat */])([result.lon, result.lat], mapProjection); // Prefer zooming to bounding box if present in result

      if (result.hasOwnProperty('boundingbox')) {
        // Result with bounding box.
        // bbox is in EPSG:4326, needs to be transformed to Map Projection (e.g. EPSG:3758)
        var extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ol_extent__["i" /* applyTransform */])(result.boundingbox, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ol_proj__["b" /* getTransform */])('EPSG:4326', mapProjection));
        __WEBPACK_IMPORTED_MODULE_10__util_ViewAnimation__["a" /* default */].to(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView(), extent);
      } else {
        // No bbox in result: center on lon/lat from result and zoom in
        __WEBPACK_IMPORTED_MODULE_10__util_ViewAnimation__["a" /* default */].to(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView(), coords);
      }

      this.selecting = false;
    }
  },
  mounted: function mounted() {
    // Setup GeocoderController to which we delegate Provider and query-handling
    this.geocoderController = new __WEBPACK_IMPORTED_MODULE_7__GeocoderController__["a" /* GeocoderController */](this.provider, this.providerOptions, this);
  }
});

/***/ }),

/***/ "VT4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OlMeasureController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_interaction_Draw__ = __webpack_require__("aUJj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_Observable_js__ = __webpack_require__("nxYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_style_Style__ = __webpack_require__("Mjwz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_style_Stroke__ = __webpack_require__("00zS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_style_Circle__ = __webpack_require__("uli1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_style_Fill__ = __webpack_require__("lUmj");












/**
 * Class holding the OpenLayers related logic for the measure tool.
 */

var OlMeasureController = /*#__PURE__*/function () {
  /* the OL map we want to measure on */
  function OlMeasureController(olMap, measureConf) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, OlMeasureController);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "map", null);

    this.map = olMap;
    this.measureConf = measureConf || {};
    this.measureLayer = undefined;
  }
  /**
   * Tears down this controller.
   */


  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(OlMeasureController, [{
    key: "destroy",
    value: function destroy() {
      if (!this.measureLayer || !__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)) {
        return;
      }

      this.removeInteraction();

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).removeLayer(this.measureLayer);

      this.measureLayer = undefined;
    }
    /**
     * Creates a vector layer for the measurement results and adds it to the
     * map.
     */

  }, {
    key: "createMeasureLayer",
    value: function createMeasureLayer() {
      var me = this;
      var measureConf = me.measureConf; // create a vector layer to

      var source = new __WEBPACK_IMPORTED_MODULE_6_ol_source_Vector__["a" /* default */]();
      this.measureLayer = new __WEBPACK_IMPORTED_MODULE_7_ol_layer_Vector__["a" /* default */]({
        lid: 'wgu-measure-layer',
        displayInLayerList: false,
        source: source,
        style: new __WEBPACK_IMPORTED_MODULE_8_ol_style_Style__["a" /* default */]({
          fill: new __WEBPACK_IMPORTED_MODULE_11_ol_style_Fill__["a" /* default */]({
            color: measureConf.fillColor || 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Stroke__["a" /* default */]({
            color: measureConf.strokeColor || 'rgba(0, 0, 0, 0.5)',
            width: 2
          })
        })
      });

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).addLayer(this.measureLayer); // make vector source available as member


      me.source = source;
    }
    /**
     * Creates and adds the necessary draw interaction and adds it to the map.
     */

  }, {
    key: "addInteraction",
    value: function addInteraction(measureType, mapClickCb) {
      var me = this;
      var measureConf = me.measureConf; // cleanup possible old draw interaction

      if (me.draw) {
        me.removeInteraction();
      }

      var type = measureType === 'area' ? 'Polygon' : 'LineString';
      var draw = new __WEBPACK_IMPORTED_MODULE_4_ol_interaction_Draw__["a" /* default */]({
        source: me.source,
        type: type,
        style: new __WEBPACK_IMPORTED_MODULE_8_ol_style_Style__["a" /* default */]({
          fill: new __WEBPACK_IMPORTED_MODULE_11_ol_style_Fill__["a" /* default */]({
            color: measureConf.sketchFillColor || 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Stroke__["a" /* default */]({
            color: measureConf.sketchStrokeColor || 'rgba(0, 0, 0, 0.5)',
            lineDash: [10, 10],
            width: 2
          }),
          image: new __WEBPACK_IMPORTED_MODULE_10_ol_style_Circle__["a" /* default */]({
            radius: 5,
            stroke: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Stroke__["a" /* default */]({
              color: measureConf.sketchVertexStrokeColor || 'rgba(0, 0, 0, 0.7)'
            }),
            fill: new __WEBPACK_IMPORTED_MODULE_11_ol_style_Fill__["a" /* default */]({
              color: measureConf.sketchVertexFillColor || 'rgba(255, 255, 255, 0.2)'
            })
          })
        })
      });

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).addInteraction(draw);

      var listener;
      var sketch;
      draw.on('drawstart', function (evt) {
        // clear old measure features
        me.source.clear(); // preserve sketch

        sketch = evt.feature;
        listener = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).on('click', function (evt) {
          var geom = sketch.getGeometry(); // execute given callback

          mapClickCb(geom);
        });
      }, me);
      draw.on('drawend', function () {
        // unset sketch
        sketch = null;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_ol_Observable_js__["b" /* unByKey */])(listener);
      }, me); // make draw interaction available as member

      me.draw = draw;
    }
    /**
     * Removes the current interaction and clears the values.
     */

  }, {
    key: "removeInteraction",
    value: function removeInteraction() {
      if (this.draw) {
        __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).removeInteraction(this.draw);

        this.draw = undefined;
      }

      if (this.source) {
        this.source.clear();
      }
    }
  }]);

  return OlMeasureController;
}();



/***/ }),

/***/ "W2JY":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de.json": "LaCf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W2JY";

/***/ }),

/***/ "WAwj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapOverlay_vue__ = __webpack_require__("K6sL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf2f2fd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapOverlay_vue__ = __webpack_require__("uRfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapOverlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf2f2fd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapOverlay_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf2f2fd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapOverlay_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WFjz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mapable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__ = __webpack_require__("ZkkH");

/**
 * Mixin, which binds the OL map to the target component.
 * Executes the onMapBound function of the target component, if available.
 */

var Mapable = {
  created: function created() {
    var _this = this;

    // if the OL map is not present in the vue prototype we have to wait until
    // it is mounted. Otherwise apply OL map as member var.
    if (!this.$map) {
      // apply OL map once OL map is mounted
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
        // make the OL map accessible in this component
        _this.map = olMap;

        if (_this.onMapBound) {
          _this.onMapBound();

          _this.unbound = false;
        }
      });
    } else {
      // OL map is already mounted --> directly apply as member
      this.map = this.$map;

      if (this.onMapBound) {
        this.onMapBound();
        this.unbound = false;
      }
    }

    __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-unmounted', function () {
      // Make the OL map unaccessible in this component
      if (_this.onMapUnbound) {
        _this.onMapUnbound();

        _this.unbound = true;
      }
    });
  }
};

/***/ }),

/***/ "WKho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerLegendImage_vue__ = __webpack_require__("EnnV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f5e5923_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerLegendImage_vue__ = __webpack_require__("3fUr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerLegendImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f5e5923_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerLegendImage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f5e5923_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerLegendImage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WNvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","nudge-bottom":"15","transition":"scale-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"ma-2",attrs:{"borderless":"","dense":"","color":"onprimary","background-color":"transparent","title":_vm.$t('wgu-localeswitcher.title'),"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',{staticClass:"mr-1",attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n        "+_vm._s(_vm.$i18n.locale)+" \n      ")],1)]}}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "),_c('v-list',_vm._l((Object.keys(_vm.lang)),function(langCode){return _c('v-list-item',{key:langCode,staticClass:"wgu-langlist-item",on:{"click":function($event){return _vm.onItemClick(langCode)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n            "+_vm._s(_vm.lang[langCode])+" ("+_vm._s(langCode)+")\n          ")])],1)],1)}),1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "WhIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_infoclick_PropertyTable_vue__ = __webpack_require__("ZY9t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_util_Layer__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_JsUtil_js__ = __webpack_require__("kURA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IdsCorpusLookup_js__ = __webpack_require__("9HAY");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// the module card is a the template for a typical Wegue module







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ids-feature-info',
  // make sure to register the 'Mapable' mixin
  mixins: [__WEBPACK_IMPORTED_MODULE_6__src_mixins_Mapable__["a" /* Mapable */]],
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_2__src_components_modulecore_ModuleCard__["a" /* default */],
    'wgu-property-table': __WEBPACK_IMPORTED_MODULE_3__src_components_infoclick_PropertyTable_vue__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'info'
    },
    welcomeImageUrl: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      featureProperties: {},
      queryLinkText: 'Daten dieses Ortspunkts in der DGD',
      queryLinkSuffix: '(nur zur wissenschaftlichen Nutzung durch registrierte DGD-Nutzende)',
      lastSelectedFeat: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__src_WguEventBus__["a" /* WguEventBus */].$on('ids-feature-info', function (clickedFeat) {
      _this.stripProperties(clickedFeat);
    }); // reset feature info results

    __WEBPACK_IMPORTED_MODULE_4__src_WguEventBus__["a" /* WguEventBus */].$on('ids-before-new-locations-load', function () {
      _this.featureProperties = {};
    });
  },
  created: function created() {
    if (this.$vuetify.breakpoint.xs) {
      // sync visibility of sidebar with visibility of feature info
      __WEBPACK_IMPORTED_MODULE_4__src_WguEventBus__["a" /* WguEventBus */].$on('ids-feature-info-module-visibility-change', function () {
        __WEBPACK_IMPORTED_MODULE_4__src_WguEventBus__["a" /* WguEventBus */].$emit('sidebar-toggle');
      });
    }
  },
  methods: {
    onMapBound: function onMapBound() {
      var _this2 = this;

      var declusterLayer = __WEBPACK_IMPORTED_MODULE_5__src_util_Layer__["a" /* default */].getLayerByLid('ids-decluster-layer', __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this));
      var clusterLayer = __WEBPACK_IMPORTED_MODULE_5__src_util_Layer__["a" /* default */].getLayerByLid('ids-result-layer', __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this));

      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).on('singleclick', function (e) {
        var clickedFeatures = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this2).getFeaturesAtPixel(e.pixel, {
          layerFilter: function layerFilter(l) {
            return l.get('lid') === declusterLayer.get('lid') || l.get('lid') === clusterLayer.get('lid');
          }
        }); // list possible feature attributes


        if (clickedFeatures && clickedFeatures.length) {
          // decluster layer
          var clickedFeat = clickedFeatures[0]; // location cluster layer

          var subFeats = clickedFeat.get('features');

          if (subFeats) {
            if (subFeats.length === 1) {
              clickedFeat = subFeats[0];
            } else {
              clickedFeat = null;
            }
          }

          if (clickedFeat) {
            // reset last selected feature
            if (_this2.lastSelectedFeat) {
              var _originalFeat = _this2.lastSelectedFeat.get('originalFeat');

              if (_originalFeat) {
                // original pendant of de-cluster feature
                _originalFeat.set('ids-selected', false);
              } else {
                // single feat not in de-cluster
                _this2.lastSelectedFeat.set('ids-selected', false);
              }

              _this2.lastSelectedFeat = null;
            } // find the orig feature and store select state


            var originalFeat = clickedFeat.get('originalFeat');

            if (originalFeat) {
              // original pendant of de-cluster feature
              originalFeat.set('ids-selected', true);
            } else {
              // single feat not in de-cluster
              clickedFeat.set('ids-selected', true);
            } // preserve last selected feature


            _this2.lastSelectedFeat = clickedFeat;
          }

          _this2.stripAndShowProperties(clickedFeat);

          if (clickedFeat) {
            // ensure the sidebar with FeatureInfo result is visible
            __WEBPACK_IMPORTED_MODULE_4__src_WguEventBus__["a" /* WguEventBus */].$emit('sidebar-toggle', true);
          }
        }
      });
    },

    /**
     *
     */
    stripAndShowProperties: function stripAndShowProperties(feat) {
      if (!feat) {
        return;
      }

      var props = feat.getProperties();
      var clone = __WEBPACK_IMPORTED_MODULE_7__util_JsUtil_js__["a" /* default */].cloneObject(props); // avoid values from been showing in UI

      delete clone.geometry;
      delete clone.originalGeometry;
      delete clone.originalOlUid;
      delete clone.originalFeat;
      delete clone['ids-selected'];
      delete clone.Ortsteil; // adjust some known props, e.g. make links out of it

      for (var key in clone) {
        var val = clone[key];

        if (key === 'Korpus') {
          var _context;

          var corpusLabel = __WEBPACK_IMPORTED_MODULE_8__IdsCorpusLookup_js__["a" /* default */].getCorpusLabel(val);
          var link = __WEBPACK_IMPORTED_MODULE_8__IdsCorpusLookup_js__["a" /* default */].getCorpusLink(val);
          clone[key] = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context = "<a href=\"".concat(link, "\" target=\"_blank\">")).call(_context, corpusLabel, "</a>");
        }

        if (key === 'DGD_url') {
          var _context2, _context3;

          var dgdUrl = clone['DGD_url'];
          clone['Link'] = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context3 = "<a href=\"".concat(dgdUrl, "\" target=\"_blank\">")).call(_context3, this.queryLinkText, "</a><br>")).call(_context2, this.queryLinkSuffix);
          delete clone[key]; // remove original prop from UI
        }
      }

      this.featureProperties = clone;
    }
  }
});

/***/ }),

/***/ "Wi6V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X0Tm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoverTooltip_vue__ = __webpack_require__("lHTH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c65aae6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoverTooltip_vue__ = __webpack_require__("+2xm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoverTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c65aae6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoverTooltip_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c65aae6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoverTooltip_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XSiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray__ = __webpack_require__("mF7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__("xtLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign__ = __webpack_require__("E6nQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign__);





/**
 * Object related utility methods.
 */
var ObjectUtil = {
  /**
   * Tests whether item is an object
   * @param {*} item The item to test.
   * @returns {Boolean} True if the item is an object.
   */
  isObject: function isObject(item) {
    return item && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof___default()(item) === 'object' && !Array.isArray(item);
  },

  /**
   * Deep in place merge of source object into target object.
   * @param {Object} target The target of the merge operation.
   * @param {Object} source The source of the merge operation.
   */
  mergeDeep: function mergeDeep(target, source) {
    if (ObjectUtil.isObject(target) && ObjectUtil.isObject(source)) {
      for (var key in source) {
        if (ObjectUtil.isObject(source[key])) {
          if (!target[key]) {
            __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign___default()(target, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty___default()({}, key, {}));
          }

          ObjectUtil.mergeDeep(target[key], source[key]);
        } else {
          __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign___default()(target, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty___default()({}, key, source[key]));
        }
      }
    }
  },

  /**
   * Recursively list all property paths in an object.
   *
   * @param {Object} item An object to extract property paths from.
   * @param {String} path Internal usage for recursion.
   * @returns {Array} An array containing all paths to keys of the object.
   */
  toPaths: function toPaths(item) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var result = [];

    if (item && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof___default()(item) === 'object') {
      if (Array.isArray(item)) {
        for (var i = 0; i < item.length; i++) {
          result.push.apply(result, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default()(ObjectUtil.toPaths(item[i], path + '[' + i + ']')));
        }
      } else {
        for (var p in item) {
          result.push.apply(result, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default()(ObjectUtil.toPaths(item[p], path + '.' + p)));
        }
      }
    } else {
      result.push(path);
    }

    return result;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ObjectUtil);

/***/ }),

/***/ "XxAX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({ref:"ids-filter-module-win",staticClass:"mx-auto ids-filter-panel",attrs:{"moduleName":"ids-filter-module","icon":_vm.icon,"width":_vm.$vuetify.breakpoint.xs ? 300 : 500,"max-width":"600"}},'wgu-module-card',_vm.$attrs,false),[_c('v-container',{staticClass:"ids-filter-container"},[_c('ids-location-type-chooser',{attrs:{"locationTypeList":_vm.locationTypeList,"locationType":_vm.locationType},on:{"ids-location-type-change":function (newLT) { this$1.locationType = newLT }}}),_vm._v(" "),_c('v-tabs',{staticClass:"pl-2 mb-2",attrs:{"color":"primary","slider-color":"black","active-class":"ids-active-filter-type-tab"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},_vm._l((_vm.tabItems),function(tabItem){return _c('v-tab',{key:tabItem.tab},[_vm._v("\n        "+_vm._s(tabItem.tab)+"\n      ")])}),1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},_vm._l((_vm.tabItems),function(tabItem){return _c('v-tab-item',{key:tabItem.tab},[(tabItem.type === 'corpora')?_c('ids-corpora-filter',{attrs:{"corpusListApi":_vm.corpusList,"corpusSelection":_vm.corpusSelection},on:{"ids-corpus-selection-change":function (newSel) { return _vm.corpusSelection=newSel; }}}):(tabItem.type === 'geo')?_c('ids-geographic-filter',{attrs:{"countries":_vm.countryList,"countrySelection":_vm.countrySelection,"regionSelection":_vm.regionSelection,"districtSelection":_vm.districtSelection,"locationType":_vm.locationType},on:{"ids-geog-filter-change":_vm.onGeographicFilterChange}}):_vm._e()],1)}),1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"primary","dark":"","dense":""}},[_c('v-btn',{on:{"click":this.requestLocations}},[_vm._v("\n      ANWENDEN\n    ")])],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.apiError),callback:function ($$v) {_vm.apiError=$$v},expression:"apiError"}},[_c('v-container',{staticClass:"ids-error-msg-ct",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('div',[_c('h3',[_vm._v("Fehler")]),_vm._v(" "),_c('p',[_vm._v("Die Ortsdaten konnten nicht vom Server geladen werden.")])])])],1)],1),_vm._v(" "),_c('v-snackbar',{staticClass:"ids-dev-api-snackbar",attrs:{"top":"","absolute":"","timeout":_vm.snackbarTimeout},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_c('div',[_vm._v("\n      API Call:\n      "),_c('br'),_vm._v(" "),_c('span',[_c('code',[_vm._v(_vm._s(_vm.dummyApiCall))])])])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "Xzb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YFln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"measure-result"},[_vm._v("\n    "+_vm._s(_vm.$t("wgu-measuretool.length"))+": "+_vm._s(_vm.distance)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"measure-result"},[_vm._v("\n    "+_vm._s(_vm.$t("wgu-measuretool.area"))+": "+_vm._s(_vm.area)+"\n  ")])])}
var staticRenderFns = []


/***/ }),

/***/ "YPa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgLayerList_vue__ = __webpack_require__("HyBD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ccfaa73_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerList_vue__ = __webpack_require__("BjgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgLayerList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ccfaa73_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ccfaa73_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yg4S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-maprecorder-win",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon,"width":"350"}},'wgu-module-card',_vm.$attrs,false),[_c('v-expansion-panels',{staticClass:"overflow-y-auto",attrs:{"multiple":true,"accordion":true}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-icon',{staticClass:"mr-4"},[_vm._v("settings")]),_vm._v("\n          "+_vm._s(_vm.$t('wgu-maprecorder.options'))+"\n        ")],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('wgu-maprecorder.videoFormat')))]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-select',{attrs:{"color":"secondary","item-color":"secondary","menu-props":{
                  'offset-y': true,
                  bottom: true,
                },"items":_vm.mimeTypes,"prepend-icon":"mdi-video-image","dense":"","hide-details":""},model:{value:(_vm.mimeType),callback:function ($$v) {_vm.mimeType=$$v},expression:"mimeType"}})],1),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm.$t('wgu-maprecorder.frameRate')))]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-slider',{attrs:{"color":"secondary","prepend-icon":"mdi-iframe-variable-outline","min":"20","max":"50","step":"1","thumb-label":"","hide-details":""},model:{value:(_vm.frameRate),callback:function ($$v) {_vm.frameRate=_vm._n($$v)},expression:"frameRate"}})],1),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm.$t('wgu-maprecorder.bitRate')))]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-slider',{attrs:{"color":"secondary","prepend-icon":"mdi-quality-high","min":"1.0","max":"10.0","step":"0.1","thumb-label":"","hide-details":""},model:{value:(_vm.videoMBitsPerSecond),callback:function ($$v) {_vm.videoMBitsPerSecond=_vm._n($$v)},expression:"videoMBitsPerSecond"}})],1),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm.$t('wgu-maprecorder.fileName')))]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-text-field',{attrs:{"color":"secondary","prepend-icon":"mdi-rename-box","label":"YYYY-MM-DD at HH.MM.SS","dense":"","single-line":"","hide-details":""},model:{value:(_vm.filename),callback:function ($$v) {_vm.filename=$$v},expression:"filename"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pb-5"},[_c('v-row',{staticClass:"px-3",attrs:{"align-center":"","justify-center":"","no-gutters":""}},[_c('v-btn',{class:{
          'secondary': true,
          'onsecondary--text': true  
        },attrs:{"block":!_vm.recording},on:{"click":_vm.toggleRecord}},[(!_vm.recording)?[_c('v-icon',{attrs:{"left":""}},[_vm._v("fiber_manual_record")]),_vm._v(" \n          "+_vm._s(_vm.$t('wgu-maprecorder.start'))+"\n        ")]:[_c('v-icon',{attrs:{"left":""}},[_vm._v("stop")]),_vm._v(" \n          "+_vm._s(_vm.$t('wgu-maprecorder.stop'))+"\n        ")]],2),_vm._v(" "),_c('v-col',{staticClass:"px-2",attrs:{"align-self":"center"}},[_c('v-progress-linear',{attrs:{"color":"secondary","active":_vm.recording,"buffer-value":"0","stream":""}})],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"12","md":"12","lg":"12"}},[_c('v-alert',{staticClass:"mt-2 mb-0",attrs:{"type":"error","dismissible":"","dense":"","transition":"scroll-y-transition"},model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}},[_vm._v("\n          "+_vm._s(_vm.$t('wgu-maprecorder.error'))+"\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "YvPU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocaleSwitcher_vue__ = __webpack_require__("gjO7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164c0437_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocaleSwitcher_vue__ = __webpack_require__("WNvh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocaleSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164c0437_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocaleSwitcher_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164c0437_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocaleSwitcher_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZKPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenStreetMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float__ = __webpack_require__("8U/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float__);




// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

/**
 * OpenStreetMap Nominatim Provider. See https://nominatim.openstreetmap.org.
 *
 * @class OpenStreetMap
 */
var OpenStreetMap = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function OpenStreetMap() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, OpenStreetMap);

    this.settings = {
      url: 'https://nominatim.openstreetmap.org/search/',
      params: {
        q: '',
        format: 'json',
        addressdetails: 1,
        limit: 10,
        countrycodes: '',
        'accept-language': 'en-US'
      }
    };
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(OpenStreetMap, [{
    key: "getParameters",
    value: function getParameters(opt) {
      return {
        url: this.settings.url,
        params: {
          q: opt.query,
          format: this.settings.params.format,
          addressdetails: this.settings.params.addressdetails,
          limit: opt.limit || this.settings.params.limit,
          countrycodes: opt.countrycodes || this.settings.params.countrycodes,
          'accept-language': opt.lang || this.settings.params['accept-language']
        }
      };
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(results) {
      if (!results || results.length === 0) {
        return;
      }

      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default()(results).call(results, function (result) {
        var _context;

        result = {
          lon: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float___default()(result.lon),
          lat: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float___default()(result.lat),
          boundingbox: __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = result.boundingbox).call(_context, function (x) {
            return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float___default()(x);
          }),
          address: {
            name: result.display_name,
            road: result.address.road || '',
            houseNumber: result.address.house_number || '',
            postcode: result.address.postcode || '',
            city: result.address.city || result.address.town || '',
            state: result.address.state || '',
            country: result.address.country || ''
          },
          original: {
            formatted: result.display_name,
            details: result.address
          }
        }; // Make bbox llx,lly,urx,ury

        var bbox = result.boundingbox;
        result.boundingbox = [bbox[2], bbox[0], bbox[3], bbox[1]];
        return result;
      });
    }
  }]);

  return OpenStreetMap;
}();

/***/ }),

/***/ "ZY9t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyTable_vue__ = __webpack_require__("v4OI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01127237_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__ = __webpack_require__("bkd3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("01On")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01127237_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01127237_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZfcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__("kJWX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9dcdd42_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__("zOpH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fUjn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9dcdd42_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9dcdd42_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZjDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitcher_vue__ = __webpack_require__("RCTG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThemeSwitcher_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZjhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-expansion-panels',{staticClass:"mb-1",attrs:{"multiple":""},model:{value:(_vm.expandState),callback:function ($$v) {_vm.expandState=$$v},expression:"expandState"}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"ids-expansion-panel-header",attrs:{"color":"secondary","dark":"","dense":""}},[_c('v-icon',{staticClass:"ids-expansion-header-left-icon pr-2"},[_vm._v("\n          mdi-image-filter-tilt-shift\n        ")]),_vm._v("\n        "+_vm._s(_vm.corpusCategoryName)+"\n        "),_c('v-btn',{staticStyle:{"margin-right":"20px"},attrs:{"icon":"","title":_vm.toggleAllTooltip},on:{"click":[_vm.toggleAllCorpora,function($event){$event.stopPropagation();}]}},[_c('v-icon',{},[_vm._v(_vm._s(_vm.toggleAllIcon))])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.corpusItems),function(cbItem,index){return _c('v-col',{key:cbItem.label,attrs:{"cols":12}},[_c('v-checkbox',{staticClass:"ids-corpus-checkbox",attrs:{"value":cbItem.v_corpus_id,"label":_vm.corpusLabel(cbItem.v_corpus_id),"hide-details":"","dense":""},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',[_vm._v("\n                  "+_vm._s(_vm.corpusLabel(cbItem.v_corpus_id))+"\n                  "),_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"target":"_blank","href":_vm.corpusLink(cbItem.v_corpus_id)},on:{"click":function($event){$event.stopPropagation();}}},[_c('v-icon',[_vm._v("mdi-information-outline")])],1)])]},proxy:true}],null,true),model:{value:(_vm.dataSelection[index]),callback:function ($$v) {_vm.$set(_vm.dataSelection, index, $$v)},expression:"dataSelection[index]"}})],1)}),1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "ZkkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WguEventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
 // Vue instance acting as app-wide event-bus

var WguEventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "aDNC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverviewMapController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_control__ = __webpack_require__("eM/O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_layer_Tile__ = __webpack_require__("Mdwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_source_OSM__ = __webpack_require__("WiOa");







/**
 * Implementation of an OpenLayers based overview map.
 */

var OverviewMapController = /*#__PURE__*/function () {
  /**
   * Construction
   * @param {ol.Map} map OpenLayers map.
   * @param {HTMLElement} target The target container to render the control.
   * @param {Object} config The overview map configuration object.
   */
  function OverviewMapController(map, target, config) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, OverviewMapController);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "overviewMapControl", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "map", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "layer", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "timerHandle", null);

    this.map = map;
    this.conf = config || {};
    this.overviewMapControl = new __WEBPACK_IMPORTED_MODULE_4_ol_control__["b" /* OverviewMap */]({
      className: 'ol-overviewmap wgu-overviewmap-ctrl',
      target: target,
      collapsible: false,
      rotateWithView: this.conf.rotateWithView
    });
    this.setLayer(null); // TODO:
    // Workaround because without defering the following operation, OL will fail to render
    // the overview map control. Presumably because no sizes have been computed yet on the
    // target DOM element. Another deferred render operation within requestAnimationFrame is
    // necessary to correctly position the selection box.

    this.timerHandle = setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).addControl(_this.overviewMapControl);

      _this.setOlStyle();

      requestAnimationFrame(function () {
        _this.overviewMapControl.render();
      });
    }, 100);
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(OverviewMapController, [{
    key: "destroy",
    value:
    /**
     * Unregister the OpenLayers overview map.
     */
    function destroy() {
      if (this.timerHandle) {
        clearTimeout(this.timerHandle);
      }

      if (this.layer) {
        var overviewMap = this.overviewMapControl.getOverviewMap();
        overviewMap.getLayers().clear();
      }

      if (__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)) {
        __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).removeControl(this.overviewMapControl);
      }

      this.timerHandle = null;
      this.layer = null;
      this.map = null;
      this.overviewMapControl = null;
    }
    /**
     * Applies a vuetify card like style to the inner overview map.
     */

  }, {
    key: "setOlStyle",
    value: function setOlStyle() {
      document.querySelector('.ol-overviewmap-map').classList.add('v-card', 'ma-0');
    }
    /**
     * Set the layer to be displayed in the overview map.
     * Remarks:
     * As of OpenLayers 6 re-using the same layer instance between different map controls is no
     * longer supported. The workaround used here is to create a shallow clone if the layer is a
     * TileLayer by reusing the same source. This will cover most of the cases for background layers.
     * For other layer types fallback to an OSM layer.
     * @param {ol.layer.Base} layer The currently displayed layer.
     */

  }, {
    key: "setLayer",
    value: function setLayer(layer) {
      this.layer = layer instanceof __WEBPACK_IMPORTED_MODULE_5_ol_layer_Tile__["a" /* default */] ? new __WEBPACK_IMPORTED_MODULE_5_ol_layer_Tile__["a" /* default */]({
        extent: layer.getExtent(),
        source: layer.getSource()
      }) : new __WEBPACK_IMPORTED_MODULE_5_ol_layer_Tile__["a" /* default */]({
        source: new __WEBPACK_IMPORTED_MODULE_6_ol_source_OSM__["b" /* default */]()
      });
      var overviewMap = this.overviewMapControl.getOverviewMap();
      overviewMap.getLayers().clear();
      overviewMap.addLayer(this.layer);
    }
  }]);

  return OverviewMapController;
}();



/***/ }),

/***/ "aqYZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bkd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card-text',{staticClass:"px-0"},[_c('v-simple-table',{staticClass:"wgu-proptable"},[_c('tbody',{staticClass:"attr-tbody"},_vm._l((_vm.properties),function(value,key){return _c('tr',{key:key},[_c('td',{staticClass:"key-td"},[_vm._v("\n          "+_vm._s(key)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"val-td",domProps:{"innerHTML":_vm._s(value)}})])}),0)])],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "bvM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_style__ = __webpack_require__("beD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_geom_Point__ = __webpack_require__("T18w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_util_Layer_js__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_factory_OlStyle_js__ = __webpack_require__("fT5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");








var IdsStyleFactory = {
  /** Maximum extent size in meters to detect same places for points */
  MAX_POINT_EXTENT_SIZE: 50,
  CLUSTER_FILL_COLOR: '#3399CC',
  DECLUSTER_CIRCLE_RADIUS: 40,
  DECLUSTER_CIRCLE_RADIUS_MEDIUM: 80,
  DECLUSTER_CIRCLE_RADIUS_BIG: 200,
  DEFAULT_ICON_COLOR: '#3399cc',
  LOCATION_ICON: 'location_on',

  /**
   * Creates a single point icon style.
   *
   * @param {String} fillColor
   * @returns The OL style object
   */
  createSinglePointStyle: function createSinglePointStyle(fillColor) {
    var style = __WEBPACK_IMPORTED_MODULE_6__src_factory_OlStyle_js__["a" /* OlStyleFactory */].createPointStyle({
      font: 'normal 30px Material Icons',
      textIcon: IdsStyleFactory.LOCATION_ICON,
      fillColor: fillColor
    });
    return style;
  },

  /**
   * Creates a selected single point icon style.
   *
   * @param {String} fillColor
   * @returns The OL style object
   */
  createSelectStyle: function createSelectStyle(fillColor) {
    var style = __WEBPACK_IMPORTED_MODULE_6__src_factory_OlStyle_js__["a" /* OlStyleFactory */].createPointStyle({
      font: 'normal 40px Material Icons',
      textIcon: IdsStyleFactory.LOCATION_ICON,
      fillColor: fillColor
    });
    return style;
  },

  /**
   * Creates a cluster style for the Ortsdaten layer.
   *
   * @param {Object} styleCache A style cache object
   *
   * @returns {ol.style.Style}
   */
  createClusterStyle: function createClusterStyle(styleCache, olMap) {
    if (__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig.ids && __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig.ids.styles) {
      IdsStyleFactory.styleConf = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig.ids.styles;
      IdsStyleFactory.CLUSTER_FILL_COLOR = IdsStyleFactory.styleConf.clusterColor;
    }

    var declusterLayer = __WEBPACK_IMPORTED_MODULE_5__src_util_Layer_js__["a" /* default */].getLayerByLid('ids-decluster-layer', olMap);
    var declusterSource = declusterLayer.getSource();
    var clusterLayer = __WEBPACK_IMPORTED_MODULE_5__src_util_Layer_js__["a" /* default */].getLayerByLid('ids-result-layer', olMap);
    var clusterSource = clusterLayer.getSource(); // when cluster source changes
    // we clear the source of the twin layer

    clusterSource.on('change', function () {
      declusterSource.clear();
    });
    return function (feature, resolution) {
      var clusterFeats = feature.get('features');
      var size = 1;

      if (clusterFeats) {
        size = clusterFeats.length;
      } // const size = clusterFeats.length;


      var zoom = olMap.getView().getZoomForResolution(resolution); // check for multiple points at same place / geom

      var onlySameCoords = false;

      if (size > 1) {
        onlySameCoords = IdsStyleFactory.pointsAtSamePlace(clusterFeats);
      }

      var style = null;

      if (size === 1) {
        // render normal
        var corpusId = clusterFeats[0].get('Korpus');
        var corpusStyleConf = IdsStyleFactory.styleConf[corpusId];
        var corpusColor = corpusStyleConf ? corpusStyleConf.iconColor : IdsStyleFactory.DEFAULT_ICON_COLOR;

        if (clusterFeats[0].get('ids-selected')) {
          return IdsStyleFactory.createSelectStyle(corpusColor);
        } else {
          return IdsStyleFactory.createSinglePointStyle(corpusColor);
        }
      } else {
        // lot of points
        if (zoom <= 10) {
          // cluster
          // styling for real clusters
          style = styleCache[size];

          if (!style) {
            // cluster style if not existing in cache
            style = new __WEBPACK_IMPORTED_MODULE_2_ol_style__["a" /* Style */]({
              image: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["b" /* Circle */]({
                radius: 10,
                stroke: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["c" /* Stroke */]({
                  color: '#fff'
                }),
                fill: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["d" /* Fill */]({
                  color: IdsStyleFactory.CLUSTER_FILL_COLOR
                })
              }),
              text: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["e" /* Text */]({
                text: size.toString(),
                fill: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["d" /* Fill */]({
                  color: '#fff'
                })
              })
            });
            styleCache[size] = style;
          }
        } else {
          if (onlySameCoords) {
            // de-cluster
            // render single features de-clustered
            IdsStyleFactory.drawDeclusteredFeatures(clusterFeats, olMap, declusterLayer); // render original point in a decent way

            style = __WEBPACK_IMPORTED_MODULE_6__src_factory_OlStyle_js__["a" /* OlStyleFactory */].createPointStyle({
              radius: 4,
              fillColor: 'rgba(0,91,165, .2)'
            });
          } else {// TODO cluster ?
          }
        }
      }

      return style;
    };
  },

  /**
   * Checks if the given point features are at the same spot, based on the a
   * threshold defined in meters in #MAX_POINT_EXTENT_SIZE.
   *
   * @param {Array<ol.Feature>} features
   * @returns true=> all points are on the same spot / false => not
   */
  pointsAtSamePlace: function pointsAtSamePlace(features) {
    // calc extent for features to check if all on same place
    var coords = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(features).call(features, function (f) {
      return f.getGeometry().getCoordinates();
    });

    var clusterExtent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_extent__["a" /* boundingExtent */])(coords);
    var size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_extent__["s" /* getSize */])(clusterExtent);
    return size[0] < IdsStyleFactory.MAX_POINT_EXTENT_SIZE && size[1] < IdsStyleFactory.MAX_POINT_EXTENT_SIZE;
  },

  /**
   * Creates a copy for every given point feature and shifts it round the
   * original coordinate in a circular layout.
   *
   * @param {Array<ol.Feature>} features Features to shift around
   * @param {ol.Map} olMap The OL map instance
   * @param {ol.layer/Vector} declusterLayer The layer to add the shifted features
   */
  drawDeclusteredFeatures: function drawDeclusteredFeatures(features, olMap, declusterLayer) {
    var declusterSource = declusterLayer.getSource();
    var size = features.length;
    var radius = IdsStyleFactory.DECLUSTER_CIRCLE_RADIUS;

    if (size >= 10 && size < 30) {
      radius = IdsStyleFactory.DECLUSTER_CIRCLE_RADIUS_MEDIUM;
    }

    if (size >= 30) {
      radius = IdsStyleFactory.DECLUSTER_CIRCLE_RADIUS_BIG;
    } // create a copy for all features and shift it round the original coordinate


    features.forEach(function (feature, index) {
      var _context;

      // check if we have this feature already in out de-cluster
      // necessary since the drawDeclusteredFeatures fn is called multiple times
      var existing = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context = declusterSource.getFeatures()).call(_context, function (decFeat) {
        return decFeat.get('originalOlUid') === feature.ol_uid;
      });

      if (existing) {
        return;
      }

      var clonedFeature = feature.clone();
      var oldGeometry = clonedFeature.getGeometry();
      var oldCoord = oldGeometry.getCoordinates();
      var newCoord = IdsStyleFactory.getCircleCoordinate(oldCoord, size, index, radius, olMap);
      var newGeometry = new __WEBPACK_IMPORTED_MODULE_3_ol_geom_Point__["a" /* default */](newCoord);
      clonedFeature.setGeometry(newGeometry); // add original geometry, necessary for callout lines

      clonedFeature.set('originalGeometry', oldGeometry);
      clonedFeature.set('originalOlUid', feature.ol_uid);
      clonedFeature.set('originalFeat', feature);
      var corpus = feature.get('Korpus');
      var corpusStyleConf = IdsStyleFactory.styleConf[corpus];
      var corpusColor = corpusStyleConf ? corpusStyleConf.iconColor : IdsStyleFactory.DEFAULT_ICON_COLOR; // style shifted clone and add to separate de-cluster layer

      if (feature.get('ids-selected')) {
        var selectStyle = IdsStyleFactory.createSelectStyle(corpusColor);
        clonedFeature.setStyle(selectStyle);
      } else {
        var declusterStyle = IdsStyleFactory.createSinglePointStyle(corpusColor);
        clonedFeature.setStyle(declusterStyle);
      } // TODO check if feature is selected, maybe needs to be store in orig feat


      declusterSource.addFeature(clonedFeature);
    });
  },

  /**
   * Compute the coordinate of a de-clustered feature.
   *
   * @param {ol.coordinate} coordinate The original coordinate of the feature
   * @param {Number} clusterCount The count of features in the current cluster
   * @param {Number} index The index of the feature in the cluster
   * @param {Number} [radius=40] The radius of the circle in pixel
   * @param {ol.Map} [radius=40] The radius of the circle in pixel
   *
   * @returns {ol.coordinate} The new coordinate in the map CRS
   */
  getCircleCoordinate: function getCircleCoordinate(coordinate, clusterCount, index, radius, olMap) {
    if (!coordinate || !clusterCount) {
      return;
    }

    if (!index && index !== 0) {
      return;
    } // TODO: increase radius based on number of features


    if (!radius) {
      radius = 40;
    }

    var oldPixelCoord = olMap.getPixelFromCoordinate(coordinate);
    var maxAngle = 2 * Math.PI;
    var angle = maxAngle / clusterCount * index; // rotate by 45°

    angle = angle + Math.PI / 4;
    var yValue = Math.sin(angle) * radius;
    var xValue = Math.cos(angle) * radius;
    oldPixelCoord[0] = oldPixelCoord[0] + xValue;
    oldPixelCoord[1] = oldPixelCoord[1] - yValue;
    return olMap.getCoordinateFromPixel(oldPixelCoord);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (IdsStyleFactory);

/***/ }),

/***/ "c0QU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguAppTemplate_vue__ = __webpack_require__("04/i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a667ce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__ = __webpack_require__("HrcG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguAppTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a667ce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61a667ce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c8A0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ids-corpora-filter px-2"},_vm._l((_vm.corpusByCategory),function(corpusItems,name){return _c('ids-corpus-category',{key:name,attrs:{"corpusCategoryName":name,"corpusItems":corpusItems,"selection":_vm.dataCorpusSelection[name]},on:{"ids-corpus-selection-change":_vm.onCorpusSelectionChange}})}),1)}
var staticRenderFns = []


/***/ }),

/***/ "cmEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.coordRows)?_c('v-card-text',{staticClass:"px-0"},[_c('v-simple-table',{staticClass:"wgu-coordstable"},[_c('tbody',_vm._l((_vm.coordRows),function(value,key){return _c('tr',{key:key},[_c('td',{staticClass:"key-td"},[_vm._v("\n          "+_vm._s(key)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"val-td"},[_vm._v("\n          "+_vm._s(value)+"\n        ")])])}),0)])],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "csSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cspx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureResult_vue__ = __webpack_require__("F+zM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f632e3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__ = __webpack_require__("YFln");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("xdWY")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f632e3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f632e3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e/Tm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_toConsumableArray__ = __webpack_require__("mF7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_keys__ = __webpack_require__("qWzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim__ = __webpack_require__("9gOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_core_js_stable_instance_includes__ = __webpack_require__("wk9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_core_js_stable_instance_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_core_js_stable_instance_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Object_js__ = __webpack_require__("XSiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Url_js__ = __webpack_require__("v9hS");






function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }











/**
 * Locale related utility methods.
 */

var LocaleUtil = {
  /**
   * Hardcoded fallback if no supported languages are declared in app config.
   */
  supportedLanguageFallback: {
    'en': 'English'
  },

  /**
   * Import a webpack context for language files and returns message content.
   * @param {Object} context The webpack context returned by require.context.
   * @param {Object} mappingFunc A function to extract messages from an item of the webpack context.
   *
   * @returns {Object} A container with message data. Key is the language code, value contains the messages.
   */
  importLocales: function importLocales(context, mappingFunc) {
    var _context;

    return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_keys___default()(context).call(context)).call(_context, function (key) {
      return {
        key: key,
        locale: key.match(/[a-z0-9-_]+/i)[0]
      };
    }).reduce(function (messages, _ref) {
      var key = _ref.key,
          locale = _ref.locale;
      return _objectSpread(_objectSpread({}, messages), {}, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty___default()({}, locale, mappingFunc(context(key))));
    }, {});
  },

  /**
   * Import all Wegue core language files from 'src/locales' and optionally
   * app specific language files from 'app/locales'. Language files will be merged,
   * such that Wegue core messages can be overridden by app messages.
   *
   * @returns  {Object} A container with message data. Key is the language code, value contains the messages.
   */
  importVueI18nLocales: function importVueI18nLocales() {
    var jsonContentExtractor = function jsonContentExtractor(i) {
      return i;
    }; // Load Wegue core language files.


    var i18nMessages = LocaleUtil.importLocales(__webpack_require__("1ywd"), jsonContentExtractor); // Try to load optional app specific language files and merge contents.

    try {
      var i18nMessagesApp = LocaleUtil.importLocales(__webpack_require__("W2JY"), jsonContentExtractor);
      __WEBPACK_IMPORTED_MODULE_13__Object_js__["a" /* default */].mergeDeep(i18nMessages, i18nMessagesApp);
    } catch (e) {}

    return i18nMessages;
  },

  /**
   * Import vuetify language files from 'node_modules/vuetify/es/locale'.
   *
   * @returns A container with message data. Key is the language code, value contains the messages.
   */
  importVuetifyLocales: function importVuetifyLocales() {
    var moduleDefaultExtractor = function moduleDefaultExtractor(i) {
      return i.default;
    };

    return LocaleUtil.importLocales(__webpack_require__("qETa"), moduleDefaultExtractor);
  },

  /**
  * Detects the preferred language which is supported by the application
  * and returns the language code.
  * Priority order:
  * 1. URL-parameter
  * 2. Preferred browser language
  * 3. One of the accepted browser languages
  * 4. The fallback language declared in appConfig
  * 5. The fallback language declared above
  *
  * @param {Object} appConfig Global application context.
  * @returns The language code of the preferred language.
  */
  getPreferredLanguage: function getPreferredLanguage(appConfig) {
    var _context2, _context3;

    var precedence = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context2 = [__WEBPACK_IMPORTED_MODULE_14__Url_js__["a" /* default */].getQueryParam('lang'), navigator.language || navigator.userLanguage]).call(_context2, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_toConsumableArray___default()(navigator.languages), [LocaleUtil.getFallbackLanguage(appConfig), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(LocaleUtil.supportedLanguageFallback)[0]]); // Transform codes like 'de-DE' or 'en-GB' to 'de' or 'en'.


    var languages = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context3 = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter___default()(precedence).call(precedence, function (value) {
      return !!value;
    })).call(_context3, function (value) {
      return value ? __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim___default()(value).call(value).split(/-|_/)[0] : null;
    });

    return __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_find___default()(languages).call(languages, function (value) {
      return LocaleUtil.isLanguageSupported(value, appConfig);
    });
  },

  /**
   * Get languages supported by the application, which are declared in the application context.
   * Fallback will be {'en':'English}'
   *
   * @param {Object} appConfig Global application context.
   * @returns {Object} A container with key value pairs, while key corresponds to the language code and
   *  value contains a human readable language name.
   */
  getSupportedLanguages: function getSupportedLanguages(appConfig) {
    var isDefined = appConfig.lang && appConfig.lang.supported && __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(appConfig.lang.supported).length > 0;
    return isDefined ? appConfig.lang.supported : LocaleUtil.supportedLanguageFallback;
  },

  /**
   * Get the fallback language declared in the application context.
   * If none such it is declared, returns 'en'.
   *
   * @param {Object} appConfig Global application context.
   * @returns {String} The language code of the fallback language.
   */
  getFallbackLanguage: function getFallbackLanguage(appConfig) {
    var isDefined = appConfig.lang && appConfig.lang.fallback;
    return isDefined ? appConfig.lang.fallback : __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(LocaleUtil.supportedLanguageFallback)[0];
  },

  /**
   * Checks whether the language code is supported by the application.
   *
   * @param {String} code The language code
   * @param {Object} appConfig Global application context.
   * @returns {Boolean} True if the language code is supported by the application.
   */
  isLanguageSupported: function isLanguageSupported(code, appConfig) {
    var _context4;

    var supported = LocaleUtil.getSupportedLanguages(appConfig);
    return __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_core_js_stable_instance_includes___default()(_context4 = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(supported)).call(_context4, code);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LocaleUtil);

/***/ }),

/***/ "eMo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ids-geographic-filter px-2"},[_c('ids-geo-selector',{ref:"idsCountrySelector",attrs:{"geoType":"country","geoList":_vm.countries,"selection":_vm.countrySelection,"headerText":"Land","placeHolderText":"Bitte wählen Sie eine Land aus","loading":_vm.countryLoading},on:{"ids-geo-selection-change":_vm.onGeoSelectionChange}}),_vm._v(" "),(_vm.showRegion)?_c('ids-geo-selector',{ref:"idsRegionSelector",attrs:{"geoType":"region","geoList":_vm.regions,"selection":_vm.regionSelection,"headerText":"Region","placeHolderText":"Bitte wählen Sie eine Region aus","loading":_vm.regionLoading},on:{"ids-geo-selection-change":_vm.onGeoSelectionChange}}):_vm._e(),_vm._v(" "),(_vm.showDistrict)?_c('ids-geo-selector',{ref:"idsDistrictSelector",attrs:{"geoType":"district","geoList":_vm.districts,"selection":_vm.districtSelection,"headerText":"Landkreise","placeHolderText":"Bitte wählen Sie eine Kreis aus","loading":_vm.districtLoading},on:{"ids-geo-selection-change":_vm.onGeoSelectionChange}}):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "f4Re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LayerLegendImage__ = __webpack_require__("WKho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LayerOpacityControl__ = __webpack_require__("G9tR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlistitem',
  components: {
    'wgu-layerlegendimage': __WEBPACK_IMPORTED_MODULE_0__LayerLegendImage__["a" /* default */],
    'wgu-layeropacitycontrol': __WEBPACK_IMPORTED_MODULE_1__LayerOpacityControl__["a" /* default */]
  },
  data: function data() {
    return {
      open: false
    };
  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    mapView: {
      type: Object,
      required: true
    },
    showLegends: {
      type: Boolean,
      required: true
    },
    showOpacityControls: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    /**
     * Handler for click on layer item, toggles the layer`s visibility.
     */
    onItemClick: function onItemClick() {
      this.layer.setVisible(!this.layer.getVisible());
    }
  },
  computed: {
    /**
     * Returns true, if the layer item should show an extension slider with layer details.
     */
    showDetails: function showDetails() {
      return this.showLegend || this.showOpacityControl;
    },

    /**
     * Returns true, if the layer item should show a legend image.
     */
    showLegend: function showLegend() {
      return this.showLegends && !!this.layer.get('legend');
    },

    /**
     * Returns true, if the layer item should show an opacity control.
     */
    showOpacityControl: function showOpacityControl() {
      return this.showOpacityControls && !!this.layer.get('opacityControl');
    }
  }
});

/***/ }),

/***/ "f54h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenCage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__);



// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

/**
 * OpenCage Provider, needs key. See https://opencagedata.com.
 *
 * @class OpenCage
 *
 */
var OpenCage = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function OpenCage() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, OpenCage);

    this.settings = {
      url: 'https://api.opencagedata.com/geocode/v1/json?',
      params: {
        q: '',
        key: '',
        limit: 10,
        countrycodes: '',
        language: 'en-US',
        pretty: 1,
        no_annotations: 1
      }
    };
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(OpenCage, [{
    key: "getParameters",
    value: function getParameters(options) {
      return {
        url: this.settings.url,
        params: {
          q: options.query,
          key: options.key,
          limit: options.limit || this.settings.params.limit,
          countrycode: options.countrycodes || this.settings.params.countrycodes,
          language: options.language || this.settings.params.language
        }
      };
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(results) {
      var _context;

      if (!results.results || results.results.length === 0) {
        return;
      }

      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = results.results).call(_context, function (result) {
        return {
          lon: result.geometry.lng,
          lat: result.geometry.lat,
          boundingbox: result.bounds && [result.bounds.southwest.lng, result.bounds.southwest.lat, result.bounds.northeast.lng, result.bounds.northeast.lat],
          address: {
            name: result.formatted,
            road: result.components.road || '',
            houseNumber: result.components.house_number || '',
            postcode: result.components.postcode || '',
            city: result.components.city || result.components.town || '',
            state: result.components.state || '',
            country: result.components.country || ''
          },
          original: {
            formatted: result.formatted,
            details: result.components
          }
        };
      });
    }
  }]);

  return OpenCage;
}();

/***/ }),

/***/ "fHet":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fIFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ViewAnimation__ = __webpack_require__("ntKu");

/**
 * Util class for OL layers
 */

var LayerUtil = {
  /**
   * Returns a set of map layers which matches the given key value pair.
   *
   * @param {String} key - Key to filter layers
   * @param {Object} value - Value to filter layers
   * @param  {ol.Map} olMap  The OL map to search in
   * @return {ol.layer.Base[]} Array of matching layers
   */
  getLayersBy: function getLayersBy(key, value, olMap) {
    if (!olMap) {
      return [];
    }

    var layerMatches = [];
    olMap.getLayers().forEach(function (layer) {
      if (layer.get(key) === value) {
        layerMatches.push(layer);
      }
    });
    return layerMatches;
  },

  /**
   * Returns a map layer with the given LID (Layer ID)
   *
   * @param  {String} lid    The LID of the layer to query
   * @param  {ol.Map} olMap  The OL map to search in
   * @return {ol.layer.Base} The OL layer instance or undefined
   */
  getLayerByLid: function getLayerByLid(lid, olMap) {
    return LayerUtil.getLayersBy('lid', lid, olMap)[0];
  },

  /**
   * Zooms to the given layer's extent.
   * Will only work if the layer has kind of vector source.
   *
   * @param  {ol.layer.Base} vecLayer OL vector layer
   * @param  {ol.Map} olMap           The map to perform the zoom on
   */
  zoomToLayerExtent: function zoomToLayerExtent(vecLayer, olMap) {
    if (!vecLayer || !vecLayer.getSource().getExtent || !olMap) {
      return;
    }

    var extent = vecLayer.getSource().getExtent();
    __WEBPACK_IMPORTED_MODULE_0__ViewAnimation__["a" /* default */].to(olMap.getView(), extent);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LayerUtil);

/***/ }),

/***/ "fLNA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fT5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OlStyleFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_max_safe_integer__ = __webpack_require__("L1Nm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_style__ = __webpack_require__("beD/");








function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }


/**
 * Factory, which creates OpenLayers style instances according to a given config
 * object.
 * This only covers a minimal subset of the OpenLayers style capabilities.
 * It allows to create simple styles for points, line and polygons.
 * For advanced styling use a custom style function or
 * GeoStyler<https://github.com/terrestris/geostyler>
 */

var OlStyleFactory = {
  /**
   * Returns an OpenLayers Style instance due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL Style instance
   */
  getInstance: function getInstance(styleConf) {
    var style;

    if (!styleConf) {
      return;
    } else if (styleConf.radius || styleConf.iconUrl || styleConf.textIcon) {
      style = OlStyleFactory.createPointStyle(styleConf);
    } else if (styleConf.fillColor) {
      style = OlStyleFactory.createPolygonStyle(styleConf);
    } else if (styleConf.strokeColor || styleConf.strokeWidth) {
      style = OlStyleFactory.createLineStyle(styleConf);
    }

    if (styleConf.label && styleConf.label.attribute && styleConf.label.attribute !== '') {
      // use an OL style function to enable labels
      return OlStyleFactory.getTextStyleFunction(style, styleConf.label);
    }

    return style;
  },

  /**
   * Returns an OpenLayers style instance for point due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createPointStyle: function createPointStyle(styleConf) {
    var pointStyle;

    if (styleConf.iconUrl) {
      pointStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["a" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_7_ol_style__["f" /* Icon */]({
          src: styleConf.iconUrl,
          scale: styleConf.scale || 1,
          anchor: styleConf.iconAnchor,
          anchorXUnits: styleConf.iconAnchorXUnits,
          anchorYUnits: styleConf.iconAnchorYUnits
        })
      });
    } else if (styleConf.radius) {
      pointStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["a" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_7_ol_style__["b" /* Circle */]({
          radius: styleConf.radius,
          fill: OlStyleFactory.createFill(styleConf),
          stroke: OlStyleFactory.createStroke(styleConf)
        })
      });
    } else {
      pointStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["a" /* Style */]({
        text: new __WEBPACK_IMPORTED_MODULE_7_ol_style__["e" /* Text */]({
          text: styleConf.textIcon,
          font: styleConf.font || 'normal 30px Material Icons',
          fill: OlStyleFactory.createFill(styleConf)
        })
      });
    }

    return pointStyle;
  },

  /**
   * Returns an OpenLayers style instance for lines due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createLineStyle: function createLineStyle(styleConf) {
    var olStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["a" /* Style */]({
      stroke: OlStyleFactory.createStroke(styleConf)
    });
    return olStyle;
  },

  /**
   * Returns an OpenLayers style instance for polygons due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createPolygonStyle: function createPolygonStyle(styleConf) {
    var olStyle = OlStyleFactory.createLineStyle(styleConf);
    olStyle.setFill(OlStyleFactory.createFill(styleConf));
    return olStyle;
  },

  /**
   * Creates an OL Stroke object due to given config.
   *
   * @param  {Object} styleConf Style config object
   * @return {Stroke}           OL Stroke instance
   */
  createStroke: function createStroke(styleConf) {
    return new __WEBPACK_IMPORTED_MODULE_7_ol_style__["c" /* Stroke */]({
      color: styleConf.strokeColor,
      width: styleConf.strokeWidth
    });
  },

  /**
   * Creates an OL Fill object due to given config.
   *
   * @param  {Object} styleConf Style config object
   * @return {Fill}             OL Fill instance
   */
  createFill: function createFill(styleConf) {
    return new __WEBPACK_IMPORTED_MODULE_7_ol_style__["d" /* Fill */]({
      color: styleConf.fillColor
    });
  },

  /**
   * Creates and returns a basic OL style object for texts.
   *
   * @param {Object} labelConf Style config object for labels
   * @returns {ol/style/Text} The OL style object for texts
   */
  getTextStyle: function getTextStyle(labelConf) {
    // create a clone to avoid unwanted in place modification
    var textConf = _objectSpread({}, labelConf);

    textConf.fill = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["d" /* Fill */]({
      color: textConf.fillColor
    });
    textConf.stroke = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["c" /* Stroke */]({
      color: textConf.outlineColor,
      width: textConf.outlineWidth
    });
    var textStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["e" /* Text */](textConf);
    return textStyle;
  },

  /**
   * Wraps the given OL style as function and injects a text style symbolizer
   * in order to show a label at the feature.
   *
   * @param {ol/style/Style} style
   * @param {Object} labelStyleConf
   * @returns {ol/style/Style~StyleFunction}
   *    Style function returning the OL style object enriched by texts / labels
   */
  getTextStyleFunction: function getTextStyleFunction(style, labelStyleConf) {
    var labelStyle = OlStyleFactory.getTextStyle(labelStyleConf);
    var labelAttr = labelStyleConf.attribute;
    return function (feature, resolution) {
      // detect min/max resolution to show labels
      // if nothing is configured labels are shown regardless of resolution
      var minRes = labelStyleConf.minResolution || __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_max_safe_integer___default.a;
      var maxRes = labelStyleConf.maxResolution || 0;

      if (resolution < minRes && resolution > maxRes) {
        // set text to display
        labelStyle.setText(feature.get(labelAttr)); // apply text style to overall style object

        style.setText(labelStyle);
      } else {
        labelStyle.setText(null);
      }

      return style;
    };
  }
};

/***/ }),

/***/ "fUjn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gjO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Locale__ = __webpack_require__("e/Tm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-localeswitcher',
  props: {
    icon: {
      type: String,
      required: false,
      default: 'language'
    }
  },
  data: function data() {
    return {
      show: false,
      lang: __WEBPACK_IMPORTED_MODULE_0__util_Locale__["a" /* default */].getSupportedLanguages(this.$appConfig)
    };
  },
  methods: {
    /**
     * Change the i18n and built-in vuetify locale.
     */
    onItemClick: function onItemClick(langCode) {
      this.$i18n.locale = this.$vuetify.lang.current = langCode;
    }
  }
});

/***/ }),

/***/ "gxed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_components_modulecore_ToggleButton__ = __webpack_require__("TVSi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_components_maxextentbutton_ZoomToMaxExtentButton__ = __webpack_require__("qqRY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_components_geocoder_Geocoder__ = __webpack_require__("kyCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_components_geolocator_Geolocator__ = __webpack_require__("1nz2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_components_localeswitcher_LocaleSwitcher__ = __webpack_require__("YvPU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_components_themeswitcher_ThemeSwitcher__ = __webpack_require__("ZjDE");







function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-header',
  components: {
    'wgu-toggle-btn': __WEBPACK_IMPORTED_MODULE_8__src_components_modulecore_ToggleButton__["a" /* default */],
    'wgu-geocoder-btn': __WEBPACK_IMPORTED_MODULE_10__src_components_geocoder_Geocoder__["a" /* default */],
    'wgu-zoomtomaxextent-btn': __WEBPACK_IMPORTED_MODULE_9__src_components_maxextentbutton_ZoomToMaxExtentButton__["a" /* default */],
    'wgu-geolocator-btn': __WEBPACK_IMPORTED_MODULE_11__src_components_geolocator_Geolocator__["a" /* default */],
    'wgu-localeswitcher-btn': __WEBPACK_IMPORTED_MODULE_12__src_components_localeswitcher_LocaleSwitcher__["a" /* default */],
    'wgu-themeswitcher-btn': __WEBPACK_IMPORTED_MODULE_13__src_components_themeswitcher_ThemeSwitcher__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      menuButtons: this.getModuleButtons('menu'),
      tbButtons: this.getModuleButtons('toolbar')
    };
  },
  methods: {
    /**
     * Determines the module button configuration objects from app-config:
     * If the module button toggles a window, then a generic wgu-toggle-btn will
     * be returned - otherwise the button is custom.
     *
     *    menuButtons: [
     *      {type: 'wgu-layerlist-toggle-btn'},
     *      {type: 'wgu-helpwin-toggle-btn'},
     *      {type: 'wgu-measuretool-toggle-btn'}
     *    ]
     * @param  {String} target Either 'menu' or 'toolbar'
     * @return {Array} module button configuration objects
     */
    getModuleButtons: function getModuleButtons(target) {
      var appConfig = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig || {};
      var modulesConfs = appConfig.modules || {};
      var buttons = [];

      for (var _i = 0, _Object$keys = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(modulesConfs); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        var moduleOpts = appConfig.modules[key];

        if (moduleOpts.target === target) {
          buttons.push(_objectSpread({
            type: moduleOpts.win ? 'wgu-toggle-btn' : key + '-btn',
            moduleName: key
          }, moduleOpts));
        }
      }

      return buttons;
    }
  }
});

/***/ }),

/***/ "h4Lm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__ = __webpack_require__("0WSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator__ = __webpack_require__("I3KW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_promise__ = __webpack_require__("SBIS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_JsUtil__ = __webpack_require__("kURA");





var DgdMockDataLoader = {
  /**
   * Returns a mock list of all location types (Ortstypen) as JSON array.
   *
   * @returns The JSON array with all location types (key: 'v_ortstyp')
   */
  getLocationTypeList: function getLocationTypeList() {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee() {
      var randomTimeout;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              randomTimeout = __WEBPACK_IMPORTED_MODULE_4__util_JsUtil__["a" /* default */].randomIntFromInterval(100, 500);
              return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_promise___default.a(function (resolve, reject) {
                setTimeout(function () {
                  resolve([{
                    'v_ortstyp': 'Aufnahmeort'
                  }, {
                    'v_ortstyp': 'Geburtsort'
                  }, {
                    'v_ortstyp': 'Mundartort'
                  }, {
                    'v_ortstyp': 'Wohnort'
                  }]);
                }, randomTimeout);
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * Returns a mock list of all corpora (Korpora) as JSON array.
   *
   * @returns The GeoJSON for the given filter parameters
   */
  getCorpusList: function getCorpusList() {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_promise___default.a(function (resolve, reject) {
                resolve([{
                  v_corpus_id: 'FOLK',
                  v_corpus_name: 'Forschungs- und Lehrkorpus Gesprochenes Deutsch',
                  v_corpus_cat: 'Gesprächskorpora'
                }, {
                  v_corpus_id: 'ZW',
                  v_corpus_name: 'Deutsche Mundarten: Zwirner-Korpus',
                  v_corpus_cat: 'Gesprächskorpora'
                }, {
                  v_corpus_id: 'SW--',
                  v_corpus_name: 'Deutsche Mundarten: Schwarzwald',
                  v_corpus_cat: 'Gesprächskorpora'
                }, {
                  v_corpus_id: 'AD',
                  v_corpus_name: 'Australiendeutsch',
                  v_corpus_cat: 'Kategorie 2'
                }, {
                  v_corpus_id: 'WISC',
                  v_corpus_name: 'Deutsch in Wisconsin',
                  v_corpus_cat: 'Kategorie 3'
                }, {
                  v_corpus_id: 'DNAM',
                  v_corpus_name: 'Deutsch in Namibia',
                  v_corpus_cat: 'Kategorie 2'
                }, {
                  v_corpus_id: '3MBG',
                  v_corpus_name: 'Noch ein 3er Korpus',
                  v_corpus_cat: 'Kategorie 3'
                }]);
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   * Returns a mock list of all countries as JSON array.
   *
   * @returns The country JSON array
   */
  getCountryList: function getCountryList() {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee3() {
      var randomTimeout;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              randomTimeout = __WEBPACK_IMPORTED_MODULE_4__util_JsUtil__["a" /* default */].randomIntFromInterval(100, 500);
              return _context3.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_promise___default.a(function (resolve, reject) {
                setTimeout(function () {
                  var countries = [{
                    'ISO-Code': 'DE',
                    Langname: 'Deutschland'
                  }, {
                    'ISO-Code': 'AU',
                    Langname: 'Australien'
                  }, {
                    'ISO-Code': 'BE',
                    Langname: 'Belgien'
                  }, {
                    'ISO-Code': 'BO',
                    Langname: 'Bolivien'
                  }, {
                    'ISO-Code': 'Brasilien',
                    Langname: 'BR'
                  }];
                  var modCountries = [];
                  countries.forEach(function (r) {
                    modCountries.push({
                      name: r.Langname,
                      iso: r['ISO-Code'],
                      clientId: r['ISO-Code']
                    });
                  });
                  modCountries.unshift({
                    name: '- Keine Auswahl -',
                    clientId: null
                  });
                  resolve(modCountries);
                }, randomTimeout);
              }));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },

  /**
   * Returns a mock list of all regions for the given country as JSON array.
   *
   * @returns The region JSON array
   */
  getRegionList: function getRegionList(countryCode) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee4() {
      var randomTimeout;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              randomTimeout = __WEBPACK_IMPORTED_MODULE_4__util_JsUtil__["a" /* default */].randomIntFromInterval(100, 500);
              return _context4.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_promise___default.a(function (resolve, reject) {
                setTimeout(function () {
                  var regions = [{
                    Region: countryCode + ' ' + 'Baden-Württemberg'
                  }, {
                    Region: countryCode + ' ' + 'Bayern'
                  }, {
                    Region: countryCode + ' ' + 'Berlin'
                  }, {
                    Region: countryCode + ' ' + 'Brandenburg'
                  }, {
                    Region: countryCode + ' ' + 'Bremen'
                  }];
                  var modRegions = [];
                  regions.forEach(function (r) {
                    modRegions.push({
                      name: r.Region,
                      clientId: r.Region
                    });
                  });
                  modRegions.unshift({
                    name: '- Keine Auswahl -',
                    clientId: null
                  });
                  resolve(modRegions);
                }, randomTimeout);
              }));

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /**
   * Returns a mock list of all districts for the given country and region as
   * JSON array.
   *
   * @returns The region JSON array
   */
  getDistrictList: function getDistrictList(countryCode, regionName) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee5() {
      var randomTimeout;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              randomTimeout = __WEBPACK_IMPORTED_MODULE_4__util_JsUtil__["a" /* default */].randomIntFromInterval(100, 500);
              return _context5.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_promise___default.a(function (resolve, reject) {
                setTimeout(function () {
                  var districts = [{
                    Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis 1'
                  }, {
                    Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis 2'
                  }, {
                    Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis 3'
                  }, {
                    Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis 4'
                  }, {
                    Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis n'
                  }];
                  var modDistricts = [];
                  districts.forEach(function (d) {
                    modDistricts.push({
                      name: d.Landkreis,
                      clientId: d.Landkreis
                    });
                  });
                  modDistricts.unshift({
                    name: '- Keine Auswahl -',
                    clientId: null
                  });
                  resolve(modDistricts);
                }, randomTimeout);
              }));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * Returns a mock list of locations (Ortsdaten) as GeoJSON FeatureCollection.
   *
   * @returns The GeoJSON for the given filter parameters
   */
  getLocationList: function getLocationList() {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee6() {
      var mockUrl, resp;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              mockUrl = './static/data/zw-ereignis-aufnahmeort.geo.json';

              if (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$mockGeoData === 1) {
                mockUrl = './static/data/isz-vater-sprecher-geburtsort.geo.json';
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$mockGeoData = 2;
              } else if (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$mockGeoData === 2) {
                mockUrl = './static/data/isw-sprecher-geburtsort.geo.json';
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$mockGeoData = 1;
              }

              if (!__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$mockGeoData) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$mockGeoData = 1;
              }

              _context6.next = 5;
              return fetch(mockUrl, {});

            case 5:
              resp = _context6.sent;
              return _context6.abrupt("return", resp.json());

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },

  /**
   * Returns a mock list of locations (Ortsdaten) as GeoJSON FeatureCollection,
   * based on a geographic filter.
   *
   * @returns
   */
  getLocationListGeo: function getLocationListGeo() {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.mark(function _callee7() {
      var randomTimeout;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              randomTimeout = __WEBPACK_IMPORTED_MODULE_4__util_JsUtil__["a" /* default */].randomIntFromInterval(100, 500);
              return _context7.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_promise___default.a(function (resolve, reject) {
                setTimeout(function () {
                  var geojson = {
                    'type': 'FeatureCollection',
                    'features': [{
                      'type': 'Feature',
                      'properties': {
                        'Dummy Dataset': true,
                        'lorem': 'ipsum',
                        'v_corpus_id': 'FOLK',
                        'v_corpus_name': 'Forschungs- und Lehrkorpus Gesprochenes Deutsch'
                      },
                      'geometry': {
                        'type': 'Point',
                        'coordinates': [9.29443359375, 49.51807644873301]
                      }
                    }, {
                      'type': 'Feature',
                      'properties': {
                        'Dummy Dataset': true,
                        'foo': 'bar',
                        'v_corpus_id': 'FOLK',
                        'v_corpus_name': 'Forschungs- und Lehrkorpus Gesprochenes Deutsch'
                      },
                      'geometry': {
                        'coordinates': [9.59106445312733, 49.35375571831017],
                        'type': 'Point'
                      }
                    }]
                  };
                  resolve(geojson);
                }, randomTimeout);
              }));

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (DgdMockDataLoader);

/***/ }),

/***/ "h9kb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_LayerPreview__ = __webpack_require__("yekt");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerpreviewimage',
  props: {
    mapView: {
      type: Object,
      required: true
    },
    layer: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    previewIcon: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      imgLoaded: false
    };
  },
  computed: {
    /**
     * Returns an URL to the layers preview image.
     */
    previewURL: function previewURL() {
      return this.layer.get('previewImage') || __WEBPACK_IMPORTED_MODULE_1__util_LayerPreview__["a" /* default */].getUrl(this.layer, this.mapView.getCenter(), this.mapView.getResolution(), this.mapView.getProjection());
    }
  }
});

/***/ }),

/***/ "hlHd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i6yw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMapPanel_vue__ = __webpack_require__("HD/1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebfda584_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMapPanel_vue__ = __webpack_require__("Ss2k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverviewMapPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebfda584_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMapPanel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebfda584_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverviewMapPanel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i8bC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("UdpQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea291714_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("UTjW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("9x2o")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea291714_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea291714_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ijcu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsGeoSelector_vue__ = __webpack_require__("sx1O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2450a40d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsGeoSelector_vue__ = __webpack_require__("2XVS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("SqAI")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2450a40d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsGeoSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2450a40d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsGeoSelector_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2450a40d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsGeoSelector_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "imGD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jQlT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-items',{staticClass:"d-flex align-center justify-center"},[_c('v-combobox',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideSearch),expression:"!hideSearch"}],staticClass:"wgu-geocoder-combo wgu-solo-field",attrs:{"outlined":"","dense":"","color":"accent","dark":_vm.isPrimaryDark,"filled":"","return-object":"","hide-details":"","no-filter":_vm.noFilter,"autofocus":_vm.autofocus,"items":_vm.resultItems,"label":_vm.$t('wgu-geocoder.placeHolder'),"clearable":_vm.clearable,"persistent-hint":_vm.persistentHint,"hidden":_vm.hideSearch,"rounded":_vm.rounded,"search-input":_vm.search},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._v(" "),_c('div',[_c('v-btn',{attrs:{"color":"onprimary","icon":"","title":_vm.$t('wgu-geocoder.title')},on:{"click":function($event){return _vm.toggle()}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "jc9b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgLayerSwitcher_vue__ = __webpack_require__("ygOZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d3bd38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerSwitcher_vue__ = __webpack_require__("k7iY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgLayerSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d3bd38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerSwitcher_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d3bd38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerSwitcher_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jsmT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jzAQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k3Re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsCorpusCategory_vue__ = __webpack_require__("rdXe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340b9e96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsCorpusCategory_vue__ = __webpack_require__("ZjhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("y83G")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-340b9e96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsCorpusCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340b9e96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsCorpusCategory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340b9e96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsCorpusCategory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k7iY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{attrs:{"id":"wgu-bglayerswitcher-wrapper"}},[_c('v-menu',{attrs:{"offset-x":"","nudge-right":"15","transition":"scale-transition","close-on-content-click":false,"attach":"#wgu-bglayerswitcher-wrapper"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-sheet',{staticClass:"wgu-map-button wgu-bglayerswitcher"},[_c('v-btn',_vm._g({attrs:{"color":"secondary","fab":"","title":_vm.$t('wgu-bglayerswitcher.title')}},on),[_c('v-icon',{attrs:{"color":"onsecondary","medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1)]}}],null,false,3071793356),model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._v(" "),(_vm.open)?_c('wgu-bglayerlist',{attrs:{"previewIcon":_vm.icon,"imageWidth":_vm.imageWidth,"imageHeight":_vm.imageHeight}}):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "kJWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-footer',
  props: {
    footerTextLeft: {
      type: String,
      required: true
    },
    footerTextRight: {
      type: String,
      required: true
    },
    showCopyrightYear: {
      type: Boolean,
      required: false,
      default: true
    }
  }
});

/***/ }),

/***/ "kQCp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_DraggableWin__ = __webpack_require__("MPh8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus__ = __webpack_require__("ZkkH");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-module-card',
  inheritAttrs: false,
  directives: {
    DraggableWin: __WEBPACK_IMPORTED_MODULE_1__directives_DraggableWin__["a" /* DraggableWin */]
  },
  props: {
    // Common properties
    moduleName: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    win: {
      type: String,
      required: false,
      default: 'floating'
    },
    minimizable: {
      type: Boolean,
      required: false,
      default: false
    },
    closable: {
      type: Boolean,
      required: false,
      default: true
    },
    backgroundImage: {
      type: String,
      required: false,
      default: undefined
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    // Positioning / sizing properties will be ignored for sidebar cards.
    draggable: {
      type: Boolean,
      required: false,
      default: true
    },
    initPos: {
      type: Object,
      required: false
    },
    height: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    width: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    maxHeight: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    maxWidth: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    minHeight: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    minWidth: {
      type: [Number, String],
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      show: this.visible,
      minimized: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$on(this.moduleName + '-visibility-change', function (visible) {
      _this.show = visible;

      _this.$emit('visibility-change', visible);
    });
  },
  updated: function updated() {
    if (this.show && this.win === 'sidebar') {
      __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$emit('sidebar-scroll', this);
    }
  },
  computed: {
    cardClasses: function cardClasses() {
      return this.win === 'floating' ? ['wgu-module-card', 'wgu-floating'] : ['wgu-module-card', 'wgu-sidebar'];
    },
    cardStyles: function cardStyles() {
      return this.win === 'floating' ? {
        left: this.initPos ? this.initPos.left + 'px' : '0px',
        top: this.initPos ? this.initPos.top + 'px' : '0px'
      } : {};
    },
    cardAttr: function cardAttr() {
      return this.win === 'floating' ? {
        height: this.height,
        width: this.width,
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth,
        minHeight: this.minHeight,
        minWidth: this.minWidth
      } : {};
    },
    cardDraggable: function cardDraggable() {
      return this.win === 'floating' ? this.draggable : false;
    },
    toolbarAttr: function toolbarAttr() {
      return this.backgroundImage ? {
        dark: true,
        flat: true,
        color: 'transparent'
      } : {
        color: 'primary',
        class: 'onprimary--text'
      };
    }
  },
  methods: {
    toggleUi: function toggleUi() {
      __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$emit(this.moduleName + '-visibility-change', !this.show);
    }
  }
});

/***/ }),

/***/ "kRhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layeropacitycontrol',
  props: {
    layer: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     * Handler for input on the opacity slider, updates the layer`s opacity.
     */
    onOpacitySliderInput: function onOpacitySliderInput(value) {
      this.layer.setOpacity(value);
    }
  }
});

/***/ }),

/***/ "kURA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__("xtLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_json_stringify__ = __webpack_require__("gPdZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_json_stringify__);



/**
 * Collection of helpers / utils around core JS / ES.
 */
var JsUtil = {
  /**
   * Checks if given input is a String.
   *
   * @param {*} candidate
   * @returns true/false
   */
  isString: function isString(candidate) {
    return Object.prototype.toString.call(candidate) === '[object String]';
  },

  /**
   * Checks if the given input is an object.
   *
   * @param {*} candidate
   * @returns true/false
   */
  isObject: function isObject(candidate) {
    return candidate && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(candidate) === 'object' && candidate.constructor === Object;
  },

  /**
   * Checks if the given input is a number. Returns false for non-finite numbers.
   *
   * @param {*} candidate
   * @returns true/false
   */
  isNumber: function isNumber(candidate) {
    return typeof candidate === 'number' && isFinite(candidate);
  },

  /**
   * Checks if the given input is numeric.
   *
   * @param {*} candidate Examples: 1, '1', '2.34'
   * @returns true/false
   */
  isNumeric: function isNumeric(candidate) {
    return !isNaN(parseFloat(candidate)) && isFinite(candidate);
  },

  /**
   * Clones a JS object.
   *
   * @param {Object} obj
   * @returns The cloned object
   */
  cloneObject: function cloneObject(obj) {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_json_stringify___default()(obj));
  },

  /**
   * Removes the given property from the given object. The operation is not
   * taken in place but on a cloned object, which will be returned.
   *
   * @param {Object} obj
   * @param {String} prop
   * @returns Object clone with removed property
   */
  removePropFromObject: function removePropFromObject(obj, prop) {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_json_stringify___default()(obj, function (key, val) {
      return key === prop ? undefined : val;
    }));
  },

  /**
   * Returns a random Integer between the given min/max values (included).
   *
   * @param {Number} min Min. Integer included
   * @param {Number} max Max. Integer included
   * @returns Random Integer in the given range
   */
  randomIntFromInterval: function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  },

  /**
   * Replaces {0}, {1}, ... occurrences in the given string with the given
   * arguments in args1.
   *
   * @param {String} str
   * @param  {...String} args1
   * @returns The replaced string
   */
  formatString: function formatString(str) {
    for (var _len = arguments.length, args1 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args1[_key - 1] = arguments[_key];
    }

    // store arguments in an array
    var args = args1;

    if (!str) {
      return;
    } // use replace to iterate over the string
    // select the match and check if the related argument is present
    // if true, replace the match with the argument


    return str.replace(/{([0-9]+)}/g, function (match, idx) {
      // check if the argument is present
      return typeof args[idx] === 'undefined' ? match : args[idx];
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (JsUtil);

/***/ }),

/***/ "ktr9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kyCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geocoder_vue__ = __webpack_require__("VNHm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecf5454e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geocoder_vue__ = __webpack_require__("jQlT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geocoder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecf5454e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geocoder_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecf5454e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geocoder_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lHTH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modulecore_MapOverlay_vue__ = __webpack_require__("WAwj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-hover-tooltip',
  components: {
    'wgu-map-overlay': __WEBPACK_IMPORTED_MODULE_0__modulecore_MapOverlay_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "lQeg":
/***/ (function(module, exports) {

module.exports = {"_from":"proj4@2.5.0","_id":"proj4@2.5.0","_inBundle":false,"_integrity":"sha512-XZTRT7OPdLzgvtTqL8DG2cEj8lYdovztOwiwpwRSYayOty5Ipf3H68dh/fiL+HKDEyetmQSMhkkMGiJoyziz3w==","_location":"/proj4","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"proj4@2.5.0","name":"proj4","escapedName":"proj4","rawSpec":"2.5.0","saveSpec":null,"fetchSpec":"2.5.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/proj4/-/proj4-2.5.0.tgz","_shasum":"e3a88ce7e7a07221aaccbc6760dd2eafee745f03","_spec":"proj4@2.5.0","_where":"/home/meggs/workspace/meggsimum/leibniz-ids/frontend","author":"","bugs":{"url":"https://github.com/proj4js/proj4js/issues"},"bundleDependencies":false,"contributors":[{"name":"Mike Adair","email":"madair@dmsolutions.ca"},{"name":"Richard Greenwood","email":"rich@greenwoodmap.com"},{"name":"Calvin Metcalf","email":"calvin.metcalf@gmail.com"},{"name":"Richard Marsden","url":"http://www.winwaed.com"},{"name":"T. Mittan"},{"name":"D. Steinwand"},{"name":"S. Nelson"}],"dependencies":{"mgrs":"1.0.0","wkt-parser":"^1.2.0"},"deprecated":false,"description":"Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.","devDependencies":{"chai":"~4.1.2","curl-amd":"github:cujojs/curl","grunt":"^1.0.1","grunt-cli":"~1.2.0","grunt-contrib-connect":"~1.0.2","grunt-contrib-jshint":"~1.1.0","grunt-contrib-uglify":"~3.1.0","grunt-mocha-phantomjs":"~4.0.0","grunt-rollup":"^6.0.0","istanbul":"~0.4.5","mocha":"~4.0.0","rollup":"^0.50.0","rollup-plugin-json":"^2.3.0","rollup-plugin-node-resolve":"^3.0.0","tin":"~0.5.0"},"directories":{"test":"test","doc":"docs"},"homepage":"https://github.com/proj4js/proj4js#readme","license":"MIT","main":"dist/proj4-src.js","module":"lib/index.js","name":"proj4","repository":{"type":"git","url":"git://github.com/proj4js/proj4js.git"},"scripts":{"build":"grunt","build:tmerc":"grunt build:tmerc","test":"npm run build && istanbul test _mocha test/test.js"},"version":"2.5.0"}

/***/ }),

/***/ "lgWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureWin_vue__ = __webpack_require__("4z3x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b160dce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__ = __webpack_require__("0ZKt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b160dce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b160dce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mUig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("gxed");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eae66e0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("tFIa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Xzb6")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eae66e0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eae66e0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mucN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerList_vue__ = __webpack_require__("VLBH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afdfa976_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__ = __webpack_require__("PSzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afdfa976_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afdfa976_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nF/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Util class for color related things.
 */
var ColorUtil = {
  /**
   * Detects whether a given string is a CSS color notation.
   *
   * @param {String} color (Color) string to test
   * @return {Boolean} true if given string is in CSS color notation
   */
  isCssColor: function isCssColor(color) {
    return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/);
  },

  /**
   * Luminance theory from:
   *    https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
   * Hexa -> RGB from:
   *    https://stackoverflow.com/questions/12043187/how-to-check-if-hex-color-is-too-black
   *
   * Checks if an hexadecimal color is dark/bright
   * @param {String} hexa color in hexadecimal format
   * @returns {Boolean} true if dark
   */
  checkLuminance: function checkLuminance(hexa) {
    var c = hexa.substring(1); // strip #

    var rgb = parseInt(c, 16); // convert rrggbb to decimal

    var r = rgb >> 16 & 0xff; // extract red

    var g = rgb >> 8 & 0xff; // extract green

    var b = rgb >> 0 & 0xff; // extract blue
    // normalize to [0, 1]

    r = r / 255.0;
    g = g / 255.0;
    b = b / 255.0; // https://www.w3.org/TR/WCAG20/#relativeluminancedef

    r = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
    g = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
    b = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4); // https://www.w3.org/TR/WCAG20/#relativeluminancedef

    var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // returns true if dark color

    return luma <= 0.179;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ColorUtil);

/***/ }),

/***/ "nU5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"dense":"","loading":_vm.loading,"loading-text":_vm.$t('wgu-attributetable.loadingText'),"headers":_vm.headers,"items":_vm.records,"mobile-breakpoint":"0","page":_vm.page,"footer-props":{
      'items-per-page-options': [],
      'show-first-last-page': true
    },"single-select":"","value":_vm.selectedRow,"item-key":_vm.uniqueRecordKeyName,"items-per-page":_vm.rowsPerPage,"height":_vm.getTableHeight()},on:{"update:page":function($event){_vm.page=$event},"click:row":_vm.onRowClick}})}
var staticRenderFns = []


/***/ }),

/***/ "njir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__("xtLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_freeze__ = __webpack_require__("7J1l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Color__ = __webpack_require__("nF/d");


 // Macro for default color themes configuration

var DEFAULT_THEMES = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_freeze___default()({
  'light': {
    'primary': '#af2622',
    'onprimary': '#ffffff',
    'secondary': '#af2622',
    'onsecondary': '#ffffff',
    'anchor': '#af2622',
    'error': '#ff6f00'
  },
  'dark': {
    'primary': '#272727',
    'onprimary': '#ffffff',
    'secondary': '#ea9b9b',
    'onsecondary': '#272727',
    'anchor': '#ea9b9b',
    'error': '#ff6f00'
  }
}); // Macros for light/dark theme


var LIGHT_WHITE = '#ffffff';
var LIGHT_ERROR = '#FF5252';
var LIGHT_INFO = '#2196F3';
var LIGHT_SUCCESS = '#4CAF50';
var LIGHT_WARNING = '#FFC107';
var LIGHT_BLACK = '#000000';
var DARK_WHITE = '#ffffff';
var DARK_ERROR = '#FF5252';
var DARK_INFO = '#2196F3';
var DARK_SUCCESS = '#4CAF50';
var DARK_WARNING = '#FFC107';
var DARK_BLACK = '#272727';
/**
   * Gets the base color for the input color.
   * See the theme object interface on
   * https://vuetifyjs.com/en/features/theme/#custom-theme-variants
   * @param {String | Object} color hexadecimal/object color
   * @returns {String} base color
   */

function getBaseColor(color) {
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(color) === 'object' ? color.base : color;
}
/**
 * Checks luminance of the input color and:
 *   - chooses "light" if color is dark;
 *   - chooses "dark" if color is light
 * @param {String | Object} color hexadecimal/object color
 * @param {String} light hexadecimal color
 * @param {String} dark hexadecimal color
 * @returns {String} contrast color
 */


function contrastColor(color, light, dark) {
  var baseColor = getBaseColor(color);
  return __WEBPACK_IMPORTED_MODULE_2__Color__["a" /* default */].checkLuminance(baseColor) ? light : dark;
}
/**
 * Util class for vuetify theming
 */


var ColorThemeUtil = {
  /**
   * Merges user color theme with the default color theme
   * @param {Object} inputTheme input theme from app-config
   * @param {Object} defaultTheme default Wegue theme
   * @returns {Object} merged color theme
   */
  mergeThemes: function mergeThemes(inputTheme, defaultTheme) {
    var light = inputTheme.light,
        dark = inputTheme.dark;
    var merged = {
      light: {},
      dark: {}
    }; // If light theme is configured with at least the primary color

    if (!light || !light.primary) {
      // fallback to default light theme
      light = defaultTheme.light;
    } // set primary color


    merged.light.primary = light.primary; // set secondary to user secondary,
    // otherwise fallback to primary

    merged.light.secondary = light.secondary ? light.secondary : light.primary; // set accent to the light theme white

    merged.light.accent = contrastColor(merged.light.primary, LIGHT_WHITE, LIGHT_BLACK); // set anchor to the light theme secondary

    merged.light.anchor = merged.light.secondary; // set onprimary to user onprimary,
    // otherwise fallback to a color that contrasts with the primary

    merged.light.onprimary = light.onprimary ? light.onprimary : contrastColor(merged.light.primary, LIGHT_WHITE, LIGHT_BLACK); // set onprimary to user onsecondary,
    // otherwise fallback to a color that contrasts with the secondary

    merged.light.onsecondary = light.onsecondary ? light.onsecondary : contrastColor(merged.light.secondary, LIGHT_WHITE, LIGHT_BLACK); // set semantic colors,
    // otherwise fallback to light theme defaults

    merged.light.info = light.info ? light.info : LIGHT_INFO;
    merged.light.success = light.success ? light.success : LIGHT_SUCCESS;
    merged.light.warning = light.warning ? light.warning : LIGHT_WARNING;
    merged.light.error = light.error ? light.error : LIGHT_ERROR; // If light theme is configured with at least the secondary color

    if (!dark || !dark.secondary) {
      // fallback to default dark theme
      dark = defaultTheme.dark;
    } // set primary to dark theme primary


    merged.dark.primary = DARK_BLACK; // set secondary

    merged.dark.secondary = dark.secondary; // set anchor to the dark theme secondary

    merged.dark.anchor = merged.dark.secondary; // set accent to secondary

    merged.dark.accent = dark.secondary; // set onprimary to dark theme white

    merged.dark.onprimary = DARK_WHITE; // set onsecondary to user onsecondary,
    // otherwise fallback to a color that contrasts with secondary

    merged.dark.onsecondary = dark.onsecondary ? dark.onsecondary : contrastColor(merged.dark.secondary, DARK_WHITE, DARK_BLACK); // set semantic colors,
    // otherwise fallback to dark theme defaults

    merged.dark.info = dark.info ? dark.info : DARK_INFO;
    merged.dark.success = dark.success ? dark.success : DARK_SUCCESS;
    merged.dark.warning = dark.warning ? dark.warning : DARK_WARNING;
    merged.dark.error = dark.error ? dark.error : DARK_ERROR;
    return merged;
  },

  /**
   * Builds the theme object used by Vuetify
   * @param {Object} inputConfig user configuration from app-config
   * @returns {Object} theme object
   */
  buildTheme: function buildTheme(inputConfig) {
    // If there is no input config, create it
    if (!inputConfig || __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(inputConfig) !== 'object') {
      inputConfig = {
        dark: false
      };
    } // If there is no input themes, create it


    if (!inputConfig.themes || __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(inputConfig.themes) !== 'object') {
      inputConfig.themes = {};
    } // Object for the output config


    var outputConfig = {}; // Apply start with dark theme

    outputConfig.dark = !!inputConfig.dark; // Apply user theme or fallback to default

    outputConfig.themes = ColorThemeUtil.mergeThemes(inputConfig.themes, DEFAULT_THEMES); // Set customProperties.
    // This creates css colors for each vuetify color class

    outputConfig.options = {
      'customProperties': true
    };
    return outputConfig;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ColorThemeUtil);

/***/ }),

/***/ "novK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLoadingStatus_vue__ = __webpack_require__("RAvm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddafc1e6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__ = __webpack_require__("I1J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("jsmT")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLoadingStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddafc1e6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddafc1e6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ntKu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_geom_Point__ = __webpack_require__("T18w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_geom_Geometry__ = __webpack_require__("SfaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");




/**
 * A collection of view animations to zoom an OpenLayers view to a given location or extent.
 * Inspired by http://openlayers.org/en/latest/examples/animation.html
 */

var ViewAnimationUtil = {
  /**
   * Returns the animation object configured in the application context.
   * @returns The animation object.
   * @private
   */
  getAnimation: function getAnimation() {
    var _appConfig$viewAnimat;

    var animations = {
      'none': NoAnimation,
      'pan': PanAnimation,
      'fly': FlyAnimation,
      'bounce': BounceAnimation,
      'default': NoAnimation
    };
    var appConfig = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$appConfig;
    var animType = appConfig === null || appConfig === void 0 ? void 0 : (_appConfig$viewAnimat = appConfig.viewAnimation) === null || _appConfig$viewAnimat === void 0 ? void 0 : _appConfig$viewAnimat.type;
    return animations[animType] || animations['default'];
  },

  /**
   * Returns the configuration object for the animation. If options have been provided by the caller,
   * these options will be returned, otherwise return the options configured in the application
   * context.
   * @param {Object} options Optional configuration object for the animation.
   * @returns An object containing the animation configuration.
   * @private
   */
  getOptions: function getOptions(options) {
    var _appConfig$viewAnimat2;

    var appConfig = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$appConfig;
    return options || (appConfig === null || appConfig === void 0 ? void 0 : (_appConfig$viewAnimat2 = appConfig.viewAnimation) === null || _appConfig$viewAnimat2 === void 0 ? void 0 : _appConfig$viewAnimat2.options) || {};
  },

  /**
   * Zoom to the given destination.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate | ol.Extent | ol.geom.Geometry} destination
   *  The destination coordinate, point, geometry or extent to zoom to.
   * @param {*} completionCallback An optional notification that the animation has completed.
   * @param {*} options Optional configuration object for the animation.
   */
  to: function to(view, destination, completionCallback, options) {
    if (destination instanceof __WEBPACK_IMPORTED_MODULE_1_ol_geom_Point__["a" /* default */]) {
      this.toLocation(view, destination.getCoordinates(), completionCallback, options);
    } else if (destination instanceof __WEBPACK_IMPORTED_MODULE_2_ol_geom_Geometry__["a" /* default */]) {
      this.toExtent(view, destination.getExtent(), completionCallback, options);
    } else if (Array.isArray(destination) && destination.length === 2) {
      this.toLocation(view, destination, completionCallback, options);
    } else if (Array.isArray(destination) && destination.length === 4) {
      this.toExtent(view, destination, completionCallback, options);
    } else {
      console.error('Unsupported type for destination.');
    }
  },

  /**
   * Zoom to the given location.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate} location The destination center point to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Optional configuration object for the animation.
   */
  toLocation: function toLocation(view, location, completionCallback, options) {
    this.getAnimation().toLocation(view, location, completionCallback, this.getOptions(options));
  },

  /**
   * Zoom to the given extent.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Extent} extent The destination extent to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Optional configuration object for the animation.
   */
  toExtent: function toExtent(view, extent, completionCallback, options) {
    this.getAnimation().toExtent(view, extent, completionCallback, this.getOptions(options));
  }
};
/**
 * No animation.
 * @private
 */

var NoAnimation = {
  /**
   * Zoom to the given location by not using animations.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate} location The destination center point to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Configuration object for the animation, supported attributes are:
   * * {Number} zoom An optional final zoom level.
   * * {Number} maxZoom An optional maximal zoom level.
   */
  toLocation: function toLocation(view, location, completionCallback, options) {
    var _options$zoom, _options$maxZoom;

    // Set defaults if arguments are not provided.
    var zoom = (_options$zoom = options.zoom) !== null && _options$zoom !== void 0 ? _options$zoom : view.getZoom();
    var maxZoom = (_options$maxZoom = options.maxZoom) !== null && _options$maxZoom !== void 0 ? _options$maxZoom : Infinity;
    this.animate(view, location, completionCallback, zoom, maxZoom);
  },

  /**
   * Zoom to fit the given extentby not using animations.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Extent} extent The destination extent to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Configuration object for the animation, supported attributes are:
   * * {Number} maxZoom An optional maximal zoom level.
   */
  toExtent: function toExtent(view, extent, completionCallback, options) {
    var _options$maxZoom2;

    // Set defaults if arguments are not provided.
    var maxZoom = (_options$maxZoom2 = options.maxZoom) !== null && _options$maxZoom2 !== void 0 ? _options$maxZoom2 : Infinity; // Zoom to the given extent.

    var resolution = view.getResolutionForExtent(extent);
    var zoom = view.getZoomForResolution(resolution) - 0.2;
    var location = __WEBPACK_IMPORTED_MODULE_0_ol_extent__["c" /* getCenter */](extent);
    this.animate(view, location, completionCallback, zoom, maxZoom);
  },

  /**
   * Move to the location.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate} location The destination center point to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Number} zoom The final zoom level.
   * @param {Number} maxZoom The maximal zoom level.
   */
  animate: function animate(view, location, completionCallback, zoom, maxZoom) {
    view.fit(new __WEBPACK_IMPORTED_MODULE_1_ol_geom_Point__["a" /* default */](location), {
      maxZoom: Math.min(zoom, maxZoom),
      callback: completionCallback
    });
  }
};
/**
 * A pan animation.
 * Remarks: This may also zoom in / zoom out, if a zoom level has been provided or the toExtent method
 *  is used.
 * @private
 */

var PanAnimation = {
  /**
   * Zoom to the given location by using a "pan" animation.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate} location The destination center point to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Configuration object for the animation, supported attributes are:
   * * {Number} duration An optional animation duration.
   * * {Number} zoom An optional final zoom level.
   * * {Number} maxZoom An optional maximal zoom level.
   */
  toLocation: function toLocation(view, location, completionCallback, options) {
    var _options$duration, _options$zoom2, _options$maxZoom3;

    // Set defaults if arguments are not provided.
    var duration = (_options$duration = options.duration) !== null && _options$duration !== void 0 ? _options$duration : 3000;
    var zoom = (_options$zoom2 = options.zoom) !== null && _options$zoom2 !== void 0 ? _options$zoom2 : view.getZoom();
    var maxZoom = (_options$maxZoom3 = options.maxZoom) !== null && _options$maxZoom3 !== void 0 ? _options$maxZoom3 : Infinity;
    this.animate(view, location, completionCallback, duration, zoom, maxZoom);
  },

  /**
   * Zoom to fit the given extent by using a "pan" animation.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Extent} extent The destination extent to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Configuration object for the animation, supported attributes are:
   * * {Number} duration An optional animation duration.
   * * {Number} maxZoom An optional maximal zoom level.
   */
  toExtent: function toExtent(view, extent, completionCallback, options) {
    var _options$duration2, _options$maxZoom4;

    // Set defaults if arguments are not provided.
    var duration = (_options$duration2 = options.duration) !== null && _options$duration2 !== void 0 ? _options$duration2 : 3000;
    var maxZoom = (_options$maxZoom4 = options.maxZoom) !== null && _options$maxZoom4 !== void 0 ? _options$maxZoom4 : Infinity; // Zoom to the given extent.

    var resolution = view.getResolutionForExtent(extent);
    var zoom = view.getZoomForResolution(resolution) - 0.2;
    var location = __WEBPACK_IMPORTED_MODULE_0_ol_extent__["c" /* getCenter */](extent);
    this.animate(view, location, completionCallback, duration, zoom, maxZoom);
  },

  /**
   * Pan / zoom to the location.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate} location The destination center point to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Number} duration The animation duration.
   * @param {Number} zoom The final zoom level.
   * @param {Number} maxZoom The maximal zoom level.
   */
  animate: function animate(view, location, completionCallback, duration, zoom, maxZoom) {
    function callback(complete) {
      if (completionCallback) {
        completionCallback(complete);
      }
    }

    view.animate({
      center: location,
      duration: duration,
      zoom: Math.min(zoom, maxZoom)
    }, callback);
  }
};
/**
 * A fly animation.
 * @private
 */

var FlyAnimation = {
  /**
   * Zoom to the given location by using a "fly" animation.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate} location The destination center point to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Configuration object for the animation, supported attributes are:
   * * {Number} duration An optional animation duration.
   * * {Number} zoom An optional final zoom level.
   * * {Number} maxZoom An optional maximal zoom level.
   */
  toLocation: function toLocation(view, location, completionCallback, options) {
    var _options$duration3, _options$zoom3, _options$maxZoom5;

    // Set defaults if arguments are not provided.
    var duration = (_options$duration3 = options.duration) !== null && _options$duration3 !== void 0 ? _options$duration3 : 3000;
    var zoom = (_options$zoom3 = options.zoom) !== null && _options$zoom3 !== void 0 ? _options$zoom3 : view.getZoom();
    var maxZoom = (_options$maxZoom5 = options.maxZoom) !== null && _options$maxZoom5 !== void 0 ? _options$maxZoom5 : Infinity; // Zoom out to have both locations visible.

    var extentOut = view.calculateExtent();
    __WEBPACK_IMPORTED_MODULE_0_ol_extent__["r" /* extend */](extentOut, __WEBPACK_IMPORTED_MODULE_0_ol_extent__["a" /* boundingExtent */]([location]));
    var resolutionOut = view.getResolutionForExtent(extentOut);
    var zoomOut = view.getZoomForResolution(resolutionOut) - 1;
    this.animate(view, location, completionCallback, duration, zoomOut, zoom, maxZoom);
  },

  /**
   * Zoom to fit the given extent by using a "fly" animation.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Extent} extent The destination extent to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Configuration object for the animation, supported attributes are:
   * * {Number} duration An optional animation duration.
   * * {Number} maxZoom An optional maximal zoom level.
   */
  toExtent: function toExtent(view, extent, completionCallback, options) {
    var _options$duration4, _options$maxZoom6;

    // Set defaults if arguments are not provided.
    var duration = (_options$duration4 = options.duration) !== null && _options$duration4 !== void 0 ? _options$duration4 : 3000;
    var maxZoom = (_options$maxZoom6 = options.maxZoom) !== null && _options$maxZoom6 !== void 0 ? _options$maxZoom6 : Infinity; // Zoom out to have both locations visible.

    var extentOut = view.calculateExtent();
    __WEBPACK_IMPORTED_MODULE_0_ol_extent__["r" /* extend */](extentOut, extent);
    var resolutionOut = view.getResolutionForExtent(extentOut);
    var zoomOut = view.getZoomForResolution(resolutionOut) - 1; // Then zoom in to the given extent.

    var resolutionIn = view.getResolutionForExtent(extent);
    var zoom = view.getZoomForResolution(resolutionIn) - 0.2;
    var location = __WEBPACK_IMPORTED_MODULE_0_ol_extent__["c" /* getCenter */](extent);
    this.animate(view, location, completionCallback, duration, zoomOut, zoom, maxZoom);
  },

  /**
   * The animation consist of 2 simultaneous parts:
   * Zoom out then zoom in, while moving to the center location.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate} location The destination center point to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Number} duration The animation duration.
   * @param {Number} zoomOut The zoom out level.
   * @param {Number} zoom The final zoom level.
   * @param {Number} maxZoom The maximal zoom level.
   */
  animate: function animate(view, location, completionCallback, duration, zoomOut, zoom, maxZoom) {
    var parts = 2;
    var finished = false;

    function callback(complete) {
      --parts;

      if (finished) {
        return;
      }

      if (parts === 0 || !complete) {
        finished = true;

        if (completionCallback) {
          completionCallback(complete);
        }
      }
    }

    view.animate({
      center: location,
      duration: duration
    }, callback);
    view.animate({
      zoom: zoomOut,
      duration: duration / 2
    }, {
      zoom: Math.min(zoom, maxZoom),
      duration: duration / 2
    }, callback);
  }
};
/**
 * A bounce animation.
 * @private
 */

var BounceAnimation = {
  /**
   * Zoom to the given location by using a "bounce" animation.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate} location The destination center point to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Configuration object for the animation, supported attributes are:
   * * {Number} duration An optional animation duration.
   * * {Number} zoom An optional final zoom level.
   * * {Number} maxZoom An optional maximal zoom level.
   */
  toLocation: function toLocation(view, location, completionCallback, options) {
    var _options$duration5, _options$zoom4, _options$maxZoom7;

    // Set defaults if arguments are not provided.
    var duration = (_options$duration5 = options.duration) !== null && _options$duration5 !== void 0 ? _options$duration5 : 3000;
    var zoom = (_options$zoom4 = options.zoom) !== null && _options$zoom4 !== void 0 ? _options$zoom4 : view.getZoom();
    var maxZoom = (_options$maxZoom7 = options.maxZoom) !== null && _options$maxZoom7 !== void 0 ? _options$maxZoom7 : Infinity;
    this.animate(view, location, completionCallback, duration, zoom, maxZoom);
  },

  /**
   * Zoom to fit the given extent by using a "bounce" animation.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Extent} extent The destination extent to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Object} options Configuration object for the animation, supported attributes are:
   * * {Number} duration An optional animation duration.
   * * {Number} maxZoom An optional maximal zoom level.
   */
  toExtent: function toExtent(view, extent, completionCallback, options) {
    var _options$duration6, _options$maxZoom8;

    // Set defaults if arguments are not provided.
    var duration = (_options$duration6 = options.duration) !== null && _options$duration6 !== void 0 ? _options$duration6 : 3000;
    var maxZoom = (_options$maxZoom8 = options.maxZoom) !== null && _options$maxZoom8 !== void 0 ? _options$maxZoom8 : Infinity; // Zoom to the given extent.

    var resolution = view.getResolutionForExtent(extent);
    var zoom = view.getZoomForResolution(resolution) - 0.2;
    var location = __WEBPACK_IMPORTED_MODULE_0_ol_extent__["c" /* getCenter */](extent);
    this.animate(view, location, completionCallback, duration, zoom, maxZoom);
  },

  /**
   * An elastic easing method
   * (from https://github.com/DmitryBaranovskiy/raphael).
   * @private
   */
  elastic: function elastic(t) {
    return Math.pow(2, -10 * t) * Math.sin((t - 0.075) * (2 * Math.PI) / 0.3) + 1;
  },

  /**
   * The animation consist of 2 simultaneous parts:
   * Zoom in or out, while moving to the center location.
   * @param {ol.View} view The `ol.View` of the map.
   * @param {ol.Coordinate} location The destination center point to zoom to.
   * @param {function(complete)} completionCallback An optional notification that the animation has completed.
   * @param {Number} duration The animation duration.
   * @param {Number} zoom The final zoom level.
   * @param {Number} maxZoom The maximal zoom level.
   */
  animate: function animate(view, location, completionCallback, duration, zoom, maxZoom) {
    var parts = 2;
    var finished = false;

    function callback(complete) {
      --parts;

      if (finished) {
        return;
      }

      if (parts === 0 || !complete) {
        finished = true;

        if (completionCallback) {
          completionCallback(complete);
        }
      }
    }

    view.animate({
      center: location,
      duration: duration,
      easing: this.elastic
    }, callback);
    view.animate({
      zoom: Math.min(zoom, maxZoom),
      duration: duration
    }, callback);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ViewAnimationUtil);

/***/ }),

/***/ "o2dB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray__ = __webpack_require__("mF7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ids-location-type-chooser',
  props: {
    locationTypeList: {
      type: Array,
      required: true
    },
    locationType: {
      type: String,
      required: false,
      default: function _default() {
        return 'Aufnahmeort';
      }
    }
  },
  data: function data() {
    return {
      locationTypeSelection: this.locationType + '',
      locationTypeTexts: []
    };
  },
  created: function created() {
    var _context;

    // apply values from config
    var appConfig = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$appConfig;
    var idsConf = appConfig.ids;
    var configLocationTypeTexts = idsConf.locationTypeTexts; // apply texts (suffixes) from config to this instance

    this.locationTypeTexts = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context = []).call(_context, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default()(this.locationTypeTexts), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default()(configLocationTypeTexts));
  },
  methods: {
    /**
     * Returns a location type radio label suffix
     */
    getSuffix: function getSuffix(locType) {
      var _context2;

      var suffix = '';

      var locTypeTxt = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context2 = this.locationTypeTexts).call(_context2, function (ltt) {
        return ltt.locationType === locType;
      });

      if (locTypeTxt && locTypeTxt.suffix !== '') {
        suffix += ' (' + locTypeTxt.suffix + ')';
      }

      return suffix;
    }
  }
});

/***/ }),

/***/ "o458":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDetails)?_c('v-list-group',{staticClass:"text--primary",scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-action',[_c('v-checkbox',{attrs:{"color":"secondary","hide-details":"","input-value":_vm.layer.getVisible()},on:{"!click":function($event){$event.stopPropagation();return _vm.onItemClick()}}})],1),_vm._v(" "),_c('v-list-item-title',[_vm._v("\n      "+_vm._s(_vm.layer.get('name'))+"\n    ")])]},proxy:true}],null,false,600902376),model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._v(" "),(_vm.showOpacityControl)?_c('v-list-item',{staticClass:"overflow-visible"},[_c('wgu-layeropacitycontrol',{attrs:{"layer":_vm.layer}})],1):_vm._e(),_vm._v(" "),(_vm.showLegend)?_c('v-list-item',[(_vm.open)?_c('wgu-layerlegendimage',{attrs:{"layer":_vm.layer,"mapView":_vm.mapView}}):_vm._e()],1):_vm._e()],1):_c('v-list-item',{staticClass:"wgu-layerlist-item"},[_c('v-list-item-action',[_c('v-checkbox',{attrs:{"color":"secondary","hide-details":"","input-value":_vm.layer.getVisible()},on:{"!click":function($event){$event.stopPropagation();return _vm.onItemClick(_vm.layer)}}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n      "+_vm._s(_vm.layer.get('name'))+"\n    ")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "odA+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeTable_vue__ = __webpack_require__("PJIL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87961ff4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTable_vue__ = __webpack_require__("nU5K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87961ff4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87961ff4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p2R4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qETa":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af.js": "yU6n",
	"./ar.js": "l2Yc",
	"./ca.js": "5QRW",
	"./cs.js": "7EgZ",
	"./de.js": "FgG9",
	"./el.js": "nuzw",
	"./en.js": "kcwg",
	"./es.js": "LW8o",
	"./et.js": "Xoj/",
	"./fa.js": "Dhz9",
	"./fr.js": "r2zY",
	"./he.js": "qKfn",
	"./hr.js": "NY0B",
	"./hu.js": "RuEo",
	"./id.js": "kSeb",
	"./index.js": "YZlv",
	"./it.js": "UXUi",
	"./ja.js": "b2mU",
	"./ko.js": "mK+S",
	"./lt.js": "9STr",
	"./lv.js": "1Jmd",
	"./nl.js": "eCap",
	"./no.js": "iG/Y",
	"./pl.js": "0vAu",
	"./pt.js": "A86W",
	"./ro.js": "Eplm",
	"./ru.js": "MoUL",
	"./sl.js": "cXVd",
	"./sr-Cyrl.js": "/LzZ",
	"./sv.js": "SNeT",
	"./th.js": "P2U1",
	"./tr.js": "Yot5",
	"./uk.js": "MSHb",
	"./zh-Hans.js": "AlPo",
	"./zh-Hant.js": "rgAM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qETa";

/***/ }),

/***/ "qMls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsCorporaFilter_vue__ = __webpack_require__("/AG+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a3857d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsCorporaFilter_vue__ = __webpack_require__("c8A0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("p2R4")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36a3857d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsCorporaFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a3857d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsCorporaFilter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a3857d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsCorporaFilter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qUL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClickWin_vue__ = __webpack_require__("Nkpt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad13726_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__ = __webpack_require__("Og0H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("hlHd")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClickWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad13726_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad13726_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qbcg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PROVIDERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeocoderController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__ = __webpack_require__("0WSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator__ = __webpack_require__("I3KW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__providers_osm__ = __webpack_require__("ZKPR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__providers_photon__ = __webpack_require__("Bik2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__providers_opencage__ = __webpack_require__("f54h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ajax__ = __webpack_require__("9OlX");




// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.



 // Geocoder Provider types

var PROVIDERS = {
  'osm': __WEBPACK_IMPORTED_MODULE_4__providers_osm__["a" /* OpenStreetMap */],
  'photon': __WEBPACK_IMPORTED_MODULE_5__providers_photon__["a" /* Photon */],
  'opencage': __WEBPACK_IMPORTED_MODULE_6__providers_opencage__["a" /* OpenCage */]
};
/**
 * @class GeocoderController
 */

var GeocoderController = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {String} providerName name of Provider.
   * @param {Object} options config options for Provider
   * @param {Object} parent callback parent
   */
  function GeocoderController(providerName, options, parent) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck___default()(this, GeocoderController);

    this.options = options; // Must have Provider class defined for name

    if (!PROVIDERS.hasOwnProperty(providerName)) {
      console.warn("No class defined for Geocoder Provider: '".concat(providerName, "'"));
      return;
    } // Create Provider from name via Factory Method


    this.provider = new PROVIDERS[providerName]();
    this.parent = parent;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass___default()(GeocoderController, [{
    key: "query",
    value: function () {
      var _query = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator___default.a.mark(function _callee(q) {
        var parameters, ajax, response;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                parameters = this.provider.getParameters({
                  query: q,
                  key: this.options.key,
                  lang: this.options.lang,
                  countrycodes: this.options.countrycodes,
                  limit: this.options.limit
                });
                ajax = {
                  url: parameters.url,
                  data: parameters.params
                }; // Optional XHR with JSONP (Provider-specific)

                if (parameters.callbackName) {
                  ajax.jsonp = true;
                  ajax.callbackName = parameters.callbackName;
                }

                _context.prev = 3;
                _context.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_ajax__["a" /* json */])(ajax);

              case 6:
                response = _context.sent;
                return _context.abrupt("return", this.provider.handleResponse(response));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                return _context.abrupt("return", _context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 10]]);
      }));

      function query(_x) {
        return _query.apply(this, arguments);
      }

      return query;
    }()
  }]);

  return GeocoderController;
}();

/***/ }),

/***/ "qq5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogo_vue__ = __webpack_require__("P5f+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_119d8dba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__ = __webpack_require__("4uSC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("zrrf")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_119d8dba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_119d8dba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qqRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomToMaxExtentButton_vue__ = __webpack_require__("ypcs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41644861_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__ = __webpack_require__("J/cV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("imGD")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomToMaxExtentButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41644861_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41644861_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rdXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IdsCorpusLookup_js__ = __webpack_require__("9HAY");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ids-corpus-category',
  props: {
    corpusCategoryName: {
      type: String,
      required: true
    },
    corpusItems: {
      type: Array,
      required: true
    },
    selection: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dataSelection: this.selection,
      expandState: [0],
      // expand the content by default
      toggleAllIcon: 'mdi-checkbox-multiple-marked-outline',
      toggleAllTooltip: 'Alle Einträge aus dieser Kategorie selektieren'
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus_js__["a" /* WguEventBus */].$on('ids-locationtype-change', function () {
      // reset to initial corpus selection
      _this.dataSelection = _this.dataSelection; // this.dataSelection = [];
      // const initCorpusIds = IdsCorpusLookup.initialCorpusIds;
      // const initSelArr = IdsCorpusLookup.getSelectionObjectByArr(initCorpusIds);
      // this.dataSelection = initSelArr[this.corpusCategoryName];
    });
  },
  watch: {
    dataSelection: function dataSelection(newSelected) {
      // inform parent component
      this.$emit('ids-corpus-selection-change', this.corpusCategoryName, newSelected); // change icon and tooltip for toggling all selections

      var allSelected = this.allSelected();

      if (allSelected) {
        this.toggleAllIcon = 'mdi-checkbox-multiple-blank-outline';
        this.toggleAllTooltip = 'Alle Einträge aus dieser Kategorie deselektieren';
      } else {
        this.toggleAllIcon = 'mdi-checkbox-multiple-marked-outline';
        this.toggleAllTooltip = 'Alle Einträge aus dieser Kategorie selektieren';
      }
    }
  },
  methods: {
    corpusLabel: function corpusLabel(corpusId) {
      return __WEBPACK_IMPORTED_MODULE_2__IdsCorpusLookup_js__["a" /* default */].getCorpusLabel(corpusId);
    },
    corpusLink: function corpusLink(corpusId) {
      return __WEBPACK_IMPORTED_MODULE_2__IdsCorpusLookup_js__["a" /* default */].getCorpusLink(corpusId);
    },

    /**
     * Selects all corpora if not all selected or deselects all corpora if all
     * corpora are currently selected.
     */
    toggleAllCorpora: function toggleAllCorpora() {
      var allSelected = this.allSelected();

      if (allSelected) {
        this.dataSelection = [];
      } else {
        this.dataSelection = __WEBPACK_IMPORTED_MODULE_2__IdsCorpusLookup_js__["a" /* default */].getAllSelected(this.corpusCategoryName);
      }
    },

    /**
     * Checks if all corpora in this category are selected or not.
     */
    allSelected: function allSelected() {
      var _context;

      // filter out empty or null values
      var selectionArr = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = this.dataSelection).call(_context, function (x) {
        return typeof x === 'string';
      });

      return selectionArr.length === this.corpusItems.length;
    }
  }
});

/***/ }),

/***/ "sx1O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_json_stringify__ = __webpack_require__("gPdZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ids-country-selector',
  props: {
    geoType: {
      type: String,
      required: true
    },
    headerText: {
      type: String,
      required: true
    },
    placeHolderText: {
      type: String,
      required: false
    },
    geoList: {
      type: Array,
      required: true
    },
    selection: {
      type: Object,
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      expandState: [0],
      // expand the content by default
      dataSelection: JSON.parse(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_json_stringify___default()(this.selection))
    };
  },
  methods: {
    onUserChange: function onUserChange(newSelected) {
      // inform parent component
      this.$emit('ids-geo-selection-change', this.geoType, newSelected);
    }
  }
});

/***/ }),

/***/ "tFIa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"wgu-app-toolbar onprimary--text",attrs:{"color":"primary","fixed":"","app":"","clipped-left":"","clipped-right":""}},[_vm._t("wgu-tb-start"),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('app.title')))]),_vm._v(" "),_vm._t("wgu-tb-after-title"),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("wgu-tb-before-auto-buttons"),_vm._v(" "),_vm._l((_vm.tbButtons),function(tbButton,index){return [_c(tbButton.type,_vm._b({key:index,tag:"component"},'component',tbButton,false))]}),_vm._v(" "),_vm._t("wgu-tb-after-auto-buttons"),_vm._v(" "),(_vm.menuButtons.length)?_c('v-menu',{attrs:{"offset-y":"","nudge-bottom":"15"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","color":"onprimary","title":_vm.$t('wgu-toolbar-menu.title')}},on),[_c('v-icon',{attrs:{"medium":""}},[_vm._v("menu")])],1)]}}],null,false,1671285656)},[_vm._v(" "),_c('v-list',{attrs:{"color":"primary"}},[_vm._l((_vm.menuButtons),function(tbButton,index){return [_c('v-list-item',{key:index},[_c(tbButton.type,_vm._b({key:index,tag:"component"},'component',tbButton,false))],1)]})],2)],1):_vm._e(),_vm._v(" "),_vm._t("wgu-tb-end")],2)}
var staticRenderFns = []


/***/ }),

/***/ "tdkq":
/***/ (function(module, exports) {

module.exports = {"app":{"title":"Vue.js / OpenLayers WebGIS","browserTitle":"Wegue Demo Anwendung","footerTextLeft":"Powered by <a href='https://meggsimum.de/wegue/' target='_blank'>Wegue WebGIS</a>","footerTextRight":"meggsimum","logo":"App Logo"},"mapLayers":{"wgu-geolocator-layer":{"name":"Ihr Standort"},"wgu-measure-layer":{"name":"Messergebnisse"},"wgu-drag-drop-layer":{"name":"Drag/Drop Daten"}},"wgu-toolbar-menu":{"title":"Menüleiste ausklappen"},"wgu-attributetable":{"title":"Attribut Tabelle","selectorLabel":"Layer auswählen","loadingText":"Lade... Bitte ein Gebiet auswählen, so dass der Layer sichtbar ist"},"wgu-bglayerswitcher":{"title":"Hintergrundkarte auswählen"},"wgu-overviewmap":{"title":"Übersichtskarte anzeigen"},"wgu-geocoder":{"title":"Adress-Suche","placeHolder":"Adresse suchen"},"wgu-geolocator":{"title":"Mein Standort"},"wgu-helpwin":{"title":"Hilfe","textTitle":"Über Wegue","htmlContent":"<b>WebGIS basierend auf OpenLayers und Vue.js</b></br>Vorlagen und wiederverwertbare Komponenten für Web-Kartenanwendungen mit OpenLayers und Vue.js","infoLinkUrl":"http://wegue.org/","infoLinkText":"Mehr Informationen"},"wgu-infoclick":{"title":"Standortinformation","mapClick":"Auf die Karte klicken, um Standortinformationen anzuzeigen.","mediaClick":"Ein Feature auf der Karte auswählen, um zugehörige Medieninformationen anzuzeigen.","mediaInfoLinkText":null},"wgu-layerlist":{"title":"Layer"},"wgu-maprecorder":{"title":"Videoaufnahme","options":"Optionen","videoFormat":"Videoformat","frameRate":"Bildrate (Bilder/s)","bitRate":"Bitrate (MBits/s)","fileName":"Dateiname","start":"Start","stop":"Stop","error":"Starten der Aufnahme fehlgeschlagen."},"wgu-zoomtomaxextent":{"title":"Kartenausschnitt zurücksetzen"},"wgu-measuretool":{"title":"Messen","distance":"Entfernung","length":"Länge","area":"Fläche","lengthKm":"{0} km","lengthMeter":"{0} m","areaSquareKm":"{0} km²","areaSquareMeter":"{0} m²"},"wgu-localeswitcher":{"title":"Spracheinstellungen"},"wgu-themeswitcher":{"title":"Dunkler Modus"}}

/***/ }),

/***/ "ty8j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u4kD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__ = __webpack_require__("ZkkH");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-sidebar',
  props: {
    width: {
      type: Number,
      required: false,
      default: 400
    },
    visible: {
      type: Boolean,
      required: false,
      default: true
    },
    autoScroll: {
      type: Boolean,
      required: false,
      default: true
    },
    scrollDuration: {
      type: Number,
      required: false,
      default: 500
    }
  },
  data: function data() {
    return {
      sidebarOpen: this.visible
    };
  },

  /**
   * Initialize the sidebar.
   */
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$on('sidebar-scroll', function (comp) {
      _this.scrollTo(comp);
    });
    __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$on('sidebar-toggle', function (open) {
      // toggle or force a visibility of the sidebar
      if (typeof open === 'boolean') {
        _this.sidebarOpen = open;
      } else {
        _this.sidebarOpen = !_this.sidebarOpen;
      }
    });
  },
  methods: {
    /**
     * Scroll to a module, if the 'autoScroll' option is enabled.
     * @param {string | HTMLElement | Vue} comp The component to scroll to.
     */
    scrollTo: function scrollTo(comp) {
      if (this.autoScroll) {
        this.$vuetify.goTo(comp, {
          container: '.wgu-app-sidebar > .v-navigation-drawer__content',
          duration: this.scrollDuration
        });
      }
    }
  }
});

/***/ }),

/***/ "uRfN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('div',{ref:"overlayContainer"},[_vm._t("default",null,null,_vm.contentData)],2)])}
var staticRenderFns = []


/***/ }),

/***/ "uk3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsLocationTypeChooser_vue__ = __webpack_require__("o2dB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f5436f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsLocationTypeChooser_vue__ = __webpack_require__("v6ZD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("yweT")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f5436f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdsLocationTypeChooser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f5436f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsLocationTypeChooser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f5436f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdsLocationTypeChooser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v4OI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-property-table',
  props: {
    properties: {
      type: Object
    }
  },
  computed: {
    /**
     * Display the table control only, if there are properties to show.
     */
    show: function show() {
      return this.properties && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(this.properties).length;
    }
  }
});

/***/ }),

/***/ "v6ZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ids-location-type-chooser"},[_c('v-radio-group',{staticClass:"mt-0",attrs:{"hide-details":""},on:{"change":function (newVal) { _vm.$emit('ids-location-type-change', newVal) }},model:{value:(_vm.locationTypeSelection),callback:function ($$v) {_vm.locationTypeSelection=$$v},expression:"locationTypeSelection"}},_vm._l((_vm.locationTypeList),function(ltItem){return _c('v-radio',{key:ltItem.label,staticClass:"ids-location-radio-item",attrs:{"value":ltItem.v_ortstyp,"color":"primary"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"ids-location-option-text"},[_vm._v("\n            "+_vm._s(ltItem.v_ortstyp)+" "),_c('small',{staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.getSuffix(ltItem.v_ortstyp)))])])]},proxy:true}],null,true)})}),1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "v9hS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__("xtLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_slicedToArray__ = __webpack_require__("EmY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice__ = __webpack_require__("J849");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_concat__);






/**
 * URL related util methods
 */
var UrlUtil = {
  /**
   * Parses query string like a=b&c=d&e=f etc of the given search part (querySearch) of an URL
   * as JS object (key-value). Uses ES6 coding/parsing as in:
   * https://www.arungudelli.com/tutorial/javascript/get-query-string-parameter-values-from-url-using-javascript/
   *
   * @param  {String} query Search part (queryString) of an URL
   * @return {Object}             Key-value pairs of the URL parameters
   */
  parseQueryString: function parseQueryString(query) {
    return (/^[?#]/.test(query) ? __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice___default()(query).call(query, 1) : query).split('&').reduce(function (params, param) {
      var _param$split = param.split('='),
          _param$split2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_slicedToArray___default()(_param$split, 2),
          key = _param$split2[0],
          value = _param$split2[1];

      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {});
  },

  /**
   * Returns the query params of the current 'location' from 'hash' or 'search'.
   *
   * @param  {String} locationType use query or hash part of URL
   * @return {Object}             Key-value pairs of the URL parameters
   */
  getParams: function getParams(locationType) {
    var querySearch = document.location[locationType].substring(1);

    if (!querySearch || querySearch === '') {
      return {};
    }

    return this.parseQueryString(querySearch);
  },

  /**
   * Returns all query params of the given search part (querySearch) of an URL
   * as JS object (key-value).
   * If querySearch is not provided it is derived from the current location.
   *
   * @param  {String} querySearch Search part (querySearch) of an URL
   * @return {Object} Key-value pairs of the URL parameters, may be empty {}.
   */
  getQueryParams: function getQueryParams(querySearch) {
    if (!querySearch) {
      querySearch = document.location.search.substring(1);
    }

    if (!querySearch || querySearch === '') {
      return {};
    }

    return this.parseQueryString(querySearch);
  },

  /**
   * Returns all query params of the given hash part (hash) of an URL
   * as JS object (key-value).
   * If hash is not provided it is derived from the current location.
   *
   * @param  {String} hash Search part (hash) of an URL
   * @return {Object} Key-value pairs of the URL parameters
   */
  getHashParams: function getHashParams(hash) {
    if (!hash) {
      hash = document.location.hash.substring(1);
    }

    return this.parseQueryString(hash);
  },

  /**
   * Returns a dedicated URL parameter if existing.
   * If querySearch is not provided it is derived from the current location.
   *
   * @param  {String} param       The URL param name
   * @param  {String} querySearch Search part (querySearch) of an URL
   * @return {String}             Value of the given URL param
   */
  getQueryParam: function getQueryParam(param, querySearch) {
    var params = this.getQueryParams(querySearch);
    var value;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys___default()(params).forEach(function (key) {
      if (key === param) {
        value = params[key];
      }
    });

    return value;
  },

  /**
   * Returns a query string from an object of key/value pairs.
   *
   * @param  {String} obj object with key/values to encode.
   * @return {String} the encoded query string
   */
  toQueryString: function toQueryString(obj) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys___default()(obj).reduce(function (a, k) {
      var _context;

      a.push(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(obj[k]) === 'object' ? _this.toQueryString(obj[k]) : __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context = "".concat(encodeURIComponent(k), "=")).call(_context, encodeURIComponent(obj[k])));
      return a;
    }, []).join('&');
  }
};
/* harmony default export */ __webpack_exports__["a"] = (UrlUtil);

/***/ }),

/***/ "vMuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListItem_vue__ = __webpack_require__("f4Re");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08a9440_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListItem_vue__ = __webpack_require__("o458");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08a9440_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08a9440_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vUPf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-attributetable-win",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon},on:{"visibility-change":_vm.show},scopedSlots:_vm._u([{key:"wgu-win-toolbar",fn:function(){return [_c('v-select',{staticClass:"wgu-vector-layer-select wgu-solo-field",attrs:{"color":"accent","item-color":"secondary","dark":_vm.isPrimaryDark,"filled":"","outlined":"","items":_vm.displayedLayers,"item-text":function (item) { return item.get('name'); },"menu-props":{
          bottom: true,
          'offset-y': true,
        },"dense":"","return-object":"","hide-details":"","label":_vm.$t('wgu-attributetable.selectorLabel')},model:{value:(_vm.selLayer),callback:function ($$v) {_vm.selLayer=$$v},expression:"selLayer"}})]},proxy:true}])},'wgu-module-card',_vm.$attrs,false),[_vm._v(" "),(_vm.selLayer)?_c('wgu-attributetable',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],attrs:{"layerId":_vm.selLayer.get('lid'),"syncTableMapSelection":_vm.syncTableMapSelection}}):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "w/12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureTypeChooser_vue__ = __webpack_require__("TooU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb52a682_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__ = __webpack_require__("C8Cu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("8SDf")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureTypeChooser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb52a682_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb52a682_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wClq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var StyleUtil = {
  /**
   * Appends a style to another style.
   *
   * @param {ol.style.Style} originalStyle A style, an array of styles or a style function.
   * @param {ol.style.Style} additionalStyle A single style.
   *
   * @returns {ol.style.Style}
   */
  appendStyle: function appendStyle(originalStyle, additionalStyle) {
    return function (feature, resolution) {
      if (typeof originalStyle === 'function') {
        var layerStyleFunction = originalStyle; // check what kind of result we can expect

        var layerStyle = layerStyleFunction(feature, resolution);

        if (Array.isArray(layerStyle)) {
          // case result is an style array
          var resultArray = [additionalStyle]; // add the array elements to the result Array

          layerStyle.forEach(function (item) {
            return resultArray.push(item);
          });
          return resultArray;
        } else {
          // classic case that result is a simple style
          return [additionalStyle, layerStyleFunction(feature, resolution)];
        }
      } else {
        return [additionalStyle, originalStyle];
      }
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (StyleUtil);

/***/ }),

/***/ "wHUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.previewURL,"width":_vm.width,"height":_vm.height},on:{"load":function($event){_vm.imgLoaded=true},"error":function($event){_vm.imgLoaded=false}}},[(!_vm.previewURL || !_vm.imgLoaded)?_c('v-layout',{attrs:{"fill-height":"","align-center":"","justify-center":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v(_vm._s(_vm.previewIcon))])],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "wO5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_interaction_Select__ = __webpack_require__("gsgi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__factory_OlStyle_js__ = __webpack_require__("fT5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Style_js__ = __webpack_require__("wClq");





var MapInteractionUtil = {
  /**
   * Create a selectInteraction for a layer
   *
   * @param {ol.layer.Layer} layer The layer to create the interaction for
   * @param {Object} [selectStyleConf] The configuration for the selection style
   * @param {Boolean} [doAppendSelectStyle] If the selection style should be appended to the original style.
   *
   * @returns {ol.interaction.Select} The select interaction
   */
  createSelectInteraction: function createSelectInteraction(layer, selectStyleConf, doAppendSelectStyle) {
    var selectClick;
    var selectStyle;

    if (selectStyleConf) {
      // layer specific select style
      selectStyle = __WEBPACK_IMPORTED_MODULE_3__factory_OlStyle_js__["a" /* OlStyleFactory */].getInstance(selectStyleConf);

      if (doAppendSelectStyle) {
        // append selectStyle to original style of layer
        selectStyle = __WEBPACK_IMPORTED_MODULE_4__Style_js__["a" /* default */].appendStyle(layer.getStyle(), selectStyle);
      }

      selectClick = new __WEBPACK_IMPORTED_MODULE_1_ol_interaction_Select__["a" /* default */]({
        layers: [layer],
        style: selectStyle
      });
    } else {
      selectClick = new __WEBPACK_IMPORTED_MODULE_1_ol_interaction_Select__["a" /* default */]({
        layers: [layer]
      });
    } // necessary for identifying referenced layer


    selectClick.set('lid', layer.get('lid')); // forward an event if feature selection changes

    selectClick.on('select', function (evt) {
      __WEBPACK_IMPORTED_MODULE_2__WguEventBus_js__["a" /* WguEventBus */].$emit('map-selectionchange', layer.get('lid'), evt.selected, evt.deselected);
    });
    return selectClick;
  },

  /**
   * Find the selectIntercation of a layer
   *
   * @param {ol.Map} olMap The OL map to search in
   * @param {String} layerId The layer id, typically 'lid' the property
   * @returns {ol.interaction.Select} The respective selectInteraction
   */
  getSelectInteraction: function getSelectInteraction(olMap, layerId) {
    if (!olMap || !olMap.getInteractions()) {
      return;
    }

    var interactions = olMap.getInteractions().getArray();

    if (!interactions) {
      return;
    }

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find___default()(interactions).call(interactions, function (interaction) {
      return interaction instanceof __WEBPACK_IMPORTED_MODULE_1_ol_interaction_Select__["a" /* default */] && interaction.get('lid') === layerId;
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (MapInteractionUtil);

/***/ }),

/***/ "xdWY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y+0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguApp_vue__ = __webpack_require__("GgOu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6394c4ab_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__ = __webpack_require__("DCNi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("PHLi")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6394c4ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6394c4ab_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6394c4ab_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y83G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yJe9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLoadingMask_vue__ = __webpack_require__("Kp7H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2179bc72_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLoadingMask_vue__ = __webpack_require__("RYap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLoadingMask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2179bc72_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLoadingMask_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2179bc72_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLoadingMask_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yekt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_source_Tile__ = __webpack_require__("Qa85");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_source_TileWMS__ = __webpack_require__("DwLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_proj__ = __webpack_require__("yGLh");
/**
 * Create preview images for layers with an underlying Tile or TileWMS source.
 *
 * This is a modified version of LayerPreview released by Jean-Marc VIGLINO
 * under the CeCILL-B license (French BSD license).
 * For the original source of ol-ext see https://github.com/Viglino/ol-ext.
 */




var TileSourcePreview = {
  /**
   * Return the tile image URL of the source.
   * @param {ol.TileSource} source The source to produce the preview for.
   * @param {ol.Coordinate} coords The center of the preview.
   * @param {number} resolution Resolution of the preview.
   * @param {ol.Projection} projection Projection of the coordinates.
   * @returns {String} The preview url.
   */
  getUrl: function getUrl(source, coords, resolution, projection) {
    var coord = source.getTileGrid().getTileCoordForCoordAndResolution(coords, resolution);
    var fn = source.getTileUrlFunction();
    return fn.call(source, coord, projection);
  }
};
var TileWMSSourcePreview = {
  /**
   * Return the tile image URL of the source.
   * @param {ol.TileWMSSource} source The source to produce the preview for.
   * @param {ol.Coordinate} coords The center of the preview.
   * @param {number} resolution Resolution of the preview.
   * @param {ol.Projection} projection Projection of the coordinates.
   * @returns {String} The preview url.
   */
  getUrl: function getUrl(source, coords, resolution, projection) {
    var fn = source.getTileUrlFunction();

    if (fn) {
      var tileGrid = source.getTileGrid() || source.getTileGridForProjection(projection);
      var coord = tileGrid.getTileCoordForCoordAndResolution(coords, resolution);
      return fn.call(source, coord, 1, projection);
    } // Use getfeature info instead


    var url = source.getGetFeatureInfoUrl ? source.getGetFeatureInfoUrl(coords, resolution, projection, {}) : source.getFeatureInfoUrl(coords, resolution, projection, {});
    url = url.replace(/getfeatureinfo/i, 'GetMap');
    return url;
  }
};
var LayerPreview = {
  /**
   * Return a preview URL for the layer.
   * @param {ol.Layer} layer The layer to produce the preview for.
   * @param {ol.Coordinate} coords The center of the preview in view projection.
   * @param {number} resolution Resolution of the preview.
   * @param {ol.Projection} projection The view projection.
   * @returns {String} Preview url or undefined if no preview can be produced.
   */
  getUrl: function getUrl(layer, coords, resolution, projection) {
    var source = layer.getSource(); // If we cannot obtain a source, no preview can be produced.

    if (!source) {
      return undefined;
    }

    try {
      // Clamp the resolution within the resolution supported by the layer.
      resolution = Math.max(Math.min(resolution, layer.getMaxResolution()), layer.getMinResolution()); // Make sure to request an extent within the layers extent.

      var e = layer.getExtent();

      if (e && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_extent__["w" /* containsCoordinate */])(e, coords)) {
        coords = [(e[0] + e[2]) / 2, (e[1] + e[3]) / 2];
      } // Transform the projection of the coords if necessary.


      var sourceProj = source.getProjection();

      if (sourceProj && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj__["c" /* equivalent */])(projection, sourceProj)) {
        coords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj__["p" /* transform */])(coords, projection, sourceProj);
        projection = sourceProj;
      } // Obtain the image URL from the source.


      if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source_TileWMS__["a" /* default */]) {
        return TileWMSSourcePreview.getUrl(source, coords, resolution, projection);
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_0_ol_source_Tile__["b" /* default */]) {
        return TileSourcePreview.getUrl(source, coords, resolution, projection);
      }
    } catch (e) {
      console.error('failed to create preview: ' + e);
    }

    return undefined;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LayerPreview);

/***/ }),

/***/ "ygOZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BgLayerList__ = __webpack_require__("YPa9");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-bglayerswitcher',
  components: {
    'wgu-bglayerlist': __WEBPACK_IMPORTED_MODULE_4__BgLayerList__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Mapable__["a" /* Mapable */]],
  props: {
    icon: {
      type: String,
      required: false,
      default: 'map'
    },
    imageWidth: {
      type: Number,
      required: false,
      default: 152
    },
    imageHeight: {
      type: Number,
      required: false,
      default: 114
    }
  },
  data: function data() {
    return {
      open: false,
      layers: []
    };
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound: function onMapBound() {
      this.layers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray();
    }
  },
  computed: {
    /**
     * Reactive property to return true, when more than one OpenLayers layer is available,
     * which is marked as 'isBaseLayer'.
     */
    show: function show() {
      var _context;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = this.layers).call(_context, function (layer) {
        return layer.get('isBaseLayer');
      }).length > 1;
    }
  }
});

/***/ }),

/***/ "ypcs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ViewAnimation__ = __webpack_require__("ntKu");

//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-zoomtomaxextent-btn',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__["a" /* Mapable */]],
  props: {
    icon: {
      type: String,
      required: false,
      default: 'zoom_out_map'
    }
  },
  methods: {
    onClick: function onClick() {
      // derive correct initial zoom and center
      var initialCenter = this.$appConfig.mapCenter;
      var initalZoom = this.$appConfig.mapZoom;
      __WEBPACK_IMPORTED_MODULE_2__util_ViewAnimation__["a" /* default */].to(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView(), initialCenter, null, {
        zoom: initalZoom,
        maxZoom: initalZoom
      });
    }
  }
});

/***/ }),

/***/ "yweT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zOpH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"onprimary--text",attrs:{"color":"primary","app":"","height":_vm.$vuetify.breakpoint.xs ? 50 : 64}},[_c('span',{staticClass:"wgu-footer-left",domProps:{"innerHTML":_vm._s(_vm.footerTextLeft)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-row',{staticClass:"footer-middle-row"},[_c('v-col',{staticClass:"ids-middle-footer-col",attrs:{"align":"center"}},[_c('a',{attrs:{"href":"https://www.ids-mannheim.de/","target":"_blank"}},[_c('img',{attrs:{"src":"static/img/logo-ids-small-1.png","height":"50","alt":"IDS Logo"}})])]),_vm._v(" "),_c('v-col',{staticClass:"ids-middle-footer-col",attrs:{"align":"center"}},[_c('a',{attrs:{"href":"https://www.konsortswd.de","target":"_blank"}},[_c('img',{staticStyle:{"padding-bottom":"6px"},attrs:{"src":"static/img/Logo-KonsortSWD_kurz_weisse-Schrift-72dpi.png","height":"40","alt":"KonsortSWD Logo"}})])]),_vm._v(" "),_c('v-col',{staticClass:"ids-middle-footer-col",attrs:{"align":"center"}},[_c('a',{attrs:{"href":"https://www.konsortswd.de/konsortswd/das-konsortium/services/qualidatanet/","target":"_blank"}},[_c('img',{attrs:{"src":"static/img/QualidataNet_Logo_Negativ.png","height":"50","alt":"QualidataNet Logo"}})])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"wgu-footer-right"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.footerTextRight)}}),_vm._v(" "),(_vm.showCopyrightYear)?_c('span',[_vm._v("© IDS "+_vm._s(new Date().getFullYear()))]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),

/***/ "znPh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OverviewMapPanel__ = __webpack_require__("i6yw");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-overviewmap',
  components: {
    'wgu-overviewmap-panel': __WEBPACK_IMPORTED_MODULE_1__OverviewMapPanel__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'zoom_out_map'
    },
    visible: {
      type: Boolean,
      required: false,
      default: true
    },
    rotateWithView: {
      type: Boolean,
      required: false,
      default: true
    },
    width: {
      type: Number,
      required: false,
      default: 164
    },
    height: {
      type: Number,
      required: false,
      default: 178
    }
  },
  data: function data() {
    return {
      open: this.visible
    };
  }
});

/***/ }),

/***/ "zrrf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5cc98f51940253a5bfc4.js